/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AdvertiserId: any;
  Cursor: any;
  CustomerAccountId: any;
  EmailAddress: any;
  HttpsUrl: any;
  ISODate: any;
  PartnerAccountId: any;
};


/**
 * Specifies which audience is allowed to view this entry.
 * Currently only supports customer ID's, but could be expanded to
 * support groups or other identifiers in the future.
 */
export type AccessControl = {
  __typename: 'AccessControl';
  customers?: Maybe<Array<Scalars['CustomerAccountId']>>;
};

export type Accreditation = {
  __typename: 'Accreditation';
  statusInfo: PartnerAccreditationStatusInfo;
  type: PartnerAccreditation;
};

export enum AccreditationStatus {
  Awarded = 'AWARDED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

/** Input for Mutation.addPartnerToGroup */
export type AddPartnerToGroupInput = {
  groupId: Scalars['PartnerAccountId'];
  memberId: Scalars['PartnerAccountId'];
};

export type AddPartnerToGroupResponse = ClientError | PartnerGroup;

export type Address = {
  __typename: 'Address';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  districtOrCounty?: Maybe<Scalars['String']>;
  lines?: Maybe<Array<Scalars['String']>>;
  postalCode?: Maybe<Scalars['String']>;
  stateOrRegion?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  districtOrCounty?: Maybe<Scalars['String']>;
  lines?: Maybe<Array<Scalars['String']>>;
  postalCode?: Maybe<Scalars['String']>;
  stateOrRegion?: Maybe<Scalars['String']>;
};

export type Advertiser = {
  __typename: 'Advertiser';
  countryCode?: Maybe<CountryCode>;
  id: Scalars['AdvertiserId'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum AdvertiserAccessLevel {
  DspMaRole = 'DSP_MA_ROLE',
  EntityNoConsoleAccess = 'ENTITY_NO_CONSOLE_ACCESS',
  EntityOwner = 'ENTITY_OWNER',
  EntityUser = 'ENTITY_USER',
  EntityViewer = 'ENTITY_VIEWER',
  SellerUser = 'SELLER_USER',
  Unknown = 'UNKNOWN',
  ViewPerformanceDashboard = 'VIEW_PERFORMANCE_DASHBOARD'
}

export enum AdvertiserAutomappingStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum AdvertiserBusinessType {
  DontSellOnAmazon = 'DONT_SELL_ON_AMAZON',
  SellOnAmazon = 'SELL_ON_AMAZON'
}

export type AdvertiserEntityInput = {
  advertiserEntityType: AdvertiserEntityType;
  advertiserId: Scalars['AdvertiserId'];
};

export enum AdvertiserEntityType {
  Brand = 'BRAND',
  DspAdvertisingAccount = 'DSP_ADVERTISING_ACCOUNT',
  KdpAuthor = 'KDP_AUTHOR',
  SellerCentralEntity = 'SELLER_CENTRAL_ENTITY'
}


export enum AdvertisingOffering {
  AdTech = 'AD_TECH',
  ManagedAdServices = 'MANAGED_AD_SERVICES',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  NonAdTechOrServices = 'NON_AD_TECH_OR_SERVICES'
}

export enum AmazonMarketplaces {
  Ae = 'AE',
  Au = 'AU',
  Be = 'BE',
  Br = 'BR',
  Ca = 'CA',
  Cn = 'CN',
  De = 'DE',
  Eg = 'EG',
  Es = 'ES',
  Fr = 'FR',
  Gb = 'GB',
  Ie = 'IE',
  In = 'IN',
  It = 'IT',
  Jp = 'JP',
  Mx = 'MX',
  Nl = 'NL',
  Pl = 'PL',
  Sa = 'SA',
  Se = 'SE',
  Sg = 'SG',
  Tr = 'TR',
  Us = 'US',
  Za = 'ZA'
}

/** Type dedicated to API registration attributes */
export type ApiRegistration = {
  __typename: 'ApiRegistration';
  /** Last date of the API form submission */
  lastSubmissionDate?: Maybe<Scalars['ISODate']>;
};

export type ApplicationDetails = {
  __typename: 'ApplicationDetails';
  /** Field indicating advertiser automapping status */
  advertiserAutomappingStatus: AdvertiserAutomappingStatus;
  /** The ApplicationID of the application as provided by StegoService. Will be of the form "amzn1.application-oa2-client.<28-digit code>" */
  applicationId: Scalars['ID'];
  /** Unique identifier representing the link created between partner and an application. */
  id: Scalars['ID'];
  /** A boolean flag indicating the status of link between partner and application. */
  isLinked: Scalars['Boolean'];
  /** Field indicating link status */
  linkStatus?: Maybe<LinkStatus>;
  /** The partner account to which the application is being linked/unlinked to. */
  partner: Partner;
};

export enum AssetType {
  AapnPartnerLogo = 'AAPN_PARTNER_LOGO',
  AapnPartnerLogo_400 = 'AAPN_PARTNER_LOGO_400',
  AapnPartnerLogoOriginal = 'AAPN_PARTNER_LOGO_ORIGINAL'
}

/** Assigned Partner Badges */
export type AssignedPartnerBadges = {
  __typename: 'AssignedPartnerBadges';
  accreditation?: Maybe<Array<Accreditation>>;
  directoryListing?: Maybe<DirectoryListingBadges>;
};

export type Audit = {
  __typename: 'Audit';
  createdDate: Scalars['ISODate'];
  updatedBy: Scalars['String'];
  updatedDate: Scalars['ISODate'];
};

export type AuthPortalPrincipal = Principal & {
  __typename: 'AuthPortalPrincipal';
  partnerUserRole?: Maybe<PartnerUserRole>;
  rights?: Maybe<Array<Right>>;
  userEmail?: Maybe<Scalars['EmailAddress']>;
  userName?: Maybe<Scalars['String']>;
};

/** Award types from BillboardCharts */
export enum AwardType {
  Accreditation = 'ACCREDITATION',
  Awards = 'AWARDS',
  Industry = 'INDUSTRY',
  Specialization = 'SPECIALIZATION',
  Status = 'STATUS'
}

export enum AwardsLocale {
  ArAe = 'AR_AE',
  CsCz = 'CS_CZ',
  DeDe = 'DE_DE',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnIn = 'EN_IN',
  EnSg = 'EN_SG',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  EsMx = 'ES_MX',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  HeIl = 'HE_IL',
  HiIn = 'HI_IN',
  ItIt = 'IT_IT',
  JaJp = 'JA_JP',
  KoKr = 'KO_KR',
  NlNl = 'NL_NL',
  PlPl = 'PL_PL',
  PtBr = 'PT_BR',
  SvSe = 'SV_SE',
  ThTh = 'TH_TH',
  TrTr = 'TR_TR',
  ViVn = 'VI_VN',
  ZhCn = 'ZH_CN',
  ZhTw = 'ZH_TW'
}

export enum BadgeType {
  VerifiedByAmazon = 'VERIFIED_BY_AMAZON'
}

export type Budget = {
  __typename: 'Budget';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<CurrencyCode>;
};

export type BudgetInput = {
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<CurrencyCode>;
};

export type BudgetRequirement = {
  __typename: 'BudgetRequirement';
  currency?: Maybe<CurrencyCode>;
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
};

export type BudgetRequirementInput = {
  currency?: Maybe<CurrencyCode>;
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
};

/** Input shape for query bulkAccountCreationReportDownloadURL */
export type BulkAccountCreationReportDownloadUrlRequest = {
  reportId: Scalars['String'];
};

export type BulkAccountCreationReportDownloadUrlResponse = ClientError | ReportFileLocation;

export enum BulkAccountCreationRequestFailedReason {
  RegistrationFailed = 'REGISTRATION_FAILED',
  ServerFailed = 'SERVER_FAILED',
  UserError = 'USER_ERROR',
  UserErrorAccountLimit = 'USER_ERROR_ACCOUNT_LIMIT'
}

export enum BulkAccountCreationRequestStatus {
  AccountsCreatedWithIncompleteSetup = 'ACCOUNTS_CREATED_WITH_INCOMPLETE_SETUP',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  FailedPartially = 'FAILED_PARTIALLY',
  Pending = 'PENDING'
}

export type BulkAccountCreationRequestUploadUrlResponse = ClientError | RequestFileLocation;

/** Part of output shape for query bulkAccountCreationUploadHistory in case of no client errors */
export type BulkAccountCreationSubmission = {
  __typename: 'BulkAccountCreationSubmission';
  customerEmail: Scalars['String'];
  failedReason?: Maybe<BulkAccountCreationRequestFailedReason>;
  fileName: Scalars['String'];
  numberOfCreatedAccounts?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['String']>;
  status: BulkAccountCreationRequestStatus;
  submittedAt: Scalars['ISODate'];
  totalRequestedAccounts?: Maybe<Scalars['Int']>;
};

export type BulkAccountCreationTemplateDownloadUrlResponse = ClientError | TemplateFileLocation;

/** Output shape for query bulkAccountCreationUploadHistory in case of no client errors */
export type BulkAccountCreationUploadHistoryOutput = {
  __typename: 'BulkAccountCreationUploadHistoryOutput';
  uploadRequests: Array<BulkAccountCreationSubmission>;
};

/** Input shape for query bulkAccountCreationUploadHistory */
export type BulkAccountCreationUploadHistoryRequest = {
  requestId: Scalars['String'];
};

export type BulkAccountCreationUploadHistoryResponse = BulkAccountCreationUploadHistoryOutput | ClientError;

/** Identifies a specific asset in Content Asset Service (CAS). */
export type CasAsset = {
  __typename: 'CASAsset';
  /** Unique ID of the asset */
  assetId: Scalars['ID'];
  /** Type of the asset */
  assetType: AssetType;
  /** Optional version of the asset. A null value indicates the latest version of the asset. */
  version?: Maybe<Scalars['Int']>;
};

export type CmsAsset = {
  __typename: 'CMSAsset';
  /** An expiring, signed URL for accessing this asset, generated server-side. */
  link?: Maybe<Scalars['HttpsUrl']>;
  /** The MIME type of the asset. */
  mimeType?: Maybe<Scalars['String']>;
  /** Location of the asset in the official storage mechanism (S3/CAS/etc) */
  storageLocation: S3StorageLocation;
};

/** Describes the specifics of an individual entry (event or resource). */
export type CmsDetails = {
  __typename: 'CMSDetails';
  /**
   * CR Note:
   * Details are keyed off of language, allowing for drill down into exact language(s)
   * GraphQL doesn't directly support "dynamic keys", although Arguments may be
   * used, however they appear to limit the number of languages we can return
   * in one query down to 1. Can be countered by using aliases.
   * Languages are keyed according to IETF language tags, although use
   * an underscore (_) separator to be compatible with GraphQL names.
   * IETF standard uses a dash (-) normally.
   * https://spec.graphql.org/June2018/#sec-Names
   */
  ar_AE?: Maybe<CmsDetailsLocalized>;
  cs_CZ?: Maybe<CmsDetailsLocalized>;
  de_DE?: Maybe<CmsDetailsLocalized>;
  en_AE?: Maybe<CmsDetailsLocalized>;
  en_AU?: Maybe<CmsDetailsLocalized>;
  en_CA?: Maybe<CmsDetailsLocalized>;
  en_GB?: Maybe<CmsDetailsLocalized>;
  en_IN?: Maybe<CmsDetailsLocalized>;
  en_SG?: Maybe<CmsDetailsLocalized>;
  en_US?: Maybe<CmsDetailsLocalized>;
  es_CO?: Maybe<CmsDetailsLocalized>;
  es_ES?: Maybe<CmsDetailsLocalized>;
  es_MX?: Maybe<CmsDetailsLocalized>;
  es_US?: Maybe<CmsDetailsLocalized>;
  fr_CA?: Maybe<CmsDetailsLocalized>;
  fr_FR?: Maybe<CmsDetailsLocalized>;
  he_IL?: Maybe<CmsDetailsLocalized>;
  hi_IN?: Maybe<CmsDetailsLocalized>;
  it_IT?: Maybe<CmsDetailsLocalized>;
  ja_JP?: Maybe<CmsDetailsLocalized>;
  kn_IN?: Maybe<CmsDetailsLocalized>;
  ko_KR?: Maybe<CmsDetailsLocalized>;
  nl_NL?: Maybe<CmsDetailsLocalized>;
  pl_PL?: Maybe<CmsDetailsLocalized>;
  pt_BR?: Maybe<CmsDetailsLocalized>;
  sv_SE?: Maybe<CmsDetailsLocalized>;
  ta_IN?: Maybe<CmsDetailsLocalized>;
  te_IN?: Maybe<CmsDetailsLocalized>;
  th_TH?: Maybe<CmsDetailsLocalized>;
  tr_TR?: Maybe<CmsDetailsLocalized>;
  vi_VN?: Maybe<CmsDetailsLocalized>;
  zh_CN?: Maybe<CmsDetailsLocalized>;
  zh_TW?: Maybe<CmsDetailsLocalized>;
};

/**
 * Generic - contains fields that encompass both event and resource,
 * but arent guaranteed to show up for both (description, link, assets)
 */
export type CmsDetailsLocalized = {
  __typename: 'CMSDetailsLocalized';
  /** An optional list of assets (files) that are assocaited with this CMS entry. */
  assets?: Maybe<Array<CmsAsset>>;
  description?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Contains all data to refer to an event or resource. */
export type CmsEntry = {
  /**
   * Optional access control to lock down an entry so that
   * it's only viewable by a select audience.
   * Access control is only expected to be enforced *if* this
   * attribute is present.
   */
  accessControl?: Maybe<AccessControl>;
  audit: Audit;
  /** Indicates whether this entry has been soft-deleted. */
  deleted: Scalars['Boolean'];
  details?: Maybe<CmsDetails>;
  /** Indicates the experience level category */
  experienceLevelCategories?: Maybe<Array<CmsExperienceLevelCategory>>;
  /** Indicates whether this entry is considered as "featured" entry. */
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Indicates the marketplace category */
  marketplaceCategories?: Maybe<Array<CmsMarketplaceCategory>>;
  /** Indicates the product category. */
  productCategories?: Maybe<Array<CmsProductCategory>>;
  /** Indicates the type of content this entry is associated with. */
  tags?: Maybe<Array<CmsEntryTag>>;
  /** Specifies the segments this entry belongs to, and should be targeted for. */
  targetSegments?: Maybe<Array<Scalars['String']>>;
};

export type CmsEntryConnection = Connection & {
  __typename: 'CMSEntryConnection';
  edges: Array<CmsEntryEdge>;
  pageInfo?: Maybe<PageInfo>;
  totalCMSEntryCount: Scalars['Int'];
};

export type CmsEntryEdge = Edge & {
  __typename: 'CMSEntryEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node: CmsEntry;
};

export enum CmsEntryTag {
  BestPractices = 'BEST_PRACTICES',
  Guide = 'GUIDE',
  InternationalExpansion = 'INTERNATIONAL_EXPANSION',
  Onboarding = 'ONBOARDING',
  OneSheet = 'ONE_SHEET',
  Recording = 'RECORDING',
  RetailReadiness = 'RETAIL_READINESS',
  Seasonal = 'SEASONAL',
  Video = 'VIDEO'
}

export type CmsEventEntry = CmsEntry & {
  __typename: 'CMSEventEntry';
  accessControl?: Maybe<AccessControl>;
  audit: Audit;
  deleted: Scalars['Boolean'];
  details?: Maybe<CmsDetails>;
  /**
   * Indicates what type of event this is expected to be.
   * In order to support partial updates, this field cannot be marked as required,
   * but instead the server will default to PHYSICAL if this field is not specified
   * or previously set.
   * Examples include physical locations (a meeting center) or virtual
   * locations like GoToWebinar.
   */
  eventType?: Maybe<CmsEventType>;
  experienceLevelCategories?: Maybe<Array<CmsExperienceLevelCategory>>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /**
   * Events with physical locations have a physcial address associated,
   * which juxtaposes with webinars, in which case this field should be null.
   */
  location?: Maybe<Address>;
  marketplaceCategories?: Maybe<Array<CmsMarketplaceCategory>>;
  /** If the entry is an event, identify when is this due to occur. */
  occurrence?: Maybe<Occurrence>;
  productCategories?: Maybe<Array<CmsProductCategory>>;
  /** Both physical and virtual events may utilize a registration website (EventBrite/GoToWebinar/etc). */
  registrationUrl?: Maybe<Scalars['HttpsUrl']>;
  tags?: Maybe<Array<CmsEntryTag>>;
  targetSegments?: Maybe<Array<Scalars['String']>>;
};

export enum CmsEventType {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL',
  Webinar = 'WEBINAR'
}

export enum CmsExperienceLevelCategory {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE'
}

export enum CmsMarketplaceCategory {
  Australia = 'AUSTRALIA',
  Belgium = 'BELGIUM',
  Brazil = 'BRAZIL',
  Canada = 'CANADA',
  Egypt = 'EGYPT',
  France = 'FRANCE',
  Germany = 'GERMANY',
  India = 'INDIA',
  Ireland = 'IRELAND',
  Italy = 'ITALY',
  Japan = 'JAPAN',
  Mexico = 'MEXICO',
  Netherlands = 'NETHERLANDS',
  Poland = 'POLAND',
  SaudiArabia = 'SAUDI_ARABIA',
  Singapore = 'SINGAPORE',
  SouthAfrica = 'SOUTH_AFRICA',
  Spain = 'SPAIN',
  Sweden = 'SWEDEN',
  Turkey = 'TURKEY',
  UnitedArabEmirates = 'UNITED_ARAB_EMIRATES',
  UnitedKingdom = 'UNITED_KINGDOM',
  UnitedStates = 'UNITED_STATES'
}

export enum CmsProductCategory {
  AmazonAdvertisingApi = 'AMAZON_ADVERTISING_API',
  AmazonAttribution = 'AMAZON_ATTRIBUTION',
  AmazonDsp = 'AMAZON_DSP',
  AmazonLive = 'AMAZON_LIVE',
  AmazonMarketingCloud = 'AMAZON_MARKETING_CLOUD',
  AmazonMarketingStream = 'AMAZON_MARKETING_STREAM',
  AmazonOtt = 'AMAZON_OTT',
  BulkOperations = 'BULK_OPERATIONS',
  CustomAds = 'CUSTOM_ADS',
  ManagerAccount = 'MANAGER_ACCOUNT',
  PartnerAdvertiserManager = 'PARTNER_ADVERTISER_MANAGER',
  PartnerNetwork = 'PARTNER_NETWORK',
  Posts = 'POSTS',
  RapidRetailAnalytics = 'RAPID_RETAIL_ANALYTICS',
  SponsoredBrands = 'SPONSORED_BRANDS',
  SponsoredDisplay = 'SPONSORED_DISPLAY',
  SponsoredProducts = 'SPONSORED_PRODUCTS',
  Stores = 'STORES'
}

export enum CmsResourceCategory {
  AdvertisingGuides = 'ADVERTISING_GUIDES',
  CaseStudies = 'CASE_STUDIES',
  NewsAndUpdates = 'NEWS_AND_UPDATES',
  OnDemandWebinars = 'ON_DEMAND_WEBINARS',
  ProductUpdates = 'PRODUCT_UPDATES',
  Videos = 'VIDEOS'
}

export type CmsResourceEntry = CmsEntry & {
  __typename: 'CMSResourceEntry';
  accessControl?: Maybe<AccessControl>;
  audit: Audit;
  deleted: Scalars['Boolean'];
  details?: Maybe<CmsDetails>;
  experienceLevelCategories?: Maybe<Array<CmsExperienceLevelCategory>>;
  featured?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  marketplaceCategories?: Maybe<Array<CmsMarketplaceCategory>>;
  productCategories?: Maybe<Array<CmsProductCategory>>;
  /** Indicates the resource category. */
  resourceCategories?: Maybe<Array<CmsResourceCategory>>;
  tags?: Maybe<Array<CmsEntryTag>>;
  targetSegments?: Maybe<Array<Scalars['String']>>;
};

/** Basic (top-level) info describing a featured content request */
export type CampaignDetails = {
  __typename: 'CampaignDetails';
  /** The amount of money budgeted for the featured campaign */
  campaignBudget?: Maybe<Budget>;
  /** The end date of the featured campaign */
  campaignEndDate?: Maybe<Scalars['ISODate']>;
  /** The state date of the featured campaign */
  campaignStartDate?: Maybe<Scalars['ISODate']>;
  /** The title of the featured campaign */
  campaignTitle?: Maybe<Scalars['String']>;
  /** The merchant id of the featured client */
  clientMCID?: Maybe<Scalars['String']>;
  /** The company name of the featured client */
  clientName?: Maybe<Scalars['String']>;
};

export type CampaignDetailsInput = {
  /** The amount of money budgeted for the featured campaign */
  campaignBudget?: Maybe<BudgetInput>;
  /** The end date of the featured campaign */
  campaignEndDate?: Maybe<Scalars['ISODate']>;
  /** The state date of the featured campaign */
  campaignStartDate?: Maybe<Scalars['ISODate']>;
  /** The title of the featured campaign */
  campaignTitle?: Maybe<Scalars['String']>;
  /** The merchant id of the featured client */
  clientMCID?: Maybe<Scalars['String']>;
  /** The company name of the featured client */
  clientName?: Maybe<Scalars['String']>;
};

/** Type holding data related to case study article */
export type CaseStudy = FeaturedContent & {
  __typename: 'CaseStudy';
  /** The article-specific unique identifier in the case study URL */
  contentUrlKey: Scalars['String'];
  id: Scalars['ID'];
  /** The user who last updated the case study */
  lastUpdatedBy: Scalars['String'];
  /** The date the case study was last updated */
  lastUpdatedDate: Scalars['ISODate'];
};

/** Information specific to the featured campaign */
export type CaseStudyDetails = {
  __typename: 'CaseStudyDetails';
  /** The objective of the campaign and key performance indicators */
  campaignObjectives?: Maybe<Scalars['String']>;
  /** The partner's approach to delivering on objectives */
  deliveryApproach?: Maybe<Scalars['String']>;
  /** The challenge the partner was looking to solve for the client */
  partnerChallenge?: Maybe<Scalars['String']>;
  /** The Amazon Ads products leveraged in the campaign */
  productsUtilized?: Maybe<Array<Maybe<CaseStudyProducts>>>;
  /** The metrics used to measure success against KPIs */
  successIndicators?: Maybe<Array<Maybe<CaseStudySuccessIndicators>>>;
};

export type CaseStudyDetailsInput = {
  /** The objective of the campaign and key performance indicators */
  campaignObjectives?: Maybe<Scalars['String']>;
  /** The partner's approach to delivering on objectives */
  deliveryApproach?: Maybe<Scalars['String']>;
  /** The challenge the partner was looking to solve for the client */
  partnerChallenge?: Maybe<Scalars['String']>;
  /** The Amazon Ads products leveraged in the campaign */
  productsUtilized?: Maybe<Array<Maybe<CaseStudyProducts>>>;
  /** The metrics used to measure success against KPIs */
  successIndicators?: Maybe<Array<Maybe<CaseStudySuccessIndicators>>>;
};

/** Information related to the outcome of the featured campaign */
export type CaseStudyOutcome = {
  __typename: 'CaseStudyOutcome';
  /** The results of the campaign against objectives and goals */
  campaignResults?: Maybe<Scalars['String']>;
  /** Information about how the partner implemented their strategy with Amazon products */
  implementationSummary?: Maybe<Scalars['String']>;
  /** How campaign learnings will drive future success */
  resultsFutureUsage?: Maybe<Scalars['String']>;
};

export type CaseStudyOutcomeInput = {
  /** The results of the campaign against objectives and goals */
  campaignResults?: Maybe<Scalars['String']>;
  /** Information about how the partner implemented their strategy with Amazon products */
  implementationSummary?: Maybe<Scalars['String']>;
  /** How campaign learnings will drive future success */
  resultsFutureUsage?: Maybe<Scalars['String']>;
};

export enum CaseStudyProducts {
  AmazonAdsApi = 'AMAZON_ADS_API',
  AmazonAttribution = 'AMAZON_ATTRIBUTION',
  AmazonDsp = 'AMAZON_DSP',
  AmazonLive = 'AMAZON_LIVE',
  AmazonMarketingCloud = 'AMAZON_MARKETING_CLOUD',
  AmazonMarketingStream = 'AMAZON_MARKETING_STREAM',
  AudioAds = 'AUDIO_ADS',
  CustomAdvertisingSolutions = 'CUSTOM_ADVERTISING_SOLUTIONS',
  Posts = 'POSTS',
  SizmekAdSuite = 'SIZMEK_AD_SUITE',
  SponsoredBrands = 'SPONSORED_BRANDS',
  SponsoredDisplay = 'SPONSORED_DISPLAY',
  SponsoredProducts = 'SPONSORED_PRODUCTS',
  Stores = 'STORES',
  StreamingTv = 'STREAMING_TV',
  Twitch = 'TWITCH',
  VideoAds = 'VIDEO_ADS'
}

/** A type capturing direct quotes related to a featured campaign */
export type CaseStudyQuote = {
  __typename: 'CaseStudyQuote';
  quote: Scalars['String'];
  quoteType: QuoteCategory;
};

export type CaseStudyQuoteInput = {
  quote: Scalars['String'];
  quoteType: QuoteCategory;
};

/** Key performance indicators related to a campaign featured in a featured content request */
export enum CaseStudySuccessIndicators {
  AddToCart = 'ADD_TO_CART',
  AdvertisingCostOfSale = 'ADVERTISING_COST_OF_SALE',
  AdAttributedSales = 'AD_ATTRIBUTED_SALES',
  AdImpressions = 'AD_IMPRESSIONS',
  AdSpend = 'AD_SPEND',
  BrandedSearchImpressions = 'BRANDED_SEARCH_IMPRESSIONS',
  BrandLift = 'BRAND_LIFT',
  Clicks = 'CLICKS',
  ClickThroughs = 'CLICK_THROUGHS',
  DetailPageViews = 'DETAIL_PAGE_VIEWS',
  DetailPageViewRate = 'DETAIL_PAGE_VIEW_RATE',
  NewToBrandCustomers = 'NEW_TO_BRAND_CUSTOMERS',
  NewToBrandPurchases = 'NEW_TO_BRAND_PURCHASES',
  Other = 'OTHER',
  PurchaseRate = 'PURCHASE_RATE',
  ReturnOnAdSpend = 'RETURN_ON_AD_SPEND',
  SubscribeAndSaveSubscriptions = 'SUBSCRIBE_AND_SAVE_SUBSCRIPTIONS',
  SubscribeAndSaveSubscriptionRate = 'SUBSCRIBE_AND_SAVE_SUBSCRIPTION_RATE'
}

/** Type dedicated to partner user certification data */
export type CertificationData = {
  __typename: 'CertificationData';
  /** Info about the total count for each certification type */
  certificationDataByType?: Maybe<Array<CertificationTypeData>>;
  /** Search for specific partner-users based on their certification expiration or certification type */
  certifiedUsers?: Maybe<CertifiedUsersResult>;
};


/** Type dedicated to partner user certification data */
export type CertificationDataCertifiedUsersArgs = {
  pagination?: Maybe<PaginationInput>;
  query?: Maybe<CertificationQueryInput>;
  sorts?: Maybe<Array<Maybe<SortInput>>>;
};

export type CertificationEntryConnection = Connection & {
  __typename: 'CertificationEntryConnection';
  edges: Array<CertificationEntryEdge>;
  pageInfo?: Maybe<PageInfo>;
  totalCertificationEntryCount: Scalars['Int'];
};

export type CertificationEntryEdge = Edge & {
  __typename: 'CertificationEntryEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node: CertificationEntryNode;
};

/** Type dedicated to certification entries, each entry is one certification mapped to a specific PartnerUser */
export type CertificationEntryNode = {
  __typename: 'CertificationEntryNode';
  /** Edge to corresponding partner user */
  certificationUser: PartnerUser;
  /** Certification courseTag */
  courseTag?: Maybe<CourseTag>;
  /** Expiration date of the Certification */
  expirationDate?: Maybe<Scalars['ISODate']>;
  /** Name of the Certification */
  name: Scalars['String'];
  /** Type of the Certification */
  type?: Maybe<Scalars['String']>;
};

/** Input for Query.partner.CertificationData.certifiedUsers */
export type CertificationQueryInput = {
  /** Filter by courseTag */
  courseTag?: Maybe<Array<Scalars['String']>>;
  /** Filter certifications expiring before this date */
  endDate?: Maybe<Scalars['ISODate']>;
  /** String to use for a text search */
  search?: Maybe<Scalars['String']>;
  /** Filter certifications expiring after this date */
  startDate?: Maybe<Scalars['ISODate']>;
};

/** Type dedicated to the data for a given certification type */
export type CertificationTypeData = {
  __typename: 'CertificationTypeData';
  /** Count of users with this certificate */
  count: Scalars['Int'];
  /** Name of the type of certificate */
  name: Scalars['String'];
};

export type CertifiedUsersResult = CertificationEntryConnection | ClientError;

export type ClientError = Error & {
  __typename: 'ClientError';
  code: ErrorCode;
  message?: Maybe<Scalars['String']>;
};

export enum CompanyListingServiceModels {
  SelfService = 'SELF_SERVICE',
  Service = 'SERVICE'
}

export enum CompanyServiceModels {
  Agency = 'AGENCY',
  Consultant = 'CONSULTANT',
  ToolProvider = 'TOOL_PROVIDER'
}

export enum CompanyServicesProvided {
  AdvertisingEffectiveness = 'ADVERTISING_EFFECTIVENESS',
  AnimatedVideos = 'ANIMATED_VIDEOS',
  AudienceAndTargeting = 'AUDIENCE_AND_TARGETING',
  AudienceMeasurement = 'AUDIENCE_MEASUREMENT',
  AudienceVerification = 'AUDIENCE_VERIFICATION',
  AudioAds = 'AUDIO_ADS',
  AudioAdsProduction = 'AUDIO_ADS_PRODUCTION',
  AudioMeasurement = 'AUDIO_MEASUREMENT',
  APlusContent = 'A_PLUS_CONTENT',
  BrandMeasurement = 'BRAND_MEASUREMENT',
  BrandSafety = 'BRAND_SAFETY',
  BusinessAndMarketingIntelligenceTools = 'BUSINESS_AND_MARKETING_INTELLIGENCE_TOOLS',
  CampaignManagement = 'CAMPAIGN_MANAGEMENT',
  CampaignMonitoring = 'CAMPAIGN_MONITORING',
  CampaignReporting = 'CAMPAIGN_REPORTING',
  CampaignSetup = 'CAMPAIGN_SETUP',
  CleanRoomAnalytics = 'CLEAN_ROOM_ANALYTICS',
  CleanRoomDeveloper = 'CLEAN_ROOM_DEVELOPER',
  CleanRoomIntegration = 'CLEAN_ROOM_INTEGRATION',
  CreativeTools = 'CREATIVE_TOOLS',
  CreatorContent = 'CREATOR_CONTENT',
  CustomerDataPlatform = 'CUSTOMER_DATA_PLATFORM',
  DataConnectors = 'DATA_CONNECTORS',
  DataIntegration = 'DATA_INTEGRATION',
  DetailPageSetUp = 'DETAIL_PAGE_SET_UP',
  HowToVideos = 'HOW_TO_VIDEOS',
  InventoryManagement = 'INVENTORY_MANAGEMENT',
  LifestyleVideos = 'LIFESTYLE_VIDEOS',
  MarketingMixModeling = 'MARKETING_MIX_MODELING',
  MarketResearch = 'MARKET_RESEARCH',
  MobileAndAppAttribution = 'MOBILE_AND_APP_ATTRIBUTION',
  MultiTouchAttribution = 'MULTI_TOUCH_ATTRIBUTION',
  Photography = 'PHOTOGRAPHY',
  ProductResearch = 'PRODUCT_RESEARCH',
  ProductShots = 'PRODUCT_SHOTS',
  Promotions = 'PROMOTIONS',
  ReportingAndAnalytics = 'REPORTING_AND_ANALYTICS',
  Resale = 'RESALE',
  RetailPerformanceMeasurement = 'RETAIL_PERFORMANCE_MEASUREMENT',
  RichMedia = 'RICH_MEDIA',
  SalesAndPricingStrategy = 'SALES_AND_PRICING_STRATEGY',
  StoreSetupAndOptimization = 'STORE_SETUP_AND_OPTIMIZATION',
  Training = 'TRAINING',
  TvAds_15And_30Sec = 'TV_ADS_15_AND_30_SEC',
  VideoMeasurement = 'VIDEO_MEASUREMENT',
  VideoProduction = 'VIDEO_PRODUCTION',
  WebDesign = 'WEB_DESIGN'
}

export type CompletedReport = {
  __typename: 'CompletedReport';
  creationDate?: Maybe<Scalars['ISODate']>;
  location?: Maybe<Scalars['HttpsUrl']>;
  reportType?: Maybe<ReportType>;
};

/**
 * Indicates that there was a conflict or some kind of lock contention when attempting to perform an operation.
 * Used in Mutations.
 */
export type ConcurrentlyModified = Error & {
  __typename: 'ConcurrentlyModified';
  code: ErrorCode;
};

export type Connection = {
  edges?: Maybe<Array<Maybe<Edge>>>;
  pageInfo?: Maybe<PageInfo>;
};

/** Country's two letter code according to ISO 3166-1 alpha-2 standards */
export enum CountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export enum CourseTag {
  AmazonAdsAdvancedRetailCertification = 'AMAZON_ADS_ADVANCED_RETAIL_CERTIFICATION',
  AmazonAdsCampaignOptimizationCertification = 'AMAZON_ADS_CAMPAIGN_OPTIMIZATION_CERTIFICATION',
  AmazonAdsCampaignPlanningCertification = 'AMAZON_ADS_CAMPAIGN_PLANNING_CERTIFICATION',
  AmazonAdsFoundationsCertification = 'AMAZON_ADS_FOUNDATIONS_CERTIFICATION',
  AmazonDspAdvancedCertification = 'AMAZON_DSP_ADVANCED_CERTIFICATION',
  AmazonDspCertification = 'AMAZON_DSP_CERTIFICATION',
  AmazonMarketingCloudCertification = 'AMAZON_MARKETING_CLOUD_CERTIFICATION',
  AmazonRetailCertification = 'AMAZON_RETAIL_CERTIFICATION',
  AmazonVideoAdsCertification = 'AMAZON_VIDEO_ADS_CERTIFICATION',
  SizmekAdSuiteAdvancedCertification = 'SIZMEK_AD_SUITE_ADVANCED_CERTIFICATION',
  SizmekAdSuiteCertification = 'SIZMEK_AD_SUITE_CERTIFICATION',
  SponsoredAdsAdvancedCertification = 'SPONSORED_ADS_ADVANCED_CERTIFICATION',
  SponsoredAdsCertification = 'SPONSORED_ADS_CERTIFICATION',
  TwitchGameplanCertification = 'TWITCH_GAMEPLAN_CERTIFICATION'
}

/** Three letters currency code based on ISO 4217:2015 CURRENCY CODES  (https://www.iso.org/iso-4217-currency-codes.html) */
export enum CurrencyCode {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}



/** Input for Mutation.deleteListingSubmission */
export type DeleteListingSubmissionInput = {
  locale: DirectoryLocale;
  revision: Scalars['ID'];
};

export type DeleteListingSubmissionResult = ClientError | MutationError | Partner;

export type DeletePartnerAdvertiserInviteResult = ClientError | NotFound | PartnerAdvertiserInvite;

/** Input for Mutation.deleteRegistration */
export type DeletePartnerRegistrationInput = {
  revision: Scalars['ID'];
};

export type DeletePartnerRegistrationResult = ClientError | MutationError | Partner;

export type DeletePartnerUserInviteResult = ClientError | NotFound | PartnerUserInvite;

export type DeleteSocialDataResult = ClientError | MutationError | Partner;

/** Badges associated with live partner.liveDirectoryListingData */
export type DirectoryListingBadges = {
  __typename: 'DirectoryListingBadges';
  products?: Maybe<Array<ProductBadge>>;
  services?: Maybe<Array<ServiceBadge>>;
};

export enum DirectoryLocale {
  ArAe = 'AR_AE',
  DeDe = 'DE_DE',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  JaJp = 'JA_JP',
  KoKr = 'KO_KR',
  NlNl = 'NL_NL',
  PlPl = 'PL_PL',
  PtBr = 'PT_BR',
  SvSe = 'SV_SE',
  TrTr = 'TR_TR',
  ZhCn = 'ZH_CN'
}

export type DisplayNameInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Edge = {
  cursor?: Maybe<Scalars['Cursor']>;
};


export type Error = {
  code: ErrorCode;
};

export enum ErrorCode {
  ClientError = 'CLIENT_ERROR',
  ConcurrentlyModified = 'CONCURRENTLY_MODIFIED',
  ErrorFeaturedContentRequestNotFinished = 'ERROR_FEATURED_CONTENT_REQUEST_NOT_FINISHED',
  IncompleteSubmission = 'INCOMPLETE_SUBMISSION',
  InvalidCursor = 'INVALID_CURSOR',
  InvalidInput = 'INVALID_INPUT',
  InvalidInputAgreementNotAccepted = 'INVALID_INPUT_AGREEMENT_NOT_ACCEPTED',
  InvalidInputDescriptionTooLarge = 'INVALID_INPUT_DESCRIPTION_TOO_LARGE',
  InvalidInputEmailBlocklistRecordMissingFields = 'INVALID_INPUT_EMAIL_BLOCKLIST_RECORD_MISSING_FIELDS',
  InvalidInputEnglishNotProvided = 'INVALID_INPUT_ENGLISH_NOT_PROVIDED',
  InvalidInputIncorrectAreaCode = 'INVALID_INPUT_INCORRECT_AREA_CODE',
  InvalidInputLocationMissing = 'INVALID_INPUT_LOCATION_MISSING',
  InvalidInputLogoMissing = 'INVALID_INPUT_LOGO_MISSING',
  InvalidInputLogoReviewMissing = 'INVALID_INPUT_LOGO_REVIEW_MISSING',
  InvalidInputLogoVersion = 'INVALID_INPUT_LOGO_VERSION',
  InvalidInputLogoVersionTooLow = 'INVALID_INPUT_LOGO_VERSION_TOO_LOW',
  InvalidInputNoEditsMadeToRejectionReason = 'INVALID_INPUT_NO_EDITS_MADE_TO_REJECTION_REASON',
  InvalidInputOccurrenceStartAndEndDate = 'INVALID_INPUT_OCCURRENCE_START_AND_END_DATE',
  InvalidInputPersonalEmail = 'INVALID_INPUT_PERSONAL_EMAIL',
  InvalidInputRejectionReasonMissingFields = 'INVALID_INPUT_REJECTION_REASON_MISSING_FIELDS',
  InvalidInputRequestId = 'INVALID_INPUT_REQUEST_ID',
  InvalidInputSingleValueField = 'INVALID_INPUT_SINGLE_VALUE_FIELD',
  InvalidLocale = 'INVALID_LOCALE',
  InvalidPartnerGroupId = 'INVALID_PARTNER_GROUP_ID',
  InvalidRequestStructure = 'INVALID_REQUEST_STRUCTURE',
  InvalidRevision = 'INVALID_REVISION',
  InvalidState = 'INVALID_STATE',
  InvalidStateAccountDisabled = 'INVALID_STATE_ACCOUNT_DISABLED',
  InvalidStateAlreadyPendingReview = 'INVALID_STATE_ALREADY_PENDING_REVIEW',
  InvalidStateApplicationAlreadyLinkedToPartner = 'INVALID_STATE_APPLICATION_ALREADY_LINKED_TO_PARTNER',
  InvalidStateApplicationAlreadyUnlinked = 'INVALID_STATE_APPLICATION_ALREADY_UNLINKED',
  InvalidStateApplicationDoesNotBelongToPartner = 'INVALID_STATE_APPLICATION_DOES_NOT_BELONG_TO_PARTNER',
  InvalidStateApplicationInInvalidState = 'INVALID_STATE_APPLICATION_IN_INVALID_STATE',
  InvalidStateApplicationInPending = 'INVALID_STATE_APPLICATION_IN_PENDING',
  InvalidStateApplicationLinkedToAnotherPartner = 'INVALID_STATE_APPLICATION_LINKED_TO_ANOTHER_PARTNER',
  InvalidStateBadgeAlreadyAwarded = 'INVALID_STATE_BADGE_ALREADY_AWARDED',
  InvalidStateBadgeAlreadyRevoked = 'INVALID_STATE_BADGE_ALREADY_REVOKED',
  InvalidStateBadgeNotAwarded = 'INVALID_STATE_BADGE_NOT_AWARDED',
  InvalidStateBadgeNotClaimed = 'INVALID_STATE_BADGE_NOT_CLAIMED',
  InvalidStateCannotRemovePrimaryPartner = 'INVALID_STATE_CANNOT_REMOVE_PRIMARY_PARTNER',
  InvalidStateCustomerEmailNotFound = 'INVALID_STATE_CUSTOMER_EMAIL_NOT_FOUND',
  InvalidStateDuplicateCompanyNameInGroup = 'INVALID_STATE_DUPLICATE_COMPANY_NAME_IN_GROUP',
  InvalidStateDuplicateRejectionReason = 'INVALID_STATE_DUPLICATE_REJECTION_REASON',
  InvalidStateEmailBlocklistRecordAlreadyInactive = 'INVALID_STATE_EMAIL_BLOCKLIST_RECORD_ALREADY_INACTIVE',
  InvalidStateExistingDraft = 'INVALID_STATE_EXISTING_DRAFT',
  InvalidStateInviteeUnauthorized = 'INVALID_STATE_INVITEE_UNAUTHORIZED',
  InvalidStateInviteExpired = 'INVALID_STATE_INVITE_EXPIRED',
  InvalidStateInviteNotRedeemable = 'INVALID_STATE_INVITE_NOT_REDEEMABLE',
  InvalidStateInviteNotRevocable = 'INVALID_STATE_INVITE_NOT_REVOCABLE',
  InvalidStateInviteRedeemableLock = 'INVALID_STATE_INVITE_REDEEMABLE_LOCK',
  InvalidStateNotAdvancedPartner = 'INVALID_STATE_NOT_ADVANCED_PARTNER',
  InvalidStateNoApprovedRegistration = 'INVALID_STATE_NO_APPROVED_REGISTRATION',
  InvalidStateNoChangesDetected = 'INVALID_STATE_NO_CHANGES_DETECTED',
  InvalidStateNoExistingRegistration = 'INVALID_STATE_NO_EXISTING_REGISTRATION',
  InvalidStatePartnerAnotherGroupMember = 'INVALID_STATE_PARTNER_ANOTHER_GROUP_MEMBER',
  InvalidStatePartnerNotEligibleGroupMember = 'INVALID_STATE_PARTNER_NOT_ELIGIBLE_GROUP_MEMBER',
  InvalidStatePartnerNotGroupMember = 'INVALID_STATE_PARTNER_NOT_GROUP_MEMBER',
  InvalidStateRejectionReasonAlreadyDisabled = 'INVALID_STATE_REJECTION_REASON_ALREADY_DISABLED',
  InvalidStateRequestAlreadySubmitted = 'INVALID_STATE_REQUEST_ALREADY_SUBMITTED',
  InvalidStateSecondaryAccount = 'INVALID_STATE_SECONDARY_ACCOUNT',
  InvalidStateTestimonialLimitReached = 'INVALID_STATE_TESTIMONIAL_LIMIT_REACHED',
  InvalidStateUnredeemedRequestExists = 'INVALID_STATE_UNREDEEMED_REQUEST_EXISTS',
  InvalidStateUserAnotherGroupAdmin = 'INVALID_STATE_USER_ANOTHER_GROUP_ADMIN',
  InvalidStateUserDoesNotMatchActivationLink = 'INVALID_STATE_USER_DOES_NOT_MATCH_ACTIVATION_LINK',
  InvalidStateUserNotGroupAdmin = 'INVALID_STATE_USER_NOT_GROUP_ADMIN',
  InvalidStateUserNotPartnerAccountAdmin = 'INVALID_STATE_USER_NOT_PARTNER_ACCOUNT_ADMIN',
  InvalidStateUserUnauthorized = 'INVALID_STATE_USER_UNAUTHORIZED',
  InvalidStateUserUnauthorizedToLinkApplication = 'INVALID_STATE_USER_UNAUTHORIZED_TO_LINK_APPLICATION',
  NonRetryable = 'NON_RETRYABLE',
  NonRetryableDependency = 'NON_RETRYABLE_DEPENDENCY',
  NotFound = 'NOT_FOUND',
  RecordNotFound = 'RECORD_NOT_FOUND',
  RequiredFieldEventType = 'REQUIRED_FIELD_EVENT_TYPE',
  RequiredFieldExperienceCategory = 'REQUIRED_FIELD_EXPERIENCE_CATEGORY',
  RequiredFieldMarketplaceCategory = 'REQUIRED_FIELD_MARKETPLACE_CATEGORY',
  RequiredFieldProductCategory = 'REQUIRED_FIELD_PRODUCT_CATEGORY',
  RequiredFieldResourceCategory = 'REQUIRED_FIELD_RESOURCE_CATEGORY',
  Retryable = 'RETRYABLE',
  RetryableDependency = 'RETRYABLE_DEPENDENCY',
  RetryableInternal = 'RETRYABLE_INTERNAL',
  UnexpectedStatus = 'UNEXPECTED_STATUS'
}

/** This is the object queried for the partner details view as part of our external API, so that we don't expose our internal API. */
export type ExternalRejectionReasonObject = {
  __typename: 'ExternalRejectionReasonObject';
  /** Help content ID(s) field to link an internal help content */
  helpContentIds?: Maybe<Array<Scalars['ID']>>;
  /** Unique identifier for this rejection reason */
  id: Scalars['ID'];
  /** Detailed description for partners (english) */
  message: Scalars['String'];
  /** A list of translations of the rejection message */
  translations: Array<Translation>;
  /** Version of rejection reason object at the time of rejection. */
  version: Scalars['Int'];
};

export type FeatureVariations = {
  __typename: 'FeatureVariations';
  /** The name of the feature evaluated */
  feature: Scalars['String'];
  /** The name of the variation that was served to this feature (C, T1, T2, ...) */
  variation: Variation;
};

/** Interface for any type of FeaturedContent */
export type FeaturedContent = {
  id: Scalars['ID'];
};

/** A unique featured content request */
export type FeaturedContentRequest = {
  __typename: 'FeaturedContentRequest';
  /** Audit information for createdDate and most recent update on FCR by partner user */
  auditInfo: Audit;
  /** The most recent draft of the featured content request */
  draft: FeaturedContentRequestInfo;
  id: Scalars['ID'];
  /** The submitted featured content request */
  live?: Maybe<FeaturedContentRequestSubmission>;
  /** The locale representative of the request submission */
  locale: PreferredLocale;
};

export type FeaturedContentRequestEntries = {
  __typename: 'FeaturedContentRequestEntries';
  entries?: Maybe<Array<FeaturedContentRequest>>;
};

/** All of the featured content request form inputs */
export type FeaturedContentRequestInfo = {
  __typename: 'FeaturedContentRequestInfo';
  campaignDetails?: Maybe<CampaignDetails>;
  caseStudyDetails?: Maybe<CaseStudyDetails>;
  outcome?: Maybe<CaseStudyOutcome>;
  partnerClientBackground?: Maybe<PartnerClientBackground>;
  quotes?: Maybe<Array<Maybe<CaseStudyQuote>>>;
  revision: Scalars['ID'];
};

export type FeaturedContentRequestInput = {
  campaignDetails?: Maybe<CampaignDetailsInput>;
  caseStudyDetails?: Maybe<CaseStudyDetailsInput>;
  id?: Maybe<Scalars['ID']>;
  locale?: Maybe<PreferredLocale>;
  outcome?: Maybe<CaseStudyOutcomeInput>;
  partnerClientBackground?: Maybe<PartnerClientBackgroundInput>;
  quotes?: Maybe<Array<Maybe<CaseStudyQuoteInput>>>;
};

/** All of the featured content request form inputs AND submission info */
export type FeaturedContentRequestSubmission = {
  __typename: 'FeaturedContentRequestSubmission';
  featuredContentRequestInfo: FeaturedContentRequestInfo;
  verificationWorkflowId?: Maybe<VerificationWorkflowId>;
};

export type FieldError = {
  __typename: 'FieldError';
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<FieldErrorReason>;
};

export enum FieldErrorReason {
  Missing = 'MISSING'
}

/**
 * Used to define an "exists" check on a specific field when searching indexes.
 * The shape of this input is intended to align with Keyword and Range input types.
 */
export type FieldExistsInput = {
  /** Field to check for existence */
  field: Scalars['String'];
};

export type FilterInput = {
  exists?: Maybe<Array<FieldExistsInput>>;
  /**
   * The logical operator used to evaulate all fields provided in the fields list.
   * Usually and AND or an OR, it designates if all fields must exist (AND) or if
   * one/some of the fields must exist (OR).
   * Default: AND
   */
  existsLogicalOperator?: Maybe<LogicalOperator>;
  keyword?: Maybe<Array<FilterKeywordInput>>;
  range?: Maybe<Array<FilterRangeInput>>;
};

export type FilterKeywordInput = {
  field: Scalars['String'];
  filter: Scalars['String'];
};

/**
 * Defines the constraint for a given range filter.
 * Constraints can be defined using "greater/less than" algebraic logic.
 */
export type FilterRangeConstraintInput = {
  /** Greater than. */
  gt?: Maybe<Scalars['String']>;
  /** Greater than or equal to. */
  gte?: Maybe<Scalars['String']>;
  /** Less than. */
  lt?: Maybe<Scalars['String']>;
  /** Less than or equal to. */
  lte?: Maybe<Scalars['String']>;
};

export type FilterRangeInput = {
  field: Scalars['String'];
  filter: FilterRangeConstraintInput;
};

export type GenerateReportReponse = ClientError | PendingReport;

export type GetReportResponse = CompletedReport | InvalidState | NoReport | PendingReport;



export enum Industries {
  Automotive = 'AUTOMOTIVE',
  ConsumerElectronics = 'CONSUMER_ELECTRONICS',
  ConsumerServices = 'CONSUMER_SERVICES',
  Education = 'EDUCATION',
  Entertainment = 'ENTERTAINMENT',
  Fashion = 'FASHION',
  FinancialServices = 'FINANCIAL_SERVICES',
  Grocery = 'GROCERY',
  HomeAndBuildingServices = 'HOME_AND_BUILDING_SERVICES',
  Hospitality = 'HOSPITALITY',
  Publishing = 'PUBLISHING',
  Telecom = 'TELECOM',
  ToysAndGames = 'TOYS_AND_GAMES'
}

export enum IndustriesServed {
  Automotive = 'AUTOMOTIVE',
  B2B = 'B2B',
  ConsumerGoods = 'CONSUMER_GOODS',
  EntertainmentMedia = 'ENTERTAINMENT_MEDIA',
  ECommerce = 'E_COMMERCE',
  FinancialServices = 'FINANCIAL_SERVICES',
  FoodBeverage = 'FOOD_BEVERAGE',
  Gaming = 'GAMING',
  HealthPharma = 'HEALTH_PHARMA',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  Restaurants = 'RESTAURANTS',
  Sports = 'SPORTS',
  Telecom = 'TELECOM',
  Travel = 'TRAVEL'
}

export type InvalidCursor = Error & {
  __typename: 'InvalidCursor';
  code: ErrorCode;
};

/**
 * Indicates an issue with the provided input payload.
 * Examples:
 * 1. Date range where the provided end date is earlier than the start date.
 * 2. Addresses where the city is in Canada, but the state is marked as Texas.
 */
export type InvalidInput = Error & {
  __typename: 'InvalidInput';
  code: ErrorCode;
  details: Array<InvalidInputDetails>;
};

export type InvalidInputDetails = {
  __typename: 'InvalidInputDetails';
  /**
   * A list of strings describing the traversal to an offending field.
   * Starts from the highest level in an object, winding deeper, until it labels the field in question.
   * Example:
   * type FooObject {
   *   bar: {
   *     blah: {
   *       a: 1
   *       b: 2
   *     }
   *   }
   * }
   * For field "b", path is:
   * ["bar", "blah", "b"]
   */
  path: Array<Scalars['String']>;
  /** Optional - filled with the offending/invalid value rejected by validation. */
  value?: Maybe<Scalars['String']>;
};

/**
 * Where InvalidInput is used for validity checks on input provided by a customer, InvalidRequestStructure is used for validity
 * checks on all other API input.
 * Examples include:
 * 1. Providing the query pagination parameters `first` and `before` (valid combos are `first`/`after` and `last`/`before`).
 * 2. Providing a field for query sorting that the data model is not sortable by.
 */
export type InvalidRequestStructure = Error & {
  __typename: 'InvalidRequestStructure';
  code: ErrorCode;
  details: Scalars['String'];
};

/**
 * Describes an invalid state, or more specifically a situation where even "correct"/valid input fields
 * cannot produce the desired change, as it would persist data in an invalid state.
 * Examples include:
 * 1. Moving an item into an illegal state in its lifecycle (like moving draft -> live, skipping review).
 * 2. Attempting to remove the last user or admin on an account, since removing the last would render an account inoperable.
 */
export type InvalidState = Error & {
  __typename: 'InvalidState';
  code: ErrorCode;
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type InvitedAdvertiser = {
  __typename: 'InvitedAdvertiser';
  adminId?: Maybe<Scalars['CustomerAccountId']>;
  advertiser?: Maybe<Advertiser>;
  isLinked?: Maybe<Scalars['Boolean']>;
};

export enum LanguagesSupported {
  Arabic = 'ARABIC',
  ArabicSaudiArabia = 'ARABIC_SAUDI_ARABIA',
  ArabicUnitedArabEmirates = 'ARABIC_UNITED_ARAB_EMIRATES',
  Chinese = 'CHINESE',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  EnglishSingapore = 'ENGLISH_SINGAPORE',
  French = 'FRENCH',
  FrenchCanadian = 'FRENCH_CANADIAN',
  German = 'GERMAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  PortugeseBr = 'PORTUGESE_BR',
  Portuguese = 'PORTUGUESE',
  Spanish = 'SPANISH',
  Swedish = 'SWEDISH',
  Turkish = 'TURKISH'
}

/**
 * Type holding information about certificates that the user was awarded in the Advertising Learning
 * Console
 */
export type LearningConsoleCertificate = {
  __typename: 'LearningConsoleCertificate';
  /** Certificate badge content type of the badge, e.g. \'image/jpeg\' */
  badgeContentType?: Maybe<Scalars['String']>;
  /** A fully qualified, accessible URL pointing to an image to use for the award badge. */
  badgeUrl?: Maybe<Scalars['HttpsUrl']>;
  /** Name of the certificate without localization */
  courseTag?: Maybe<Scalars['String']>;
  /** Expiry date of the certificate (if any) */
  expirationDate?: Maybe<Scalars['ISODate']>;
  /** Name of the certificate */
  name: Scalars['String'];
};

/** Input for Mutation.LinkApplicationInput */
export type LinkApplicationInput = {
  /** Field indicating advertiser automapping status */
  advertiserAutomappingStatus?: Maybe<AdvertiserAutomappingStatus>;
  /** The ApplicationID of the application as provided by StegoService. Will be of the form "amzn1.application-oa2-client.<28-digit code>" */
  applicationId: Scalars['ID'];
};

export type LinkOrUnlinkApplicationResponse = ApplicationDetails | ClientError | InvalidState;

export enum LinkStatus {
  Linked = 'LINKED',
  Pending = 'PENDING',
  Unlinked = 'UNLINKED'
}

export type LinkableApplication = {
  __typename: 'LinkableApplication';
  /** The ApplicationID of the application as provided by StegoService. Will be of the form "amzn1.application-oa2-client.<28-digit code>" */
  applicationId: Scalars['ID'];
  /** Boolean value that specifies whether application has been assigned advertising scope */
  hasAdsScope?: Maybe<Scalars['Boolean']>;
  /** The Application Name, as provided by StegoService */
  name: Scalars['String'];
};

/** Localized information describing and naming an Award */
export type LocalizedAwardDetails = {
  __typename: 'LocalizedAwardDetails';
  /** A human readable description of this Award */
  description: Scalars['String'];
  /** The locale of this award's details */
  locale: AwardsLocale;
  /** A human readable name for this Award */
  name: Scalars['String'];
};

/** Localized Directory Listing is a single set of revisions for the DirectoryListingCopy. */
export type LocalizedDirectoryListing = {
  __typename: 'LocalizedDirectoryListing';
  draft: LocalizedDirectoryListingData;
  live?: Maybe<VerifiableLocalizedDirectoryListingData>;
  review?: Maybe<VerifiableLocalizedDirectoryListingData>;
};

/** The Localized Directory Listing Data is the typically free-text Directory Listing fields, which are moderated */
export type LocalizedDirectoryListingData = {
  __typename: 'LocalizedDirectoryListingData';
  contactUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  externalHomeUrl?: Maybe<Scalars['String']>;
  revision: Scalars['ID'];
};

/** Directory Listing Locales are all the possible languages to input Copy in. */
export type LocalizedDirectoryListings = {
  __typename: 'LocalizedDirectoryListings';
  ar_ae?: Maybe<LocalizedDirectoryListing>;
  de_de?: Maybe<LocalizedDirectoryListing>;
  en_us?: Maybe<LocalizedDirectoryListing>;
  es_es?: Maybe<LocalizedDirectoryListing>;
  fr_fr?: Maybe<LocalizedDirectoryListing>;
  it_it?: Maybe<LocalizedDirectoryListing>;
  ja_jp?: Maybe<LocalizedDirectoryListing>;
  ko_kr?: Maybe<LocalizedDirectoryListing>;
  nl_nl?: Maybe<LocalizedDirectoryListing>;
  pl_pl?: Maybe<LocalizedDirectoryListing>;
  pt_br?: Maybe<LocalizedDirectoryListing>;
  sv_se?: Maybe<LocalizedDirectoryListing>;
  tr_tr?: Maybe<LocalizedDirectoryListing>;
  zh_cn?: Maybe<LocalizedDirectoryListing>;
};

export type LocalizedListingInput = {
  contactUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  externalHomeUrl?: Maybe<Scalars['String']>;
  submissionNotes?: Maybe<Scalars['String']>;
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

/**
 * Type capturing all data related to a partner manager account.
 * It includes both regional and global manager account
 */
export type ManagerAccount = {
  __typename: 'ManagerAccount';
  /** ID of the manager account */
  id: Scalars['ID'];
  /** Region of the manager account */
  region: Scalars['String'];
};

export type MultiFilterInput = {
  field: Scalars['String'];
  filters: Array<Scalars['String']>;
};

export type Mutation = {
  __typename: 'Mutation';
  /** Update online agreement acceptance for a user */
  acceptOnlineAgreement?: Maybe<OnlineAgreementOrMutationErrors>;
  addPartnerToGroup?: Maybe<AddPartnerToGroupResponse>;
  /** Delete the in-progress Partner Listing Copy submission for a given revision. */
  deleteListingSubmission?: Maybe<DeleteListingSubmissionResult>;
  /** Revoke a pending PartnerAdvertiserInvite. */
  deletePartnerAdvertiserInvite?: Maybe<DeletePartnerAdvertiserInviteResult>;
  /** Deletes the last partner account registration attempt */
  deletePartnerRegistration?: Maybe<DeletePartnerRegistrationResult>;
  /** Delete the PartnerUser invite. */
  deletePartnerUserInvite?: Maybe<DeletePartnerUserInviteResult>;
  /** Deletes social data for a given partner */
  deleteSocialData?: Maybe<DeleteSocialDataResult>;
  generateAdvertiserReport?: Maybe<GenerateReportReponse>;
  linkApplication?: Maybe<LinkOrUnlinkApplicationResponse>;
  /** Generates a PDF pitch deck for a specific partner and returns the download url */
  pitchDeck?: Maybe<PitchDeckDownloadUrlResult>;
  /** Link all specified advertiser ids to the partner associated with the a given invite id. */
  redeemPartnerAdvertiserInvite?: Maybe<RedeemPartnerAdvertiserInviteResult>;
  /** Redeem a PartnerUserInvite. There is no decline functionality. */
  redeemPartnerUserInvite?: Maybe<RedeemPartnerUserInviteResult>;
  /** Remove a PartnerAdvertiser from a specified partner account. */
  removePartnerAdvertiser?: Maybe<Advertiser>;
  removePartnerFromGroup?: Maybe<RemovePartnerFromGroupResponse>;
  /** Remove PartnerUser from a Partner */
  removePartnerUser?: Maybe<User>;
  /** Remove self from a Partner */
  removeSelfFromPartner?: Maybe<User>;
  /** Resend the notification email the email address associated with the invite id */
  resendPartnerAdvertiserInvite?: Maybe<ResendPartnerAdvertiserInviteResult>;
  /** Resend PartnerUserInvite. */
  resendPartnerUserInvite?: Maybe<ResendPartnerUserInviteResult>;
  /**
   * Send invite to and Advertiser for linking with partner account.
   * Email could be Plain or SIF protected email address
   */
  sendPartnerAdvertiserInvite?: Maybe<SendPartnerAdvertiserInviteResult>;
  /** Send invite to PartnerUser for joining partner account. */
  sendPartnerUserInvite?: Maybe<PartnerUserInvite>;
  /** Set user preferences */
  setUserPreferences?: Maybe<UserPreferencesResult>;
  submitBulkAccountCreation?: Maybe<SubmitBulkAccountCreationResponse>;
  /** Submit a new contact us form */
  submitContactUs?: Maybe<Scalars['Boolean']>;
  /** Submits the specified partner logo for moderation */
  submitPartnerLogo?: Maybe<SubmitPartnerLogoResult>;
  /** Register for a new partner account or update a non-approved existing account registration */
  submitPartnerRegistration?: Maybe<SubmitPartnerRegistrationResult>;
  unlinkApplication?: Maybe<LinkOrUnlinkApplicationResponse>;
  /** Unpublish the live Partner Listing Copy submission for a given revision. */
  unpublishListing?: Maybe<UnpublishListingResult>;
  /** Deletes the latest partner logo submission */
  unsubmitPartnerLogo?: Maybe<UnsubmitPartnerLogoResult>;
  updateApplication?: Maybe<UpdateApplicationResponse>;
  /** Create, update, and/or submit the Draft FeaturedContentRequest */
  updateFeaturedContentRequest?: Maybe<UpdateFeaturedContentRequestResult>;
  /** Create, update, and/or submit the Draft LocalizedListing. */
  updateLocalizedListing?: Maybe<UpdateLocalizedListingResult>;
  /** Update notification after the partner has read or dismissed the notification */
  updateNotifications?: Maybe<Array<Maybe<Notification>>>;
  /**
   * Update the draft version of the partner profile with the option to submit it to review to become
   * live.
   */
  updatePartnerProfileDraft?: Maybe<Partner>;
  /** Update an approved partner account registration */
  updatePartnerRegistration?: Maybe<UpdatePartnerRegistrationResult>;
  /** Update PartnerUser */
  updatePartnerUser?: Maybe<PartnerUserMutationResult>;
  /** Adds/updates social data for a given partner */
  updateSocialData?: Maybe<UpdateSocialDataResult>;
  /** Update the Universal Directory Listing Data */
  updateUniversalListing?: Maybe<UpdateUniversalListingResult>;
  /** Updates registration data that is not subject to moderation. */
  updateUnmoderatedPartnerReg?: Maybe<UpdateUnmoderatedPartnerRegResult>;
};


export type MutationAddPartnerToGroupArgs = {
  input: AddPartnerToGroupInput;
};


export type MutationDeleteListingSubmissionArgs = {
  input: DeleteListingSubmissionInput;
};


export type MutationDeletePartnerAdvertiserInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationDeletePartnerRegistrationArgs = {
  deleteRegistrationInput: DeletePartnerRegistrationInput;
};


export type MutationDeletePartnerUserInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationDeleteSocialDataArgs = {
  input: SocialDataInput;
};


export type MutationLinkApplicationArgs = {
  input: LinkApplicationInput;
};


export type MutationPitchDeckArgs = {
  input: PitchDeckInput;
};


export type MutationRedeemPartnerAdvertiserInviteArgs = {
  input: RedeemPartnerAdvertiserInviteInput;
};


export type MutationRedeemPartnerUserInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationRemovePartnerAdvertiserArgs = {
  input: RemovePartnerAdvertiserInput;
};


export type MutationRemovePartnerFromGroupArgs = {
  input: RemovePartnerFromGroupInput;
};


export type MutationRemovePartnerUserArgs = {
  userId: Scalars['CustomerAccountId'];
};


export type MutationResendPartnerAdvertiserInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationResendPartnerUserInviteArgs = {
  inviteId: Scalars['ID'];
};


export type MutationSendPartnerAdvertiserInviteArgs = {
  email: Scalars['String'];
};


export type MutationSendPartnerUserInviteArgs = {
  input: SendPartnerUserInviteInput;
};


export type MutationSetUserPreferencesArgs = {
  input: SetUserPreferencesInput;
};


export type MutationSubmitBulkAccountCreationArgs = {
  input?: Maybe<SubmitBulkAccountCreationRequest>;
};


export type MutationSubmitContactUsArgs = {
  submitContactUsInput: SubmitContactUsInput;
};


export type MutationSubmitPartnerLogoArgs = {
  input: SubmitPartnerLogoInput;
};


export type MutationSubmitPartnerRegistrationArgs = {
  submitRegistrationInput: SubmitPartnerRegistrationInput;
};


export type MutationUnlinkApplicationArgs = {
  input: UnlinkApplicationInput;
};


export type MutationUnpublishListingArgs = {
  input: UnpublishListingInput;
};


export type MutationUnsubmitPartnerLogoArgs = {
  input: UnsubmitPartnerLogoInput;
};


export type MutationUpdateApplicationArgs = {
  input: UpdateApplicationInput;
};


export type MutationUpdateFeaturedContentRequestArgs = {
  input: UpdateFeaturedContentRequestInput;
};


export type MutationUpdateLocalizedListingArgs = {
  input: UpdateLocalizedListingInput;
};


export type MutationUpdateNotificationsArgs = {
  ids: Array<Scalars['ID']>;
  status: NotificationStatus;
};


export type MutationUpdatePartnerProfileDraftArgs = {
  input?: Maybe<UpdatePartnerProfileDraftInput>;
};


export type MutationUpdatePartnerRegistrationArgs = {
  updateRegistrationInput: UpdatePartnerRegistrationInput;
};


export type MutationUpdatePartnerUserArgs = {
  input: UpdatePartnerUserInput;
};


export type MutationUpdateSocialDataArgs = {
  input: UpdateSocialDataInput;
};


export type MutationUpdateUniversalListingArgs = {
  input: UpdateUniversalListingInput;
};


export type MutationUpdateUnmoderatedPartnerRegArgs = {
  input: UnmoderatedPartnerRegInput;
};

export type MutationArgumentError = {
  __typename: 'MutationArgumentError';
  argumentName: Scalars['String'];
  fieldErrors?: Maybe<Array<FieldError>>;
};

export type MutationError = {
  __typename: 'MutationError';
  errors: Array<MutationArgumentError>;
};

export type NoReport = {
  __typename: 'NoReport';
  reportType?: Maybe<ReportType>;
};

/** Indicates that the requested operation failed due to dependency service issue and shouldn't be retried. */
export type NonRetryableDependency = Error & {
  __typename: 'NonRetryableDependency';
  code: ErrorCode;
};

/**
 * Indicates that a data object was not found in the underlying data store.
 * Used in Queries or Mutations.
 */
export type NotFound = Error & {
  __typename: 'NotFound';
  code: ErrorCode;
};

/**
 * A Notification is created for every recipient and holds all needed information for
 * either sending an email or displaying in the UI. It tracks the date on which it was
 * actually sent, along with the unread/read/dismissed status.
 */
export type Notification = {
  __typename: 'Notification';
  actionLabelToken?: Maybe<Scalars['String']>;
  /** Represents a *relative* path within the Partner Network website */
  actionLink?: Maybe<Scalars['String']>;
  creationDate: Scalars['ISODate'];
  id: Scalars['ID'];
  status: NotificationStatus;
  textPlaceholders?: Maybe<Array<Placeholder>>;
  textToken: Scalars['String'];
  titleToken: Scalars['String'];
  type: NotificationType;
};

export type NotificationConnection = Connection & {
  __typename: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo?: Maybe<PageInfo>;
  totalNotificationCount: Scalars['Int'];
};

export type NotificationConnectionResult = ClientError | InvalidCursor | InvalidRequestStructure | NotificationConnection;

export type NotificationEdge = Edge & {
  __typename: 'NotificationEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node: Notification;
};

export enum NotificationStatus {
  Archived = 'ARCHIVED',
  New = 'NEW',
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum NotificationType {
  Alert = 'ALERT',
  Bulletin = 'BULLETIN'
}

export type Occurrence = {
  __typename: 'Occurrence';
  /** Not all events have an end date */
  end?: Maybe<Scalars['ISODate']>;
  /** All events have a start date */
  start: Scalars['ISODate'];
};

export type OnlineAgreement = {
  __typename: 'OnlineAgreement';
  /** Online agreement document content */
  content?: Maybe<Scalars['String']>;
  /** Document ID assigned to the online agreement */
  contentToken: Scalars['ID'];
};

export type OnlineAgreementOrMutationErrors = MutationError | OnlineAgreement;

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type PaginationInput = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Type capturing all data related to the partner account */
export type Partner = {
  __typename: 'Partner';
  /** Whether the partner account is signed up for using the Ads API. */
  accessToAdsAPI?: Maybe<Scalars['Boolean']>;
  /** The current accreditation status of the partner. */
  accreditationStatus?: Maybe<PartnerAccreditationStatus>;
  activeClosedBetasCount?: Maybe<Scalars['Int']>;
  /** A connection for iterating through all the advertisers invites to the partner account. */
  advertiserInvites?: Maybe<PartnerAdvertiserInviteConnection>;
  /** A connection for iterating through advertisers managed by the partner account, 50 records at a time. */
  advertisers?: Maybe<PartnerAdvertiserConnection>;
  advertisingApiAccountsCount?: Maybe<Scalars['Int']>;
  advertisingApiKeysCount?: Maybe<Scalars['Int']>;
  /** Info on when the partner last registered for API access. */
  apiRegistration?: Maybe<ApiRegistration>;
  /** List of all applications currently linked to a Partner */
  applications?: Maybe<Array<PartnerApplication>>;
  /** Awards (badges) assigned to the Partner from BillboardCharts. */
  awards?: Maybe<Array<Maybe<PartnerAward>>>;
  /** Partner badges */
  badges?: Maybe<PartnerBadges>;
  /** Info about PartnerUser certifications */
  certificationData?: Maybe<CertificationData>;
  /** Certifications field to allow querying partner certifications */
  certifications?: Maybe<PartnerCertificationsResult>;
  /**
   * Total count of PartnerUsers linked to the partner, who have at least one unexpired Advertising
   * Learning Console certifications
   */
  certifiedUsersCount?: Maybe<Scalars['Int']>;
  /** The disabled status of the partner account. */
  disabledStatus?: Maybe<PartnerDisabledStatus>;
  /** Published featured content */
  featuredContent?: Maybe<Array<FeaturedContent>>;
  /** Featured content requests field to allow querying partner featured content requests */
  featuredContentRequests?: Maybe<PartnerFeaturedContentRequestsResult>;
  /**
   * Unique partner account id.
   * TODO: https://sim.amazon.com/issues/AAPN-805 -> this is an Amazon Common Identifier (ACI) compliant ID to integrate with Arches
   * TODO: https://sim.amazon.com/issues/AAPN-806 -> this is an Amazon Common Identifier (ACI) compliant ID to integrate with Minos
   */
  id: Scalars['PartnerAccountId'];
  /** Flag to indicate if this account is for internal account */
  isInternal?: Maybe<Scalars['Boolean']>;
  /** Flag to indicate if partner is trusted or not */
  isPartnerTrusted?: Maybe<Scalars['Boolean']>;
  /** Last time a partner admin consented of the Advertising Partner Network legal terms. */
  lastTermConsentDate?: Maybe<Scalars['ISODate']>;
  /** The Directory Listing fields which are typically multiple choice and do not go through moderation. */
  liveDirectoryListingData?: Maybe<UniversalDirectoryListingData>;
  /** The latest, approved, immutable revision of VerifiableRegistration. */
  liveRegistration?: Maybe<VerifiablePartnerRegistration>;
  /** The free-text Directory Listing fields, which can be provided in multiple languages and go through moderation. */
  localizedDirectoryListings?: Maybe<LocalizedDirectoryListings>;
  /** Group summary incase partner is part of a group */
  partnerGroupSummary?: Maybe<PartnerGroupSummary>;
  partnerListingURL?: Maybe<Scalars['HttpsUrl']>;
  /** Partner logo information containing asset and moderation information */
  partnerLogo?: Maybe<PartnerLogo>;
  /**
   * Immutable revision of VerifiableRegistration that goes through Partner Trust verification. If approved, this is copied
   * into the liveAccount.
   * TODO: https://sim.amazon.com/issues/AAPN-838 -> ***change REQUIRED ATTRIBUTE once dependencies support the new model***
   */
  reviewRegistration?: Maybe<VerifiablePartnerRegistration>;
  /** Partner social media information */
  social?: Maybe<Array<SocialData>>;
  /**
   * Total count of advertisers linked to the partner
   * Avoid calling it until this work has been done: https://sim.amazon.com/issues/AAPN-1513
   */
  totalAdvertisersCount?: Maybe<Scalars['Int']>;
  /** Total count of invited advertisers linked to the partner */
  totalInvitedAdvertisersCount?: Maybe<Scalars['Int']>;
  /** Total count of PartnerUser linked to the partner */
  totalUsersCount?: Maybe<Scalars['Int']>;
  /** Registration data that is not subject to moderation */
  unmoderatedRegistrationData?: Maybe<UnmoderatedRegistrationData>;
  /** List of all PartnerUserInvites for a Partner */
  userInvites?: Maybe<Array<Maybe<PartnerUserInvite>>>;
  /** List of all PartnerUsers linked to a Partner */
  users?: Maybe<Array<Maybe<PartnerUser>>>;
};


/** Type capturing all data related to the partner account */
export type PartnerAdvertiserInvitesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
};


/** Type capturing all data related to the partner account */
export type PartnerAdvertisersArgs = {
  after?: Maybe<Scalars['Cursor']>;
};


export enum PartnerAccreditation {
  AdvancedPartner = 'ADVANCED_PARTNER',
  CertifiedPartner = 'CERTIFIED_PARTNER',
  Partner = 'PARTNER',
  VerifiedPartner = 'VERIFIED_PARTNER'
}

/** Details regrading partner accreditation status tier including simple audit info */
export type PartnerAccreditationStatus = {
  __typename: 'PartnerAccreditationStatus';
  expirationDate?: Maybe<Scalars['ISODate']>;
  grantedBy?: Maybe<Scalars['String']>;
  grantedDate?: Maybe<Scalars['ISODate']>;
  revokedBy?: Maybe<Scalars['String']>;
  revokedDate?: Maybe<Scalars['ISODate']>;
  updatedBy: Scalars['String'];
  updatedDate: Scalars['ISODate'];
  value: PartnerAccreditation;
};

export type PartnerAccreditationStatusInfo = {
  __typename: 'PartnerAccreditationStatusInfo';
  lastUpdatedBy: Scalars['String'];
  lastUpdatedDate: Scalars['ISODate'];
  status: AccreditationStatus;
};

export type PartnerAdvertiserConnection = Connection & {
  __typename: 'PartnerAdvertiserConnection';
  edges?: Maybe<Array<Maybe<PartnerAdvertiserEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PartnerAdvertiserEdge = Edge & {
  __typename: 'PartnerAdvertiserEdge';
  accessLevel?: Maybe<AdvertiserAccessLevel>;
  cursor?: Maybe<Scalars['Cursor']>;
  node: Advertiser;
};

export type PartnerAdvertiserInvite = {
  __typename: 'PartnerAdvertiserInvite';
  /** The date the invitation was accepted by the invitee */
  acceptedDate?: Maybe<Scalars['ISODate']>;
  /** The date the invitation was created */
  creationDate: Scalars['ISODate'];
  /** Unique token associated with the invitation */
  invitationToken: Scalars['ID'];
  /** Partner user that initiated the invited */
  invitedBy: User;
  /** Email address of invited advertiser */
  inviteeEmail?: Maybe<Scalars['EmailAddress']>;
  /** Partner account tied to this user */
  partner: Partner;
  /** The date the invitation was revoked */
  revokedDate?: Maybe<Scalars['ISODate']>;
  /** Current status of the invite */
  status: InviteStatus;
};

export type PartnerAdvertiserInviteConnection = Connection & {
  __typename: 'PartnerAdvertiserInviteConnection';
  edges?: Maybe<Array<Maybe<PartnerAdvertiserInviteEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PartnerAdvertiserInviteEdge = Edge & {
  __typename: 'PartnerAdvertiserInviteEdge';
  accessLevel?: Maybe<AdvertiserAccessLevel>;
  cursor?: Maybe<Scalars['Cursor']>;
  node: PartnerAdvertiserInvite;
  requestedOn?: Maybe<Scalars['ISODate']>;
};

export type PartnerAdvertiserInviteResult = ClientError | NotFound | PartnerAdvertiserInvite;

export type PartnerApplication = {
  __typename: 'PartnerApplication';
  /** Field indicating advertiser automapping status */
  advertiserAutomappingStatus: AdvertiserAutomappingStatus;
  /** The ApplicationID of the application as provided by StegoService. Will be of the form "amzn1.application-oa2-client.<28-digit code>" */
  applicationId: Scalars['ID'];
  /** Unique identifier representing the link created between partner and an application. */
  id: Scalars['ID'];
  /** The link status of the application */
  linkStatus?: Maybe<LinkStatus>;
  /** The User who created the link between the Partner & Application. */
  linkedBy?: Maybe<User>;
  /** A timestamp of when the relationship was extablished */
  linkedDate: Scalars['ISODate'];
  /** The Application Name, as provided by StegoService */
  name?: Maybe<Scalars['String']>;
};

/** An Award given to a specific PartnerAccountId. */
export type PartnerAward = {
  __typename: 'PartnerAward';
  awardId: Scalars['ID'];
  /** A list of localized Award details */
  details: Array<LocalizedAwardDetails>;
  grant: PartnerAwardGrantDetails;
  /** The award grant id. This is a composite key of the partner id and the award id */
  id: Scalars['ID'];
  /** The image location for this award */
  imageDownloadLocation?: Maybe<Scalars['HttpsUrl']>;
  partnerId: Scalars['ID'];
  type: AwardType;
};

/** Award details for a specific PartnerAccountId. */
export type PartnerAwardGrantDetails = {
  __typename: 'PartnerAwardGrantDetails';
  /** The date the Partner was granted this award */
  awardedDate: Scalars['ISODate'];
  /** The date the Partner's award expired */
  expirationDate?: Maybe<Scalars['ISODate']>;
  /** The date this award was revoked from this partner */
  revocationDate?: Maybe<Scalars['ISODate']>;
};

/**
 * Top level container for Partner Badges that supports persistence of
 * badges assigned by different sources
 */
export type PartnerBadges = {
  __typename: 'PartnerBadges';
  admin?: Maybe<AssignedPartnerBadges>;
};

export type PartnerCertification = {
  __typename: 'PartnerCertification';
  count: Scalars['Int'];
  tag: CourseTag;
};

export type PartnerCertificationEntries = {
  __typename: 'PartnerCertificationEntries';
  entries?: Maybe<Array<PartnerCertification>>;
};

export type PartnerCertificationsResult = ClientError | PartnerCertificationEntries;

/** Information about the partner and client that is not specific to the featured campaign */
export type PartnerClientBackground = {
  __typename: 'PartnerClientBackground';
  /** The length of time the client has sold products on Amazon */
  clientAmazonTenure?: Maybe<Scalars['String']>;
  /** A summary of what the client company does */
  clientBackground?: Maybe<Scalars['String']>;
  /** The country the client company is based */
  clientCountry?: Maybe<CountryCode>;
  /** The reason the client was looking to work with the partner */
  clientGoal?: Maybe<Scalars['String']>;
  /** A summary of what the partner company does */
  partnerBackground?: Maybe<Scalars['String']>;
  /** The country the partner company is based */
  partnerCountry?: Maybe<CountryCode>;
  /** The partner name by which the case study request should be affiliated */
  partnerName?: Maybe<Scalars['String']>;
};

export type PartnerClientBackgroundInput = {
  /** The length of time the client has sold products on Amazon */
  clientAmazonTenure?: Maybe<Scalars['String']>;
  /** A summary of what the client company does */
  clientBackground?: Maybe<Scalars['String']>;
  /** The region the client company is based */
  clientCountry?: Maybe<CountryCode>;
  /** The reason the client was looking to work with the partner */
  clientGoal?: Maybe<Scalars['String']>;
  /** A summary of what the partner company does */
  partnerBackground?: Maybe<Scalars['String']>;
  /** The region the partner company is based */
  partnerCountry?: Maybe<CountryCode>;
  /** The partner name by which the case study request should be affiliated */
  partnerName?: Maybe<Scalars['String']>;
};

export type PartnerConnection = Connection & {
  __typename: 'PartnerConnection';
  edges?: Maybe<Array<Maybe<PartnerEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalPartnerCount?: Maybe<Scalars['Int']>;
};

/** Details about a given partner account disable/enable performed by an Amazon Admin */
export type PartnerDisabledStatus = {
  __typename: 'PartnerDisabledStatus';
  isDisabled: Scalars['Boolean'];
  updateReason: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedDate: Scalars['ISODate'];
};

export type PartnerEdge = Edge & {
  __typename: 'PartnerEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node: Partner;
};

export type PartnerFeaturedContentRequestsResult = ClientError | FeaturedContentRequestEntries;

export type PartnerGroup = {
  __typename: 'PartnerGroup';
  groupId: Scalars['PartnerAccountId'];
  members: Array<Partner>;
  ownerId: User;
  primaryPartnerAccount: Partner;
};

export type PartnerGroupSummary = {
  __typename: 'PartnerGroupSummary';
  groupId: Scalars['PartnerAccountId'];
  ownerId?: Maybe<User>;
};

/** All information detailing the current lifecycle of a partner logo. */
export type PartnerLogo = {
  __typename: 'PartnerLogo';
  /** Logo asset that has been saved, but not submitted for review. */
  draft: CasAsset;
  /** Latest approved logo asset that is live on the partner record. */
  live?: Maybe<VerifiableLogoAsset>;
  /** Logo asset that is currently in review. */
  review?: Maybe<VerifiableLogoAsset>;
};

/** All necessary data to download a specific version of the partner logo. */
export type PartnerLogoDownloadUrl = {
  __typename: 'PartnerLogoDownloadURL';
  /** The URL to download the partner logo. */
  downloadUrl?: Maybe<Scalars['HttpsUrl']>;
  /** The asset version of the asset referenced by the downloadUrl. */
  downloadVersion?: Maybe<Scalars['Int']>;
};

/** The URL to upload a new partner logo to. */
export type PartnerLogoUploadUrl = {
  __typename: 'PartnerLogoUploadURL';
  /** The URL to upload a new partner logo to. */
  uploadUrl: Scalars['HttpsUrl'];
};

/**
 * TODO: https://sim.amazon.com/issues/AAPN-830 -> profile will undergo a major refactor...leaving alone for now to minimize impacts on dependencies
 * TODO: https://sim.amazon.com/issues/AAPN-839 -> remove references of this type from downstream entities
 * TODO: https://sim.amazon.com/issues/AAPN-840 -> remove this type from the model
 */
export type PartnerProfileInput = {
  additionalLocations?: Maybe<Array<AddressInput>>;
  budgetRequirement?: Maybe<BudgetRequirementInput>;
  businessContactEmail?: Maybe<Scalars['EmailAddress']>;
  businessContactName?: Maybe<DisplayNameInput>;
  companyEmail?: Maybe<Scalars['EmailAddress']>;
  companyHqAddress?: Maybe<AddressInput>;
  companyLeadsWebsite?: Maybe<Scalars['HttpsUrl']>;
  companyLogo?: Maybe<Scalars['HttpsUrl']>;
  companyName?: Maybe<Scalars['String']>;
  companyServiceModels?: Maybe<Array<CompanyServiceModels>>;
  companyServicesProvided?: Maybe<Array<CompanyServicesProvided>>;
  companyWebsite?: Maybe<Scalars['HttpsUrl']>;
  description?: Maybe<Scalars['String']>;
  doesBusinessAs?: Maybe<Array<Scalars['String']>>;
  hasOtherAdvertisingChannels?: Maybe<Scalars['Boolean']>;
  incorporationCountry?: Maybe<CountryCode>;
  industriesServed?: Maybe<Array<IndustriesServed>>;
  isServicesOfferedOnAmazon?: Maybe<Scalars['Boolean']>;
  languagesSupported?: Maybe<Array<LanguagesSupported>>;
  marketplacesServed?: Maybe<Array<AmazonMarketplaces>>;
  otherMarketplacesServed?: Maybe<Array<CountryCode>>;
  parentCompany?: Maybe<Scalars['String']>;
  primaryServicesProvided?: Maybe<Array<PrimaryServices>>;
  productsSupported?: Maybe<Array<ProductsSupported>>;
  regionalOffices?: Maybe<Array<CountryCode>>;
  registrationNumber?: Maybe<Scalars['String']>;
  serviceModels?: Maybe<Array<ServiceModels>>;
  servicesOffered?: Maybe<Array<ServicesOffered>>;
  supportedCustomers?: Maybe<Array<SupportedCustomers>>;
};

/** Type dedicated to partner account registration attributes */
export type PartnerRegistration = {
  __typename: 'PartnerRegistration';
  /** Company address */
  companyAddress: Address;
  /** Company legal name */
  companyName: Scalars['String'];
  /** Official external company website */
  companyWebsite: Scalars['HttpsUrl'];
  /** Optional regional manager account used for conversion to global partner account during registration */
  convertedFromRegionalManagerAccount?: Maybe<RegionalManagerAccount>;
  /**
   * The companay email address domain tied to the Amazon account used to submit the registration. For example, if the
   * full email address for the logged in partner was "johnsmith@amazon.com", then this value would be "amazon.com".
   */
  emailDomain: Scalars['String'];
  /** Country of incorporation */
  incorporationCountry: CountryCode;
  /** Legal registration number of the company. */
  registrationNumber: Scalars['String'];
  /** Unique ID for this immutable snapshot of the account data */
  revision: Scalars['ID'];
  /** Optional notes input by the Partner Admin during submission */
  submissionNotes?: Maybe<Scalars['String']>;
};

/** Whether the user is using a suspected personal email */
export type PartnerRegistrationEligibility = {
  __typename: 'PartnerRegistrationEligibility';
  partnerRegistrationEligibilityResponse: Array<PartnerRegistrationEligibilityType>;
};

export type PartnerRegistrationEligibilityResult = ClientError | PartnerRegistrationEligibility;

export enum PartnerRegistrationEligibilityType {
  SuspectedPersonalEmail = 'SUSPECTED_PERSONAL_EMAIL'
}

export type PartnerUser = {
  __typename: 'PartnerUser';
  /** PartnerUser's expired or non-expired certificates awarded on Advertising Learning Console */
  learningConsoleCertificates?: Maybe<Array<LearningConsoleCertificate>>;
  /** Returning the list of advertisers this account manages */
  managedAdvertisers?: Maybe<Array<PartnerUserAdvertiser>>;
  /** The role defining the access permission of the partner user within the partner account */
  partnerUserRole?: Maybe<PartnerUserRole>;
  /** Identifying information about the user */
  user?: Maybe<User>;
};


export type PartnerUserLearningConsoleCertificatesArgs = {
  fetchExpired?: Maybe<Scalars['Boolean']>;
};

export type PartnerUserAdvertiser = {
  __typename: 'PartnerUserAdvertiser';
  adminId?: Maybe<Scalars['CustomerAccountId']>;
  advertiser?: Maybe<Advertiser>;
};

export type PartnerUserInvite = {
  __typename: 'PartnerUserInvite';
  /** The date the invitation was accepted by the invitee */
  acceptedDate?: Maybe<Scalars['ISODate']>;
  /** The date the invitation was created */
  creationDate?: Maybe<Scalars['ISODate']>;
  /** Expiration date of the invite */
  expirationDate?: Maybe<Scalars['ISODate']>;
  /** Unique identifier of the invitation */
  id: Scalars['ID'];
  /** Partner user that initiated the invited */
  invitedBy?: Maybe<User>;
  /** Email address of invited user */
  inviteeEmail?: Maybe<Scalars['EmailAddress']>;
  /** Name of the invited user */
  inviteeName?: Maybe<Scalars['String']>;
  /** Partner account tied to this user */
  partner: Partner;
  /** The role defining the access permission of the partner user within the partner account */
  partnerUserRole: PartnerUserRole;
  /** The date the invitation was revoked */
  revokedDate?: Maybe<Scalars['ISODate']>;
  /** Current status of the invite */
  status: InviteStatus;
};

export type PartnerUserInviteResult = ClientError | NotFound | PartnerUserInvite;

export type PartnerUserMutationResult = ClientError | InvalidState | NotFound | PartnerUser;

export enum PartnerUserRole {
  Admin = 'ADMIN',
  Associate = 'ASSOCIATE',
  Developer = 'DEVELOPER'
}

export type PendingReport = {
  __typename: 'PendingReport';
  creationDate?: Maybe<Scalars['ISODate']>;
  reportType?: Maybe<ReportType>;
};

/** The URL to download the pdf pitch deck */
export type PitchDeckDownloadUrl = {
  __typename: 'PitchDeckDownloadUrl';
  downloadUrl: Scalars['HttpsUrl'];
};

export type PitchDeckDownloadUrlResult = ClientError | PitchDeckDownloadUrl;

/** Input for Mutation.pitchDeck */
export type PitchDeckInput = {
  locale: DirectoryLocale;
};

export type Placeholder = PlaceholderList | PlaceholderSingle;

export type PlaceholderList = {
  __typename: 'PlaceholderList';
  name: Scalars['String'];
  value?: Maybe<Array<Scalars['String']>>;
};

/**
 * A type to represent a placeholder in a localized string
 * e.g. 'Congratulations, {companyName} has achieved Partner status'
 * In this case the placeholder `name` is 'companyName' and the `value`
 * could be something like 'Awesome Advertising Company'
 */
export type PlaceholderSingle = {
  __typename: 'PlaceholderSingle';
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum PreferredLocale {
  ArAe = 'AR_AE',
  DeDe = 'DE_DE',
  EnAe = 'EN_AE',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnIn = 'EN_IN',
  EnSg = 'EN_SG',
  EnUs = 'EN_US',
  EsCo = 'ES_CO',
  EsEs = 'ES_ES',
  EsMx = 'ES_MX',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  HiIn = 'HI_IN',
  ItIt = 'IT_IT',
  JaJp = 'JA_JP',
  KoKr = 'KO_KR',
  NlNl = 'NL_NL',
  PlPl = 'PL_PL',
  PtBr = 'PT_BR',
  SvSe = 'SV_SE',
  TaIn = 'TA_IN',
  ThTh = 'TH_TH',
  TrTr = 'TR_TR',
  ViVn = 'VI_VN',
  ZhCn = 'ZH_CN',
  ZhTw = 'ZH_TW'
}

export type PreferredLocaleResponse = {
  __typename: 'PreferredLocaleResponse';
  /** True if the value is inferred from defaultPreference and not user preference setting, otherwise false. */
  fromDefaultValue?: Maybe<Scalars['Boolean']>;
  preferredLocale: PreferredLocale;
};

export enum PricingModels {
  AdSpendBasedCommissions = 'AD_SPEND_BASED_COMMISSIONS',
  CustomPackage = 'CUSTOM_PACKAGE',
  FlatMonthlyFee = 'FLAT_MONTHLY_FEE',
  GmsBasedCommissions = 'GMS_BASED_COMMISSIONS',
  ProjectBased = 'PROJECT_BASED'
}

export enum PrimaryContactReason {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  AmazonAdvertisingApi = 'AMAZON_ADVERTISING_API',
  GeneralFeedback = 'GENERAL_FEEDBACK',
  Other = 'OTHER',
  PressRelease = 'PRESS_RELEASE',
  Registration = 'REGISTRATION',
  ReportViolation = 'REPORT_VIOLATION',
  TrademarkUsage = 'TRADEMARK_USAGE'
}

export enum PrimaryServices {
  CampaignManagement = 'CAMPAIGN_MANAGEMENT',
  CreativePlatform = 'CREATIVE_PLATFORM',
  FullService = 'FULL_SERVICE',
  ManagedService = 'MANAGED_SERVICE',
  Measurement = 'MEASUREMENT',
  VendorSellerTools = 'VENDOR_SELLER_TOOLS'
}

export type Principal = {
  rights?: Maybe<Array<Right>>;
};

/** Badge that's associated with a specific ProductsSupported value */
export type ProductBadge = {
  __typename: 'ProductBadge';
  type: BadgeType;
  value: ProductsSupported;
};

export enum ProductsSupported {
  AmazonAttribution = 'AMAZON_ATTRIBUTION',
  AmazonDsp = 'AMAZON_DSP',
  AmazonLive = 'AMAZON_LIVE',
  AmazonMarketingCloud = 'AMAZON_MARKETING_CLOUD',
  AudioAds = 'AUDIO_ADS',
  Posts = 'POSTS',
  SizmekAdSuite = 'SIZMEK_AD_SUITE',
  SponsoredBrands = 'SPONSORED_BRANDS',
  SponsoredDisplay = 'SPONSORED_DISPLAY',
  SponsoredProducts = 'SPONSORED_PRODUCTS',
  Stores = 'STORES',
  VideoAds = 'VIDEO_ADS'
}

export type Query = {
  __typename: 'Query';
  /** Get the PartnerAdvertiserInvite for a given invite id */
  advertiserInvite?: Maybe<PartnerAdvertiserInviteResult>;
  /** Get the most recent Advertisers Report */
  advertiserReport?: Maybe<GetReportResponse>;
  /** Get a download URL to download error report */
  bulkAccountCreationReportDownloadURL: BulkAccountCreationReportDownloadUrlResponse;
  /** Get upload URL to allow uploading the file for bulk account creation */
  bulkAccountCreationRequestUploadURL: BulkAccountCreationRequestUploadUrlResponse;
  /** Template download URL for bulk advertising account creation request */
  bulkAccountCreationTemplateDownloadURL: BulkAccountCreationTemplateDownloadUrlResponse;
  /** List advertising account creation bulk upload history for that partner account */
  bulkAccountCreationUploadHistory?: Maybe<BulkAccountCreationUploadHistoryResponse>;
  /** A connection for searching, filtering, and iterating through all indexed CMS entries. */
  cmsEntries?: Maybe<CmsEntryConnection>;
  /** Retrieve CMS content - utilized for single/detail page views. */
  cmsEntry?: Maybe<CmsEntry>;
  /** Evaluates a list of features */
  evaluateFeatures: Array<FeatureVariations>;
  /** Get user preferences V2 */
  getUserPreferencesV2?: Maybe<UserPreferencesResult>;
  /** Fetch applications of the current logged-in User. The excludeUnscopedApplications boolean will determine whether applications with/without assigned ads API scope will be included in the query */
  linkableApplications?: Maybe<Array<LinkableApplication>>;
  /** A connection for iterating through all the notifications for the currently logged-in user. */
  notifications?: Maybe<NotificationConnectionResult>;
  /** Fetch online agreement */
  onlineAgreement?: Maybe<OnlineAgreement>;
  /** Fetch a Partner given a partner account id */
  partner?: Maybe<Partner>;
  /** Group information where logged in user is the admin. */
  partnerGroup?: Maybe<PartnerGroup>;
  /**
   * Fetch the appropriate partner logo download URL for the specified partner account. If assetType is null, then retrieve
   * an AAPN_PARTNER_LOGO_ORIGINAL download url. If version is null, then retrieve the latest version of the logo asset.
   */
  partnerLogoDownloadURL?: Maybe<PartnerLogoDownloadUrl>;
  /** Fetch the partner logo upload URL for the specified partner account. */
  partnerLogoUploadURL?: Maybe<PartnerLogoUploadUrl>;
  /** Test whether a user email is a suspected personal email */
  partnerRegistrationEligibility?: Maybe<PartnerRegistrationEligibilityResult>;
  /** Fetch PartnerUser information of the current loggedInUser. */
  partnerUser?: Maybe<PartnerUser>;
  /** Fetch PartnerUserInvite based on inviteToken */
  partnerUserInvite?: Maybe<PartnerUserInviteResult>;
  /** Fetch all partners the logged in user has access to. */
  partners?: Maybe<PartnerConnection>;
  /** Fetch any manager accounts that could be promoted to Partner Network */
  promotableManagerAccounts: Array<Maybe<ManagerAccount>>;
  /** Fetch all regional manager accounts. It is expected that a Partner has at most 5 regional manager accounts. */
  regionalManagerAccounts?: Maybe<Array<Maybe<RegionalManagerAccount>>>;
  /** Gets a list of all reports in the ReportList table */
  reportList: Array<Maybe<ReportListResponse>>;
  /** Get all the advertisers that the loggedInUser can link for a given invite id */
  userInvitedAdvertisers?: Maybe<UserInviteAdvertisersResult>;
  /** Fetch details for authentication, authorization, and user settings. */
  whoAmI?: Maybe<AuthPortalPrincipal>;
};


export type QueryAdvertiserInviteArgs = {
  inviteId: Scalars['ID'];
};


export type QueryBulkAccountCreationReportDownloadUrlArgs = {
  input: BulkAccountCreationReportDownloadUrlRequest;
};


export type QueryBulkAccountCreationUploadHistoryArgs = {
  input?: Maybe<BulkAccountCreationUploadHistoryRequest>;
};


export type QueryCmsEntriesArgs = {
  filters?: Maybe<FilterInput>;
  pagination?: Maybe<PaginationInput>;
  search?: Maybe<Scalars['String']>;
  sorts?: Maybe<Array<SortInput>>;
};


export type QueryCmsEntryArgs = {
  id: Scalars['ID'];
};


export type QueryEvaluateFeaturesArgs = {
  input: Array<Scalars['String']>;
};


export type QueryLinkableApplicationsArgs = {
  excludeUnscopedApplications?: Maybe<Scalars['Boolean']>;
};


export type QueryNotificationsArgs = {
  filters?: Maybe<FilterInput>;
  pagination?: Maybe<PaginationInput>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<SortInput>;
};


export type QueryOnlineAgreementArgs = {
  locale: TermsLocale;
};


export type QueryPartnerLogoDownloadUrlArgs = {
  assetType?: Maybe<AssetType>;
  version?: Maybe<Scalars['Int']>;
};


export type QueryPartnerLogoUploadUrlArgs = {
  mediaType: Scalars['String'];
};


export type QueryPartnerUserInviteArgs = {
  inviteToken: Scalars['ID'];
};


export type QueryPartnersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  filters?: Maybe<Array<MultiFilterInput>>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryUserInvitedAdvertisersArgs = {
  inviteId: Scalars['ID'];
};

/** The categorization of different quotes submitted in a featured content request */
export enum QuoteCategory {
  ClientQuoteAdvice = 'CLIENT_QUOTE_ADVICE',
  PartnerQuoteAdvice = 'PARTNER_QUOTE_ADVICE',
  PartnerQuoteStrategy = 'PARTNER_QUOTE_STRATEGY',
  PartnerQuoteSuccess = 'PARTNER_QUOTE_SUCCESS'
}

/** Input for Mutation.redeemPartnerAdvertiserInvite */
export type RedeemPartnerAdvertiserInviteInput = {
  advertiserEntities: Array<AdvertiserEntityInput>;
  inviteId: Scalars['ID'];
};

export type RedeemPartnerAdvertiserInviteResult = ClientError | InvalidState | NotFound | PartnerAdvertiserInvite;

export type RedeemPartnerUserInviteResult = ClientError | InvalidState | NotFound | PartnerUserInvite;

/**
 * Type capturing all data related to a partner regional manager account.
 * This type is used during registration for conversion from regional to global partner accounts.
 */
export type RegionalManagerAccount = {
  __typename: 'RegionalManagerAccount';
  /** ID of the regional manager account */
  id: Scalars['ID'];
  /** Region of the regional manager account */
  region: Scalars['String'];
};

export type RegionalManagerAccountInput = {
  id: Scalars['ID'];
  region: Scalars['String'];
};

/**
 * Rejection reason codes provided by partner trust when they reject a registration or profile request
 * TODO: https://sim.amazon.com/issues/AAPN-812 -> populate with correct registration rejection reasons once partner trust SOP is done
 * TODO: https://sim.amazon.com/issues/AAPN-833 -> populate with correct profile rejection reasons once partner trust SOP is done
 */
export enum RejectionReason {
  AmazonLogo = 'AMAZON_LOGO',
  CompanyNameMismatch = 'COMPANY_NAME_MISMATCH',
  ContactUrlDomainMismatch = 'CONTACT_URL_DOMAIN_MISMATCH',
  ContactUrlNotWorking = 'CONTACT_URL_NOT_WORKING',
  Duplicate = 'DUPLICATE',
  InvalidRelationship = 'INVALID_RELATIONSHIP',
  InvalidWebsiteListing = 'INVALID_WEBSITE_LISTING',
  InvalidWebsiteRegistration = 'INVALID_WEBSITE_REGISTRATION',
  LegacyLogo = 'LEGACY_LOGO',
  LogoMismatch = 'LOGO_MISMATCH',
  LogoQuality = 'LOGO_QUALITY',
  LogoTrademark = 'LOGO_TRADEMARK',
  MarketplaceDeveloperCouncilBadge = 'MARKETPLACE_DEVELOPER_COUNCIL_BADGE',
  NoAccess = 'NO_ACCESS',
  PubliclySharingClientInformation = 'PUBLICLY_SHARING_CLIENT_INFORMATION',
  ServicesDoNotMatch = 'SERVICES_DO_NOT_MATCH',
  ServiceProviderNetworkBadgeLogo = 'SERVICE_PROVIDER_NETWORK_BADGE_LOGO',
  SpellingGrammarIssues = 'SPELLING_GRAMMAR_ISSUES',
  Trademark = 'TRADEMARK',
  TrademarkServicesOffered = 'TRADEMARK_SERVICES_OFFERED',
  UnapprovedMarketing = 'UNAPPROVED_MARKETING',
  UnauthorizedUseOfAmazonAudienceMeasurement = 'UNAUTHORIZED_USE_OF_AMAZON_AUDIENCE_MEASUREMENT',
  UnconfirmedCompany = 'UNCONFIRMED_COMPANY',
  UnconfirmedCompanyName = 'UNCONFIRMED_COMPANY_NAME',
  UnregisteredBusiness = 'UNREGISTERED_BUSINESS',
  UnrelatedEmailDomain = 'UNRELATED_EMAIL_DOMAIN',
  UnrelatedWebsite = 'UNRELATED_WEBSITE',
  UnsubstantiatedClaims = 'UNSUBSTANTIATED_CLAIMS',
  UnsubstantiatedClaimsCertification = 'UNSUBSTANTIATED_CLAIMS_CERTIFICATION',
  UnsubstantiatedClaimsExaggerated = 'UNSUBSTANTIATED_CLAIMS_EXAGGERATED',
  UnsubstantiatedClaimsUnverifiable = 'UNSUBSTANTIATED_CLAIMS_UNVERIFIABLE',
  UnsupportedCountry = 'UNSUPPORTED_COUNTRY',
  WebsiteDomainMismatch = 'WEBSITE_DOMAIN_MISMATCH',
  WrongLanguageEntered = 'WRONG_LANGUAGE_ENTERED'
}

/** Input for Mutation.removePartnerAdvertiser */
export type RemovePartnerAdvertiserInput = {
  advertiserEntity: AdvertiserEntityInput;
};

/** Input for Mutation.RemovePartnerFromGroup */
export type RemovePartnerFromGroupInput = {
  groupId: Scalars['PartnerAccountId'];
  memberId: Scalars['PartnerAccountId'];
};

export type RemovePartnerFromGroupResponse = ClientError | PartnerGroup;

export type ReportFileLocation = {
  __typename: 'ReportFileLocation';
  reportId: Scalars['String'];
  url: Scalars['HttpsUrl'];
};

export type ReportListResponse = {
  __typename: 'ReportListResponse';
  completedAt?: Maybe<Scalars['ISODate']>;
  createdAt: Scalars['ISODate'];
  generatedBy: Scalars['String'];
  id: Scalars['String'];
  location: ReportLocation;
  partnerId: Scalars['PartnerAccountId'];
  reportType: ReportType;
  status: ReportStatus;
  ttl: Scalars['Int'];
};

export type ReportLocation = {
  __typename: 'ReportLocation';
  bucket: Scalars['String'];
  path: Scalars['String'];
};

export enum ReportStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum ReportType {
  Advertisers = 'ADVERTISERS',
  LearningConsoleCertification = 'LEARNING_CONSOLE_CERTIFICATION'
}

export type RequestFileLocation = {
  __typename: 'RequestFileLocation';
  requestId: Scalars['String'];
  url: Scalars['HttpsUrl'];
};

export type ResendPartnerAdvertiserInviteResult = ClientError | NotFound | PartnerAdvertiserInvite;

export type ResendPartnerUserInviteResult = ClientError | NotFound | PartnerUserInvite;

/**
 * Indicates that the requested operation failed, but can be retried without issue.
 * Used in Mutations
 * TODO: These *may* be useful in queries, we should think hard on this, since
 * retryable errors with queries are likely to be retried by MoshPit already.
 * TODO: Mutations are a different beast.
 */
export type Retryable = Error & {
  __typename: 'Retryable';
  code: ErrorCode;
};

/** Indicates that the requested operation failed due to dependency service issue, but can be retried without issue. */
export type RetryableDependency = Error & {
  __typename: 'RetryableDependency';
  code: ErrorCode;
};

export enum Right {
  AdvertiserMappingEdit = 'ADVERTISER_MAPPING_EDIT',
  AdvertiserMappingView = 'ADVERTISER_MAPPING_VIEW',
  ApiRegistrationEdit = 'API_REGISTRATION_EDIT',
  ApiRegistrationView = 'API_REGISTRATION_VIEW',
  BulkAccountCreationEdit = 'BULK_ACCOUNT_CREATION_EDIT',
  CmsDeletedView = 'CMS_DELETED_VIEW',
  CmsEdit = 'CMS_EDIT',
  CmsView = 'CMS_VIEW',
  DeveloperResourcesView = 'DEVELOPER_RESOURCES_VIEW',
  EmailBlocklistEdit = 'EMAIL_BLOCKLIST_EDIT',
  FeaturedContentEdit = 'FEATURED_CONTENT_EDIT',
  GoalPlanEdit = 'GOAL_PLAN_EDIT',
  GoalPlanView = 'GOAL_PLAN_VIEW',
  LwaMappingEdit = 'LWA_MAPPING_EDIT',
  LwaMappingView = 'LWA_MAPPING_VIEW',
  NotificationEdit = 'NOTIFICATION_EDIT',
  NotificationTemplateEdit = 'NOTIFICATION_TEMPLATE_EDIT',
  NotificationTemplateView = 'NOTIFICATION_TEMPLATE_VIEW',
  OpportunitiesView = 'OPPORTUNITIES_VIEW',
  PartnerCompanyAddressView = 'PARTNER_COMPANY_ADDRESS_VIEW',
  PartnerGroupEdit = 'PARTNER_GROUP_EDIT',
  PartnerGroupView = 'PARTNER_GROUP_VIEW',
  PartnerListingReviewView = 'PARTNER_LISTING_REVIEW_VIEW',
  PartnerProfileEdit = 'PARTNER_PROFILE_EDIT',
  PartnerProfileView = 'PARTNER_PROFILE_VIEW',
  PartnerRegistrationEdit = 'PARTNER_REGISTRATION_EDIT',
  PartnerRegistrationView = 'PARTNER_REGISTRATION_VIEW',
  PartnerVerificationView = 'PARTNER_VERIFICATION_VIEW',
  ReportListView = 'REPORT_LIST_VIEW',
  RespondLead = 'RESPOND_LEAD',
  SubmitLead = 'SUBMIT_LEAD',
  UserMappingEdit = 'USER_MAPPING_EDIT',
  UserMappingView = 'USER_MAPPING_VIEW',
  ViewLead = 'VIEW_LEAD'
}

/** S3 storage description */
export type S3StorageLocation = {
  __typename: 'S3StorageLocation';
  /** The key to access the asset (in S3). */
  key: Scalars['String'];
};

export enum SecondaryContactReason {
  Access = 'ACCESS',
  Appeal = 'APPEAL',
  Deactivation = 'DEACTIVATION',
  DirectoryListing = 'DIRECTORY_LISTING',
  HowDoI = 'HOW_DO_I',
  None = 'NONE',
  PartnerStatus = 'PARTNER_STATUS',
  Status = 'STATUS',
  Troubleshooting = 'TROUBLESHOOTING'
}

export type SendPartnerAdvertiserInviteResult = ClientError | PartnerAdvertiserInvite;

export type SendPartnerUserInviteInput = {
  /** Plain or SIF protected email address */
  email: Scalars['String'];
  name: Scalars['String'];
  partnerUserRole: PartnerUserRole;
};

/** Badge that's associated with a specific CompanyServicesProvided value */
export type ServiceBadge = {
  __typename: 'ServiceBadge';
  type: BadgeType;
  value: CompanyServicesProvided;
};

export enum ServiceModels {
  Consultant = 'CONSULTANT',
  Managed = 'MANAGED',
  SelfService = 'SELF_SERVICE'
}

export enum ServicesCategory {
  CreativeAndBrandExp = 'CREATIVE_AND_BRAND_EXP',
  EducationAndTraining = 'EDUCATION_AND_TRAINING',
  Measurement = 'MEASUREMENT',
  MediaPlanningAndBuying = 'MEDIA_PLANNING_AND_BUYING',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  Retail = 'RETAIL'
}

export enum ServicesOffered {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  Display = 'DISPLAY',
  EnchancedBrandContent = 'ENCHANCED_BRAND_CONTENT',
  ECommerce = 'E_COMMERCE',
  FbaShipping = 'FBA_SHIPPING',
  InventoryManagement = 'INVENTORY_MANAGEMENT',
  ListingDetailPageOptimization = 'LISTING_DETAIL_PAGE_OPTIMIZATION',
  Product = 'PRODUCT',
  ProductImaging = 'PRODUCT_IMAGING',
  Search = 'SEARCH'
}

/** Input for Mutation.setUserPreferences */
export type SetUserPreferencesInput = {
  /** Preferred user locale */
  locale?: Maybe<PreferredLocale>;
  /** Preferred partner ID */
  partnerId?: Maybe<Scalars['PartnerAccountId']>;
};

export type SignUpInfo = {
  __typename: 'SignUpInfo';
  customerId: Scalars['CustomerAccountId'];
  user: User;
};

export type SocialData = {
  __typename: 'SocialData';
  /** The social media platform the partner is using, eg, LinkedIN */
  socialPlatform: SocialName;
  /** The URL to the partner social media page */
  socialUrl: Scalars['HttpsUrl'];
  /** The status of the URL and if is active on the Directory Listing or disable by PE agent */
  urlStatus: SocialProfileStatus;
};

/** Input for Mutation.deleteSocialData */
export type SocialDataInput = {
  socialPlatform: SocialName;
  socialUrl: Scalars['HttpsUrl'];
};

/** List of social media platforms supported */
export enum SocialName {
  Linkedin = 'LINKEDIN'
}

/** Used by PE agent to enable or disable a partner social media profile */
export enum SocialProfileStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type SortInput = {
  sortBy: Scalars['String'];
  sortOrder: SortOrder;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Output shape for mutation submitBulkAccountCreation in case of no client error */
export type SubmitBulkAccountCreationOutput = {
  __typename: 'SubmitBulkAccountCreationOutput';
  requestId: Scalars['String'];
  status: BulkAccountCreationRequestStatus;
};

/** Input shape for mutation submitBulkAccountCreation */
export type SubmitBulkAccountCreationRequest = {
  fileName: Scalars['String'];
  requestId: Scalars['String'];
};

export type SubmitBulkAccountCreationResponse = ClientError | SubmitBulkAccountCreationOutput;

/** Input for Mutation.contactUsSubmission */
export type SubmitContactUsInput = {
  description: Scalars['String'];
  primaryContactReason: PrimaryContactReason;
  secondaryContactReason: SecondaryContactReason;
};

/** Input for Mutation.submitPartnerLogo */
export type SubmitPartnerLogoInput = {
  submitForReview?: Maybe<Scalars['Boolean']>;
  version: Scalars['Int'];
};

export type SubmitPartnerLogoResult = ClientError | MutationError | Partner;

/** Input for Mutation.submitRegistration */
export type SubmitPartnerRegistrationInput = {
  companyAddress: AddressInput;
  companyName: Scalars['String'];
  companyWebsite: Scalars['HttpsUrl'];
  convertedFromGlobalManagerAccount?: Maybe<Scalars['ID']>;
  convertedFromRegionalManagerAccount?: Maybe<RegionalManagerAccountInput>;
  incorporationCountry: CountryCode;
  partnerGroupId?: Maybe<Scalars['PartnerAccountId']>;
  registrationLanguage?: Maybe<PreferredLocale>;
  registrationNumber: Scalars['String'];
  submissionNotes?: Maybe<Scalars['String']>;
  unmoderatedRegistrationData?: Maybe<UnmoderatedPartnerRegInput>;
};

export type SubmitPartnerRegistrationResult = ClientError | MutationError | Partner;

export enum SupportedCustomers {
  Advertisers = 'ADVERTISERS',
  Suppliers = 'SUPPLIERS'
}

export type TemplateFileLocation = {
  __typename: 'TemplateFileLocation';
  url: Scalars['HttpsUrl'];
};

export enum TermsLocale {
  ArAe = 'AR_AE',
  DeDe = 'DE_DE',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  JaJp = 'JA_JP',
  NlNl = 'NL_NL',
  PtBr = 'PT_BR',
  ZhCn = 'ZH_CN'
}

/** This contains metadata for a translated message */
export type Translation = {
  __typename: 'Translation';
  /** What language the message is in */
  locale: PreferredLocale;
  /** The message */
  text: Scalars['String'];
};

/** Directory Listing data which has no Localization context and does not go through Moderation. Is typically multiple-choice or numeric */
export type UniversalDirectoryListingData = {
  __typename: 'UniversalDirectoryListingData';
  budgets?: Maybe<Array<BudgetRequirement>>;
  industries?: Maybe<Array<Industries>>;
  languages?: Maybe<Array<LanguagesSupported>>;
  locations?: Maybe<Array<CountryCode>>;
  marketplaces?: Maybe<Array<AmazonMarketplaces>>;
  pricingModels?: Maybe<Array<PricingModels>>;
  products?: Maybe<Array<ProductsSupported>>;
  /** serviceModel is now renamed as 'Company Type' */
  serviceModel?: Maybe<CompanyServiceModels>;
  serviceModels?: Maybe<Array<CompanyListingServiceModels>>;
  services?: Maybe<Array<CompanyServicesProvided>>;
};

export type UniversalListingInput = {
  budgets?: Maybe<Array<BudgetRequirementInput>>;
  industries?: Maybe<Array<Industries>>;
  languages?: Maybe<Array<LanguagesSupported>>;
  locations?: Maybe<Array<CountryCode>>;
  marketplaces?: Maybe<Array<AmazonMarketplaces>>;
  pricingModels?: Maybe<Array<PricingModels>>;
  products?: Maybe<Array<ProductsSupported>>;
  /** serviceModel is now renamed as 'Company Type' */
  serviceModel?: Maybe<CompanyServiceModels>;
  serviceModels?: Maybe<Array<CompanyListingServiceModels>>;
  services?: Maybe<Array<CompanyServicesProvided>>;
};

/** Input for Mutation.UnlinkApplicationInput */
export type UnlinkApplicationInput = {
  /** Unique identifier representing the link created between partner and an application. */
  id: Scalars['ID'];
};

export type UnmoderatedPartnerRegInput = {
  adOffering: Array<AdvertisingOffering>;
  adProductsInterest?: Maybe<Array<ProductsSupported>>;
  advertiserBusinessTypes?: Maybe<Array<AdvertiserBusinessType>>;
  doesCurrentlyAdvertise?: Maybe<Scalars['Boolean']>;
  servicesCategory: Array<ServicesCategory>;
};

export type UnmoderatedRegistrationData = {
  __typename: 'UnmoderatedRegistrationData';
  adOffering: Array<AdvertisingOffering>;
  adProductsInterest?: Maybe<Array<ProductsSupported>>;
  advertiserBusinessTypes?: Maybe<Array<AdvertiserBusinessType>>;
  /** @deprecated Field no longer supported */
  doesCurrentlyAdvertise?: Maybe<Scalars['Boolean']>;
  servicesCategory: Array<ServicesCategory>;
};

/** Input for Mutation.unpublishListing */
export type UnpublishListingInput = {
  locale: DirectoryLocale;
  revision: Scalars['ID'];
};

export type UnpublishListingResult = ClientError | MutationError | Partner;

/** Input for Mutation.unsubmitPartnerLogo */
export type UnsubmitPartnerLogoInput = {
  version: Scalars['Int'];
};

export type UnsubmitPartnerLogoResult = ClientError | MutationError | Partner;

/** Input for Mutation.LinkApplicationInput */
export type UpdateApplicationInput = {
  /** Field indicating advertiser automapping status */
  advertiserAutomappingStatus: AdvertiserAutomappingStatus;
  /** Unique identifier representing the link created between partner and an application. */
  id: Scalars['ID'];
};

export type UpdateApplicationResponse = ApplicationDetails | ClientError;

export type UpdateFeaturedContentRequestInput = {
  featuredContentRequestInput: FeaturedContentRequestInput;
  revision?: Maybe<Scalars['ID']>;
  submitForReview?: Maybe<Scalars['Boolean']>;
};

export type UpdateFeaturedContentRequestResult = ClientError | FeaturedContentRequest | MutationError;

/**
 * Input for Mutation.updateLocalizedListing.
 * Fields:
 *  partnerAccountId: The id for the partner owning the Listing.
 *  locale: The locale specifying which listing is being updated.
 *  localizedListingInput: The data for the listing. Treated as a diff to apply, so no fields are required.
 *  revision: The revision, which is always required, if there is already a draft listing for the specified locale.
 *  submitForReview: A flag. True indicates intent to submit for review the existing data & the diff.
 */
export type UpdateLocalizedListingInput = {
  locale: DirectoryLocale;
  localizedListingInput: LocalizedListingInput;
  revision?: Maybe<Scalars['ID']>;
  submitForReview?: Maybe<Scalars['Boolean']>;
};

export type UpdateLocalizedListingResult = ClientError | MutationError | Partner;

/**
 * Input for Mutation.updatePartnerProfileDraft
 * TODO: https://sim.amazon.com/issues/AAPN-830 -> profile will undergo a major refactor...leaving alone for now to minimize impacts on dependencies
 * TODO: https://sim.amazon.com/issues/AAPN-839 -> remove references of this type from downstream entities
 * TODO: https://sim.amazon.com/issues/AAPN-840 -> remove this type from the model
 */
export type UpdatePartnerProfileDraftInput = {
  /**
   * Data to apply to the draft profile. Partial data will be merged with existing version of
   * the draft.
   */
  partnerProfileInput: PartnerProfileInput;
  /**
   * Set this flag to true to submit the draft version for review for becoming live. Any changes
   * passed to `partnerProfileInput` will be applied before submission.
   * The draft must be in valid state before submission (i.e. `draft.validation.isValid` is true)
   */
  submitForReview?: Maybe<Scalars['Boolean']>;
};

/** Input for Mutation.updateRegistration */
export type UpdatePartnerRegistrationInput = {
  companyName?: Maybe<Scalars['String']>;
  companyWebsite?: Maybe<Scalars['HttpsUrl']>;
  submissionNotes: Scalars['String'];
};

export type UpdatePartnerRegistrationResult = ClientError | MutationError | Partner;

export type UpdatePartnerUserInput = {
  partnerUserRole?: Maybe<PartnerUserRole>;
  userId: Scalars['CustomerAccountId'];
};

/** Input for Mutation.updateSocialData */
export type UpdateSocialDataInput = {
  social?: Maybe<Array<Maybe<SocialDataInput>>>;
};

export type UpdateSocialDataResult = ClientError | MutationError | Partner;

/** Input for Mutation.updateUniversalListing */
export type UpdateUniversalListingInput = {
  submitForReview?: Maybe<Scalars['Boolean']>;
  universalListingInput: UniversalListingInput;
};

export type UpdateUniversalListingResult = ClientError | MutationError | Partner;

export type UpdateUnmoderatedPartnerRegResult = ClientError | MutationError | Partner;

export type User = {
  __typename: 'User';
  /** Email address of the user */
  email?: Maybe<Scalars['EmailAddress']>;
  /** User id of the user */
  id: Scalars['CustomerAccountId'];
  /** Full name of the user */
  name?: Maybe<Scalars['String']>;
};

export type UserInviteAdvertisers = {
  __typename: 'UserInviteAdvertisers';
  advertisers?: Maybe<Array<InvitedAdvertiser>>;
};

export type UserInviteAdvertisersResult = ClientError | InvalidState | NotFound | UserInviteAdvertisers;

export type UserPreferences = {
  __typename: 'UserPreferences';
  locale: PreferredLocaleResponse;
  partnerId?: Maybe<Scalars['PartnerAccountId']>;
};

export type UserPreferencesResult = ClientError | NonRetryableDependency | RetryableDependency | UserPreferences;

export enum Variation {
  C = 'C',
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3'
}

/** Interface for any type that goes through Verification */
export type Verifiable = {
  /** The verification instance */
  verification: Verification;
};

export type VerifiableLocalizedDirectoryListingData = VerifiableWithInitialApproval & {
  __typename: 'VerifiableLocalizedDirectoryListingData';
  data: LocalizedDirectoryListingData;
  firstApprovedDate?: Maybe<Scalars['ISODate']>;
  verification: Verification;
};

/** Contains all necessary information to verify a logo asset. */
export type VerifiableLogoAsset = Verifiable & {
  __typename: 'VerifiableLogoAsset';
  /** The logo asset being verified. */
  logoAsset: CasAsset;
  /** Verification information tracking approval/rejection status. */
  verification: Verification;
};

/** PartnerAccount that must go through verification */
export type VerifiablePartnerRegistration = Verifiable & {
  __typename: 'VerifiablePartnerRegistration';
  /** The Registration that must be verified */
  registration: PartnerRegistration;
  /** The Verification for the PartnerAccount */
  verification: Verification;
};

/** Interface for tracking initial approval date of a Verifiable type */
export type VerifiableWithInitialApproval = {
  firstApprovedDate?: Maybe<Scalars['ISODate']>;
  /** The date that the verification was first approved */
  verification: Verification;
};

/** Type holding verification data that is common to both partner registration and profile submission */
export type Verification = {
  __typename: 'Verification';
  /** The date that the verification was first reviewed. */
  firstReviewedDate?: Maybe<Scalars['ISODate']>;
  /** The date that the verification was first submitted for review. */
  firstSubmittedDate: Scalars['ISODate'];
  /** The date that the verification was last reviewed. */
  lastReviewedDate?: Maybe<Scalars['ISODate']>;
  /** The date that the verification was last submitted for review. */
  lastSubmittedDate: Scalars['ISODate'];
  /** Partner mutable rejection reasons for integrating dynamic rejection reasons. This field will exist alongside static rejection reasons. */
  mutableRejectionReasons?: Maybe<Array<ExternalRejectionReasonObject>>;
  /** Additional information about the rejection reason */
  rejectionDetails?: Maybe<Scalars['String']>;
  /** Reasons the request was rejected */
  rejectionReasons?: Maybe<Array<RejectionReason>>;
  /** Current verification status */
  status: VerificationStatus;
  /**
   * The number of times these attributes have been submitted for verification without being APPROVED. This field is
   * required as it tracks the number of submissions before the first APPROVED status, or since the previous APPROVED
   * status.
   */
  submissionCountWithoutApproval: Scalars['Int'];
  /**
   * The number of times these attributes have been submitted for verification without completing a review. This field is
   * required since it tracks the number of submissions before the first completed review, or since the previous
   * completed review.
   */
  submissionCountWithoutReview: Scalars['Int'];
  /** CaseID to external verification process */
  workflowCaseId?: Maybe<VerificationWorkflowCaseId>;
  /** ID to external verification process */
  workflowId?: Maybe<VerificationWorkflowId>;
};

export enum VerificationStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Unique ID to an external, verification case workflow */
export type VerificationWorkflowCaseId = {
  __typename: 'VerificationWorkflowCaseId';
  /** ID of the external, verification case workflow */
  id: Scalars['ID'];
};

/** Unique ID to an external, verification workflow (e.g. SIM) */
export type VerificationWorkflowId = {
  __typename: 'VerificationWorkflowId';
  /** ID of the external, verification workflow */
  id?: Maybe<Scalars['ID']>;
  /** External entity type */
  type?: Maybe<VerificationWorkflowType>;
};

/** The type of verification workflow */
export enum VerificationWorkflowType {
  Sim = 'SIM',
  SystemPartnerGroup = 'SYSTEM_PARTNER_GROUP'
}

export type DetailFragment = (
  { __typename: 'CMSDetailsLocalized' }
  & Pick<CmsDetailsLocalized, 'title' | 'shortDescription' | 'description'>
  & { assets?: Maybe<Array<(
    { __typename: 'CMSAsset' }
    & Pick<CmsAsset, 'mimeType'>
    & { storageLocation: (
      { __typename: 'S3StorageLocation' }
      & Pick<S3StorageLocation, 'key'>
    ) }
  )>> }
);

export type DetailsFragment = (
  { __typename: 'CMSDetails' }
  & { ar_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, de_DE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_AU?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_GB?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_SG?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, en_US?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, es_CO?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, es_ES?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, es_MX?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, fr_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, fr_FR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, hi_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, it_IT?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, ja_JP?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, ko_KR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, nl_NL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, pl_PL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, pt_BR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, sv_SE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, ta_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, th_TH?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, tr_TR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, vi_VN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, zh_CN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )>, zh_TW?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailFragment
  )> }
);

export type ResourceNodeFragment = (
  { __typename: 'CMSResourceEntry' }
  & Pick<CmsResourceEntry, 'id' | 'resourceCategories' | 'productCategories' | 'tags'>
  & { details?: Maybe<(
    { __typename: 'CMSDetails' }
    & DetailsFragment
  )>, audit: (
    { __typename: 'Audit' }
    & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
  ) }
);

export type EventNodeFragment = (
  { __typename: 'CMSEventEntry' }
  & Pick<CmsEventEntry, 'id' | 'eventType' | 'productCategories' | 'registrationUrl' | 'tags'>
  & { occurrence?: Maybe<(
    { __typename: 'Occurrence' }
    & Pick<Occurrence, 'start' | 'end'>
  )>, location?: Maybe<(
    { __typename: 'Address' }
    & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
  )>, details?: Maybe<(
    { __typename: 'CMSDetails' }
    & DetailsFragment
  )>, audit: (
    { __typename: 'Audit' }
    & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
  ) }
);

export type GetCmsEntriesQueryVariables = Exact<{
  pagination?: Maybe<PaginationInput>;
  filters?: Maybe<FilterInput>;
  sorts?: Maybe<Array<SortInput> | SortInput>;
  search?: Maybe<Scalars['String']>;
}>;


export type GetCmsEntriesQuery = (
  { __typename: 'Query' }
  & { cmsEntries?: Maybe<(
    { __typename: 'CMSEntryConnection' }
    & Pick<CmsEntryConnection, 'totalCMSEntryCount'>
    & { edges: Array<(
      { __typename: 'CMSEntryEdge' }
      & { node: (
        { __typename: 'CMSEventEntry' }
        & EventNodeFragment
      ) | (
        { __typename: 'CMSResourceEntry' }
        & ResourceNodeFragment
      ) }
    )>, pageInfo?: Maybe<(
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    )> }
  )> }
);

export type EvaluateFeaturesQueryVariables = Exact<{
  features: Array<Scalars['String']> | Scalars['String'];
}>;


export type EvaluateFeaturesQuery = (
  { __typename: 'Query' }
  & { evaluateFeatures: Array<(
    { __typename: 'FeatureVariations' }
    & Pick<FeatureVariations, 'feature' | 'variation'>
  )> }
);

export type GetCompanyNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyNameQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'companyName'>
      ) }
    )> }
  )> }
);

export type GetWhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhoAmIQuery = (
  { __typename: 'Query' }
  & { whoAmI?: Maybe<(
    { __typename: 'AuthPortalPrincipal' }
    & Pick<AuthPortalPrincipal, 'rights' | 'userName' | 'userEmail' | 'partnerUserRole'>
  )>, partnerGroup?: Maybe<(
    { __typename: 'PartnerGroup' }
    & Pick<PartnerGroup, 'groupId'>
  )> }
);

export type GetPartnerStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerStatusQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & { badges?: Maybe<(
      { __typename: 'PartnerBadges' }
      & { admin?: Maybe<(
        { __typename: 'AssignedPartnerBadges' }
        & { accreditation?: Maybe<Array<(
          { __typename: 'Accreditation' }
          & Pick<Accreditation, 'type'>
          & { statusInfo: (
            { __typename: 'PartnerAccreditationStatusInfo' }
            & Pick<PartnerAccreditationStatusInfo, 'status' | 'lastUpdatedBy' | 'lastUpdatedDate'>
          ) }
        )>> }
      )> }
    )>, disabledStatus?: Maybe<(
      { __typename: 'PartnerDisabledStatus' }
      & Pick<PartnerDisabledStatus, 'isDisabled' | 'updatedDate'>
    )>, liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'companyName'>
      ), verification: (
        { __typename: 'Verification' }
        & Pick<Verification, 'lastReviewedDate'>
      ) }
    )>, partnerGroupSummary?: Maybe<(
      { __typename: 'PartnerGroupSummary' }
      & Pick<PartnerGroupSummary, 'groupId'>
    )>, accreditationStatus?: Maybe<(
      { __typename: 'PartnerAccreditationStatus' }
      & Pick<PartnerAccreditationStatus, 'value'>
    )> }
  )> }
);

export type GetPartnersQueryVariables = Exact<{
  after?: Maybe<Scalars['Cursor']>;
}>;


export type GetPartnersQuery = (
  { __typename: 'Query' }
  & { partners?: Maybe<(
    { __typename: 'PartnerConnection' }
    & { edges?: Maybe<Array<Maybe<(
      { __typename: 'PartnerEdge' }
      & { node: (
        { __typename: 'Partner' }
        & Pick<Partner, 'id'>
        & { liveRegistration?: Maybe<(
          { __typename: 'VerifiablePartnerRegistration' }
          & { registration: (
            { __typename: 'PartnerRegistration' }
            & Pick<PartnerRegistration, 'companyName'>
          ) }
        )> }
      ) }
    )>>>, pageInfo?: Maybe<(
      { __typename: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
    )> }
  )> }
);

export type SetUserPreferencesMutationVariables = Exact<{
  input: SetUserPreferencesInput;
}>;


export type SetUserPreferencesMutation = (
  { __typename: 'Mutation' }
  & { setUserPreferences?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'NonRetryableDependency' }
    & Pick<NonRetryableDependency, 'code'>
  ) | (
    { __typename: 'RetryableDependency' }
    & Pick<RetryableDependency, 'code'>
  ) | (
    { __typename: 'UserPreferences' }
    & Pick<UserPreferences, 'partnerId'>
    & { locale: (
      { __typename: 'PreferredLocaleResponse' }
      & Pick<PreferredLocaleResponse, 'preferredLocale'>
    ) }
  )> }
);

export type GetUserPreferencesV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesV2Query = (
  { __typename: 'Query' }
  & { getUserPreferencesV2?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'NonRetryableDependency' }
    & Pick<NonRetryableDependency, 'code'>
  ) | (
    { __typename: 'RetryableDependency' }
    & Pick<RetryableDependency, 'code'>
  ) | (
    { __typename: 'UserPreferences' }
    & Pick<UserPreferences, 'partnerId'>
    & { locale: (
      { __typename: 'PreferredLocaleResponse' }
      & Pick<PreferredLocaleResponse, 'preferredLocale'>
    ) }
  )> }
);

export type CampaignDetailsFragment = (
  { __typename: 'CampaignDetails' }
  & Pick<CampaignDetails, 'clientName' | 'clientMCID' | 'campaignTitle' | 'campaignStartDate' | 'campaignEndDate'>
  & { campaignBudget?: Maybe<(
    { __typename: 'Budget' }
    & Pick<Budget, 'amount' | 'currency'>
  )> }
);

export type PartnerClientBackgroundFragment = (
  { __typename: 'PartnerClientBackground' }
  & Pick<PartnerClientBackground, 'partnerName' | 'partnerBackground' | 'partnerCountry' | 'clientBackground' | 'clientCountry' | 'clientAmazonTenure' | 'clientGoal'>
);

export type CaseStudyDetailsFragment = (
  { __typename: 'CaseStudyDetails' }
  & Pick<CaseStudyDetails, 'partnerChallenge' | 'campaignObjectives' | 'successIndicators' | 'deliveryApproach' | 'productsUtilized'>
);

export type CaseStudyOutcomeFragment = (
  { __typename: 'CaseStudyOutcome' }
  & Pick<CaseStudyOutcome, 'implementationSummary' | 'campaignResults' | 'resultsFutureUsage'>
);

export type FeaturedContentRequestInfoFragment = (
  { __typename: 'FeaturedContentRequestInfo' }
  & Pick<FeaturedContentRequestInfo, 'revision'>
  & { campaignDetails?: Maybe<(
    { __typename: 'CampaignDetails' }
    & CampaignDetailsFragment
  )>, partnerClientBackground?: Maybe<(
    { __typename: 'PartnerClientBackground' }
    & PartnerClientBackgroundFragment
  )>, caseStudyDetails?: Maybe<(
    { __typename: 'CaseStudyDetails' }
    & CaseStudyDetailsFragment
  )>, outcome?: Maybe<(
    { __typename: 'CaseStudyOutcome' }
    & CaseStudyOutcomeFragment
  )>, quotes?: Maybe<Array<Maybe<(
    { __typename: 'CaseStudyQuote' }
    & Pick<CaseStudyQuote, 'quote' | 'quoteType'>
  )>>> }
);

export type MutationArgumentErrorDataFragment = (
  { __typename: 'MutationArgumentError' }
  & Pick<MutationArgumentError, 'argumentName'>
  & { fieldErrors?: Maybe<Array<(
    { __typename: 'FieldError' }
    & Pick<FieldError, 'name' | 'reason'>
  )>> }
);

export type UpdateFeaturedContentRequestMutationVariables = Exact<{
  input: UpdateFeaturedContentRequestInput;
}>;


export type UpdateFeaturedContentRequestMutation = (
  { __typename: 'Mutation' }
  & { updateFeaturedContentRequest?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'FeaturedContentRequest' }
    & Pick<FeaturedContentRequest, 'id'>
    & { draft: (
      { __typename: 'FeaturedContentRequestInfo' }
      & FeaturedContentRequestInfoFragment
    ), live?: Maybe<(
      { __typename: 'FeaturedContentRequestSubmission' }
      & { featuredContentRequestInfo: (
        { __typename: 'FeaturedContentRequestInfo' }
        & FeaturedContentRequestInfoFragment
      ) }
    )> }
  ) | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  )> }
);

export type FeaturedContentRequestFragment = (
  { __typename: 'FeaturedContentRequest' }
  & Pick<FeaturedContentRequest, 'id' | 'locale'>
  & { draft: (
    { __typename: 'FeaturedContentRequestInfo' }
    & FeaturedContentRequestInfoFragment
  ), live?: Maybe<(
    { __typename: 'FeaturedContentRequestSubmission' }
    & { featuredContentRequestInfo: (
      { __typename: 'FeaturedContentRequestInfo' }
      & FeaturedContentRequestInfoFragment
    ) }
  )>, auditInfo: (
    { __typename: 'Audit' }
    & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
  ) }
);

export type FeaturedContentRequestEntriesFragment = (
  { __typename: 'FeaturedContentRequestEntries' }
  & { entries?: Maybe<Array<(
    { __typename: 'FeaturedContentRequest' }
    & FeaturedContentRequestFragment
  )>> }
);

export type GetFeaturedContentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedContentRequestsQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { featuredContentRequests?: Maybe<{ __typename: 'ClientError' } | (
      { __typename: 'FeaturedContentRequestEntries' }
      & FeaturedContentRequestEntriesFragment
    )> }
  )> }
);

export type LocalizedDirectoryDataFragment = (
  { __typename: 'LocalizedDirectoryListingData' }
  & Pick<LocalizedDirectoryListingData, 'revision' | 'displayName' | 'description' | 'externalHomeUrl' | 'contactUrl'>
);

export type VerificationDataFragment = (
  { __typename: 'Verification' }
  & Pick<Verification, 'status' | 'rejectionReasons' | 'rejectionDetails'>
  & { mutableRejectionReasons?: Maybe<Array<(
    { __typename: 'ExternalRejectionReasonObject' }
    & Pick<ExternalRejectionReasonObject, 'id' | 'message' | 'helpContentIds' | 'version'>
    & { translations: Array<(
      { __typename: 'Translation' }
      & Pick<Translation, 'text' | 'locale'>
    )> }
  )>> }
);

export type VerifiableLocalizedDirectoryDataFragment = (
  { __typename: 'VerifiableLocalizedDirectoryListingData' }
  & { data: (
    { __typename: 'LocalizedDirectoryListingData' }
    & LocalizedDirectoryDataFragment
  ), verification: (
    { __typename: 'Verification' }
    & VerificationDataFragment
  ) }
);

export type LocalizedDirectoryScopesFragment = (
  { __typename: 'LocalizedDirectoryListing' }
  & { draft: (
    { __typename: 'LocalizedDirectoryListingData' }
    & LocalizedDirectoryDataFragment
  ), review?: Maybe<(
    { __typename: 'VerifiableLocalizedDirectoryListingData' }
    & VerifiableLocalizedDirectoryDataFragment
  )>, live?: Maybe<(
    { __typename: 'VerifiableLocalizedDirectoryListingData' }
    & VerifiableLocalizedDirectoryDataFragment
  )> }
);

export type LocalizedDirectoriesFragment = (
  { __typename: 'LocalizedDirectoryListings' }
  & { ar_ae?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, de_de?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, en_us?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, es_es?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, fr_fr?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, it_it?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, ja_jp?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, ko_kr?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, nl_nl?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, pl_pl?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, pt_br?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, sv_se?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, tr_tr?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )>, zh_cn?: Maybe<(
    { __typename: 'LocalizedDirectoryListing' }
    & LocalizedDirectoryScopesFragment
  )> }
);

export type UniversalListingDataFragment = (
  { __typename: 'UniversalDirectoryListingData' }
  & Pick<UniversalDirectoryListingData, 'serviceModel' | 'services' | 'products' | 'serviceModels' | 'industries' | 'pricingModels' | 'marketplaces' | 'locations'>
  & { budgets?: Maybe<Array<(
    { __typename: 'BudgetRequirement' }
    & Pick<BudgetRequirement, 'minimum' | 'maximum' | 'currency'>
  )>> }
);

export type CasAssetDataFragment = (
  { __typename: 'CASAsset' }
  & Pick<CasAsset, 'assetId' | 'assetType' | 'version'>
);

export type VerifiableCasAssetDataFragment = (
  { __typename: 'VerifiableLogoAsset' }
  & { logoAsset: (
    { __typename: 'CASAsset' }
    & CasAssetDataFragment
  ), verification: (
    { __typename: 'Verification' }
    & VerificationDataFragment
  ) }
);

export type PartnerLogoDataFragment = (
  { __typename: 'PartnerLogo' }
  & { draft: (
    { __typename: 'CASAsset' }
    & CasAssetDataFragment
  ), review?: Maybe<(
    { __typename: 'VerifiableLogoAsset' }
    & VerifiableCasAssetDataFragment
  )>, live?: Maybe<(
    { __typename: 'VerifiableLogoAsset' }
    & VerifiableCasAssetDataFragment
  )> }
);

export type BadgesDataFragment = (
  { __typename: 'PartnerBadges' }
  & { admin?: Maybe<(
    { __typename: 'AssignedPartnerBadges' }
    & { directoryListing?: Maybe<(
      { __typename: 'DirectoryListingBadges' }
      & { products?: Maybe<Array<(
        { __typename: 'ProductBadge' }
        & Pick<ProductBadge, 'type' | 'value'>
      )>>, services?: Maybe<Array<(
        { __typename: 'ServiceBadge' }
        & Pick<ServiceBadge, 'type' | 'value'>
      )>> }
    )>, accreditation?: Maybe<Array<(
      { __typename: 'Accreditation' }
      & Pick<Accreditation, 'type'>
      & { statusInfo: (
        { __typename: 'PartnerAccreditationStatusInfo' }
        & Pick<PartnerAccreditationStatusInfo, 'status' | 'lastUpdatedBy' | 'lastUpdatedDate'>
      ) }
    )>> }
  )> }
);

export type DlCampaignDetailsFragment = (
  { __typename: 'CampaignDetails' }
  & Pick<CampaignDetails, 'clientName' | 'clientMCID' | 'campaignTitle' | 'campaignStartDate' | 'campaignEndDate'>
  & { campaignBudget?: Maybe<(
    { __typename: 'Budget' }
    & Pick<Budget, 'amount' | 'currency'>
  )> }
);

export type DlPartnerClientBackgroundFragment = (
  { __typename: 'PartnerClientBackground' }
  & Pick<PartnerClientBackground, 'partnerBackground' | 'partnerCountry' | 'clientBackground' | 'clientCountry' | 'clientAmazonTenure' | 'clientGoal'>
);

export type DlCaseStudyDetailsFragment = (
  { __typename: 'CaseStudyDetails' }
  & Pick<CaseStudyDetails, 'partnerChallenge' | 'campaignObjectives' | 'successIndicators' | 'deliveryApproach' | 'productsUtilized'>
);

export type DlCaseStudyOutcomeFragment = (
  { __typename: 'CaseStudyOutcome' }
  & Pick<CaseStudyOutcome, 'implementationSummary' | 'campaignResults' | 'resultsFutureUsage'>
);

export type DlFeaturedContentRequestInfoFragment = (
  { __typename: 'FeaturedContentRequestInfo' }
  & Pick<FeaturedContentRequestInfo, 'revision'>
  & { campaignDetails?: Maybe<(
    { __typename: 'CampaignDetails' }
    & DlCampaignDetailsFragment
  )>, partnerClientBackground?: Maybe<(
    { __typename: 'PartnerClientBackground' }
    & DlPartnerClientBackgroundFragment
  )>, caseStudyDetails?: Maybe<(
    { __typename: 'CaseStudyDetails' }
    & DlCaseStudyDetailsFragment
  )>, outcome?: Maybe<(
    { __typename: 'CaseStudyOutcome' }
    & DlCaseStudyOutcomeFragment
  )>, quotes?: Maybe<Array<Maybe<(
    { __typename: 'CaseStudyQuote' }
    & Pick<CaseStudyQuote, 'quote' | 'quoteType'>
  )>>> }
);

export type DlFeaturedContentRequestFragment = (
  { __typename: 'FeaturedContentRequest' }
  & Pick<FeaturedContentRequest, 'id' | 'locale'>
  & { draft: (
    { __typename: 'FeaturedContentRequestInfo' }
    & DlFeaturedContentRequestInfoFragment
  ), live?: Maybe<(
    { __typename: 'FeaturedContentRequestSubmission' }
    & { featuredContentRequestInfo: (
      { __typename: 'FeaturedContentRequestInfo' }
      & DlFeaturedContentRequestInfoFragment
    ) }
  )>, auditInfo: (
    { __typename: 'Audit' }
    & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
  ) }
);

export type DlFeaturedContentRequestEntriesFragment = (
  { __typename: 'FeaturedContentRequestEntries' }
  & { entries?: Maybe<Array<(
    { __typename: 'FeaturedContentRequest' }
    & DlFeaturedContentRequestFragment
  )>> }
);

export type SocialDataFragment = (
  { __typename: 'SocialData' }
  & Pick<SocialData, 'socialPlatform' | 'socialUrl' | 'urlStatus'>
);

export type CaseStudyFragment = (
  { __typename: 'CaseStudy' }
  & Pick<CaseStudy, 'contentUrlKey' | 'lastUpdatedBy' | 'lastUpdatedDate'>
);

export type GetDirectoryListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDirectoryListingsQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { accreditationStatus?: Maybe<(
      { __typename: 'PartnerAccreditationStatus' }
      & Pick<PartnerAccreditationStatus, 'value' | 'updatedDate' | 'updatedBy'>
    )>, badges?: Maybe<(
      { __typename: 'PartnerBadges' }
      & BadgesDataFragment
    )>, liveDirectoryListingData?: Maybe<(
      { __typename: 'UniversalDirectoryListingData' }
      & UniversalListingDataFragment
    )>, localizedDirectoryListings?: Maybe<(
      { __typename: 'LocalizedDirectoryListings' }
      & LocalizedDirectoriesFragment
    )>, partnerLogo?: Maybe<(
      { __typename: 'PartnerLogo' }
      & PartnerLogoDataFragment
    )>, social?: Maybe<Array<(
      { __typename: 'SocialData' }
      & SocialDataFragment
    )>>, featuredContentRequests?: Maybe<{ __typename: 'ClientError' } | (
      { __typename: 'FeaturedContentRequestEntries' }
      & DlFeaturedContentRequestEntriesFragment
    )>, featuredContent?: Maybe<Array<(
      { __typename: 'CaseStudy' }
      & Pick<CaseStudy, 'id'>
      & CaseStudyFragment
    )>> }
  )> }
);

export type GetSocialDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSocialDataQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { accreditationStatus?: Maybe<(
      { __typename: 'PartnerAccreditationStatus' }
      & Pick<PartnerAccreditationStatus, 'value' | 'updatedDate' | 'updatedBy'>
    )>, social?: Maybe<Array<(
      { __typename: 'SocialData' }
      & SocialDataFragment
    )>> }
  )> }
);

export type UpdateSocialDataMutationVariables = Exact<{
  input: UpdateSocialDataInput;
}>;


export type UpdateSocialDataMutation = (
  { __typename: 'Mutation' }
  & { updateSocialData?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { social?: Maybe<Array<(
      { __typename: 'SocialData' }
      & SocialDataFragment
    )>> }
  )> }
);

export type DeleteSocialDataMutationVariables = Exact<{
  input: SocialDataInput;
}>;


export type DeleteSocialDataMutation = (
  { __typename: 'Mutation' }
  & { deleteSocialData?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { social?: Maybe<Array<(
      { __typename: 'SocialData' }
      & SocialDataFragment
    )>> }
  )> }
);

export type UpdateUniversalListingMutationVariables = Exact<{
  input: UpdateUniversalListingInput;
}>;


export type UpdateUniversalListingMutation = (
  { __typename: 'Mutation' }
  & { updateUniversalListing?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { liveDirectoryListingData?: Maybe<(
      { __typename: 'UniversalDirectoryListingData' }
      & UniversalListingDataFragment
    )> }
  )> }
);

export type UpdateLocalizedListingMutationVariables = Exact<{
  input: UpdateLocalizedListingInput;
}>;


export type UpdateLocalizedListingMutation = (
  { __typename: 'Mutation' }
  & { updateLocalizedListing?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { localizedDirectoryListings?: Maybe<(
      { __typename: 'LocalizedDirectoryListings' }
      & LocalizedDirectoriesFragment
    )> }
  )> }
);

export type DeleteListingSubmissionMutationVariables = Exact<{
  input: DeleteListingSubmissionInput;
}>;


export type DeleteListingSubmissionMutation = (
  { __typename: 'Mutation' }
  & { deleteListingSubmission?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { localizedDirectoryListings?: Maybe<(
      { __typename: 'LocalizedDirectoryListings' }
      & LocalizedDirectoriesFragment
    )> }
  )> }
);

export type UnpublishListingMutationVariables = Exact<{
  input: UnpublishListingInput;
}>;


export type UnpublishListingMutation = (
  { __typename: 'Mutation' }
  & { unpublishListing?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { localizedDirectoryListings?: Maybe<(
      { __typename: 'LocalizedDirectoryListings' }
      & LocalizedDirectoriesFragment
    )> }
  )> }
);

export type GetLogoDownloadQueryVariables = Exact<{
  version?: Maybe<Scalars['Int']>;
}>;


export type GetLogoDownloadQuery = (
  { __typename: 'Query' }
  & { partnerLogoDownloadURL?: Maybe<(
    { __typename: 'PartnerLogoDownloadURL' }
    & Pick<PartnerLogoDownloadUrl, 'downloadUrl' | 'downloadVersion'>
  )> }
);

export type GetLogoUploadQueryVariables = Exact<{
  mediaType: Scalars['String'];
}>;


export type GetLogoUploadQuery = (
  { __typename: 'Query' }
  & { partnerLogoUploadURL?: Maybe<(
    { __typename: 'PartnerLogoUploadURL' }
    & Pick<PartnerLogoUploadUrl, 'uploadUrl'>
  )> }
);

export type SubmitPartnerLogoMutationVariables = Exact<{
  input: SubmitPartnerLogoInput;
}>;


export type SubmitPartnerLogoMutation = (
  { __typename: 'Mutation' }
  & { submitPartnerLogo?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { partnerLogo?: Maybe<(
      { __typename: 'PartnerLogo' }
      & PartnerLogoDataFragment
    )> }
  )> }
);

export type UnsubmitPartnerLogoMutationVariables = Exact<{
  input: UnsubmitPartnerLogoInput;
}>;


export type UnsubmitPartnerLogoMutation = (
  { __typename: 'Mutation' }
  & { unsubmitPartnerLogo?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { partnerLogo?: Maybe<(
      { __typename: 'PartnerLogo' }
      & PartnerLogoDataFragment
    )> }
  )> }
);

export type PitchDeckMutationVariables = Exact<{
  input: PitchDeckInput;
}>;


export type PitchDeckMutation = (
  { __typename: 'Mutation' }
  & { pitchDeck?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  ) | (
    { __typename: 'PitchDeckDownloadUrl' }
    & Pick<PitchDeckDownloadUrl, 'downloadUrl'>
  )> }
);

export type UpdatePartnerRegistrationMutationVariables = Exact<{
  updateRegistrationInput: UpdatePartnerRegistrationInput;
}>;


export type UpdatePartnerRegistrationMutation = (
  { __typename: 'Mutation' }
  & { updatePartnerRegistration?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & Pick<MutationArgumentError, 'argumentName'>
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { reviewRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes' | 'emailDomain'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ), verification: (
        { __typename: 'Verification' }
        & Pick<Verification, 'status' | 'rejectionReasons' | 'rejectionDetails' | 'lastSubmittedDate' | 'lastReviewedDate'>
        & { mutableRejectionReasons?: Maybe<Array<(
          { __typename: 'ExternalRejectionReasonObject' }
          & Pick<ExternalRejectionReasonObject, 'id' | 'message' | 'helpContentIds' | 'version'>
          & { translations: Array<(
            { __typename: 'Translation' }
            & Pick<Translation, 'text' | 'locale'>
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type UpdateUnmoderatedPartnerRegMutationVariables = Exact<{
  input: UnmoderatedPartnerRegInput;
}>;


export type UpdateUnmoderatedPartnerRegMutation = (
  { __typename: 'Mutation' }
  & { updateUnmoderatedPartnerReg?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & Pick<MutationArgumentError, 'argumentName'>
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { unmoderatedRegistrationData?: Maybe<(
      { __typename: 'UnmoderatedRegistrationData' }
      & Pick<UnmoderatedRegistrationData, 'adOffering' | 'servicesCategory' | 'advertiserBusinessTypes' | 'adProductsInterest'>
    )> }
  )> }
);

export type GetPartnerRegistrationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerRegistrationInfoQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { reviewRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ), verification: (
        { __typename: 'Verification' }
        & Pick<Verification, 'status' | 'rejectionReasons' | 'rejectionDetails' | 'lastSubmittedDate' | 'lastReviewedDate'>
        & { mutableRejectionReasons?: Maybe<Array<(
          { __typename: 'ExternalRejectionReasonObject' }
          & Pick<ExternalRejectionReasonObject, 'id' | 'message' | 'helpContentIds' | 'version'>
          & { translations: Array<(
            { __typename: 'Translation' }
            & Pick<Translation, 'text' | 'locale'>
          )> }
        )>> }
      ) }
    )>, liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ) }
    )>, unmoderatedRegistrationData?: Maybe<(
      { __typename: 'UnmoderatedRegistrationData' }
      & Pick<UnmoderatedRegistrationData, 'adOffering' | 'servicesCategory' | 'advertiserBusinessTypes' | 'adProductsInterest'>
    )> }
  )> }
);

export type VerifyEmailMutationVariables = Exact<{
  input: UpdatePartnerProfileDraftInput;
}>;


export type VerifyEmailMutation = (
  { __typename: 'Mutation' }
  & { updatePartnerProfileDraft?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
  )> }
);

export type EventDetailsFieldsFragment = (
  { __typename: 'CMSDetailsLocalized' }
  & Pick<CmsDetailsLocalized, 'title' | 'shortDescription' | 'description'>
);

export type EventDetailsLocaleFieldsFragment = (
  { __typename: 'CMSDetails' }
  & { ar_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, cs_CZ?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, de_DE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_AU?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_GB?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_SG?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, en_US?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, es_CO?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, es_ES?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, es_MX?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, es_US?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, fr_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, fr_FR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, he_IL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, hi_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, it_IT?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, ja_JP?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, kn_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, ko_KR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, nl_NL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, pl_PL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, pt_BR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, sv_SE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, ta_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, te_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, th_TH?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, tr_TR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, vi_VN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, zh_CN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )>, zh_TW?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & EventDetailsFieldsFragment
  )> }
);

export type GetEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEventQuery = (
  { __typename: 'Query' }
  & { cmsEntry?: Maybe<(
    { __typename: 'CMSEventEntry' }
    & Pick<CmsEventEntry, 'registrationUrl' | 'id' | 'deleted' | 'featured' | 'productCategories' | 'tags' | 'targetSegments'>
    & { occurrence?: Maybe<(
      { __typename: 'Occurrence' }
      & Pick<Occurrence, 'start' | 'end'>
    )>, location?: Maybe<(
      { __typename: 'Address' }
      & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
    )>, audit: (
      { __typename: 'Audit' }
      & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
    ), details?: Maybe<(
      { __typename: 'CMSDetails' }
      & EventDetailsLocaleFieldsFragment
    )> }
  ) | (
    { __typename: 'CMSResourceEntry' }
    & Pick<CmsResourceEntry, 'id' | 'deleted' | 'featured' | 'productCategories' | 'tags' | 'targetSegments'>
    & { audit: (
      { __typename: 'Audit' }
      & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
    ), details?: Maybe<(
      { __typename: 'CMSDetails' }
      & EventDetailsLocaleFieldsFragment
    )> }
  )> }
);

export type GetAdvertiserInviteQueryVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type GetAdvertiserInviteQuery = (
  { __typename: 'Query' }
  & { advertiserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerAdvertiserInvite' }
    & Pick<PartnerAdvertiserInvite, 'status'>
    & { partner: (
      { __typename: 'Partner' }
      & { liveRegistration?: Maybe<(
        { __typename: 'VerifiablePartnerRegistration' }
        & { registration: (
          { __typename: 'PartnerRegistration' }
          & Pick<PartnerRegistration, 'companyName' | 'companyWebsite'>
        ) }
      )> }
    ) }
  )> }
);

export type GetUserInvitedAdvertisersQueryVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type GetUserInvitedAdvertisersQuery = (
  { __typename: 'Query' }
  & { userInvitedAdvertisers?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'InvalidState' }
    & Pick<InvalidState, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'UserInviteAdvertisers' }
    & { advertisers?: Maybe<Array<(
      { __typename: 'InvitedAdvertiser' }
      & Pick<InvitedAdvertiser, 'isLinked'>
      & { advertiser?: Maybe<(
        { __typename: 'Advertiser' }
        & Pick<Advertiser, 'id' | 'name' | 'type' | 'countryCode'>
      )> }
    )>> }
  )> }
);

export type RedeemPartnerAdvertiserInviteMutationVariables = Exact<{
  input: RedeemPartnerAdvertiserInviteInput;
}>;


export type RedeemPartnerAdvertiserInviteMutation = (
  { __typename: 'Mutation' }
  & { redeemPartnerAdvertiserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | { __typename: 'InvalidState' } | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerAdvertiserInvite' }
    & Pick<PartnerAdvertiserInvite, 'status'>
  )> }
);

export type GetPartnerUserInviteQueryVariables = Exact<{
  inviteToken: Scalars['ID'];
}>;


export type GetPartnerUserInviteQuery = (
  { __typename: 'Query' }
  & { partnerUserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerUserInvite' }
    & Pick<PartnerUserInvite, 'id' | 'creationDate' | 'revokedDate' | 'acceptedDate' | 'expirationDate' | 'status'>
    & { invitedBy?: Maybe<(
      { __typename: 'User' }
      & Pick<User, 'id' | 'name'>
    )>, partner: (
      { __typename: 'Partner' }
      & Pick<Partner, 'id'>
      & { liveRegistration?: Maybe<(
        { __typename: 'VerifiablePartnerRegistration' }
        & { registration: (
          { __typename: 'PartnerRegistration' }
          & Pick<PartnerRegistration, 'companyName'>
        ) }
      )> }
    ) }
  )> }
);

export type RedeemPartnerUserInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type RedeemPartnerUserInviteMutation = (
  { __typename: 'Mutation' }
  & { redeemPartnerUserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'InvalidState' }
    & Pick<InvalidState, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerUserInvite' }
    & PartnerUserInviteFragment
  )> }
);

export type SubmitBulkAccountCreationMutationVariables = Exact<{
  input: SubmitBulkAccountCreationRequest;
}>;


export type SubmitBulkAccountCreationMutation = (
  { __typename: 'Mutation' }
  & { submitBulkAccountCreation?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  ) | (
    { __typename: 'SubmitBulkAccountCreationOutput' }
    & Pick<SubmitBulkAccountCreationOutput, 'requestId' | 'status'>
  )> }
);

export type GetBulkAccountCreationRequestUploadUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBulkAccountCreationRequestUploadUrlQuery = (
  { __typename: 'Query' }
  & { bulkAccountCreationRequestUploadURL: (
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  ) | (
    { __typename: 'RequestFileLocation' }
    & Pick<RequestFileLocation, 'url' | 'requestId'>
  ) }
);

export type GetBulkAccountsCreationReportDownloadUrlQueryVariables = Exact<{
  input: BulkAccountCreationReportDownloadUrlRequest;
}>;


export type GetBulkAccountsCreationReportDownloadUrlQuery = (
  { __typename: 'Query' }
  & { bulkAccountCreationReportDownloadURL: (
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  ) | (
    { __typename: 'ReportFileLocation' }
    & Pick<ReportFileLocation, 'url' | 'reportId'>
  ) }
);

export type GetBulkAccountsCreationTemplateDownloadUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBulkAccountsCreationTemplateDownloadUrlQuery = (
  { __typename: 'Query' }
  & { bulkAccountCreationTemplateDownloadURL: (
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  ) | (
    { __typename: 'TemplateFileLocation' }
    & Pick<TemplateFileLocation, 'url'>
  ) }
);

export type GetBulkAccountsCreationHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBulkAccountsCreationHistoryQuery = (
  { __typename: 'Query' }
  & { bulkAccountCreationUploadHistory?: Maybe<(
    { __typename: 'BulkAccountCreationUploadHistoryOutput' }
    & { uploadRequests: Array<(
      { __typename: 'BulkAccountCreationSubmission' }
      & Pick<BulkAccountCreationSubmission, 'fileName' | 'customerEmail' | 'failedReason' | 'numberOfCreatedAccounts' | 'reportId' | 'status' | 'totalRequestedAccounts' | 'submittedAt'>
    )> }
  ) | (
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  )> }
);

export type GetPartnerInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerInfoQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id' | 'isPartnerTrusted'>
    & { liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ) }
    )> }
  )> }
);

export type PartnerAdvertiserInviteFragment = (
  { __typename: 'PartnerAdvertiserInvite' }
  & Pick<PartnerAdvertiserInvite, 'invitationToken' | 'inviteeEmail' | 'creationDate' | 'status'>
);

export type GetAdvertiserInvitesQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Cursor']>;
}>;


export type GetAdvertiserInvitesQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { advertiserInvites?: Maybe<(
      { __typename: 'PartnerAdvertiserInviteConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename: 'PartnerAdvertiserInviteEdge' }
        & { node: (
          { __typename: 'PartnerAdvertiserInvite' }
          & PartnerAdvertiserInviteFragment
        ) }
      )>>>, pageInfo?: Maybe<(
        { __typename: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
      )> }
    )> }
  )> }
);

export type SendPartnerAdvertiserInviteMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPartnerAdvertiserInviteMutation = (
  { __typename: 'Mutation' }
  & { sendPartnerAdvertiserInvite?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'PartnerAdvertiserInvite' }
    & PartnerAdvertiserInviteFragment
  )> }
);

export type ResendPartnerAdvertiserInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type ResendPartnerAdvertiserInviteMutation = (
  { __typename: 'Mutation' }
  & { resendPartnerAdvertiserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerAdvertiserInvite' }
    & PartnerAdvertiserInviteFragment
  )> }
);

export type DeletePartnerAdvertiserInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type DeletePartnerAdvertiserInviteMutation = (
  { __typename: 'Mutation' }
  & { deletePartnerAdvertiserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerAdvertiserInvite' }
    & PartnerAdvertiserInviteFragment
  )> }
);

export type GetPartnerUserAdvertisersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerUserAdvertisersQuery = (
  { __typename: 'Query' }
  & { partnerUser?: Maybe<(
    { __typename: 'PartnerUser' }
    & { managedAdvertisers?: Maybe<Array<(
      { __typename: 'PartnerUserAdvertiser' }
      & { advertiser?: Maybe<(
        { __typename: 'Advertiser' }
        & Pick<Advertiser, 'id' | 'name' | 'type' | 'countryCode'>
      )> }
    )>> }
  )> }
);

export type AdvertiserFragment = (
  { __typename: 'Advertiser' }
  & Pick<Advertiser, 'id' | 'name' | 'type' | 'countryCode'>
);

export type GetAdvertisersQueryVariables = Exact<{
  after?: Maybe<Scalars['Cursor']>;
}>;


export type GetAdvertisersQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'companyName'>
      ) }
    )>, advertisers?: Maybe<(
      { __typename: 'PartnerAdvertiserConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename: 'PartnerAdvertiserEdge' }
        & Pick<PartnerAdvertiserEdge, 'accessLevel'>
        & { node: (
          { __typename: 'Advertiser' }
          & AdvertiserFragment
        ) }
      )>>>, pageInfo?: Maybe<(
        { __typename: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
      )> }
    )> }
  )> }
);

export type RemovePartnerAdvertiserMutationVariables = Exact<{
  input: RemovePartnerAdvertiserInput;
}>;


export type RemovePartnerAdvertiserMutation = (
  { __typename: 'Mutation' }
  & { removePartnerAdvertiser?: Maybe<(
    { __typename: 'Advertiser' }
    & AdvertiserFragment
  )> }
);

export type GetAdvertiserReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdvertiserReportQuery = (
  { __typename: 'Query' }
  & { advertiserReport?: Maybe<(
    { __typename: 'CompletedReport' }
    & Pick<CompletedReport, 'reportType' | 'creationDate' | 'location'>
  ) | (
    { __typename: 'InvalidState' }
    & Pick<InvalidState, 'code'>
  ) | (
    { __typename: 'NoReport' }
    & Pick<NoReport, 'reportType'>
  ) | (
    { __typename: 'PendingReport' }
    & Pick<PendingReport, 'reportType' | 'creationDate'>
  )> }
);

export type GenerateAdvertiserReportMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateAdvertiserReportMutation = (
  { __typename: 'Mutation' }
  & { generateAdvertiserReport?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'PendingReport' }
    & Pick<PendingReport, 'reportType' | 'creationDate'>
  )> }
);

export type GetApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationsQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { applications?: Maybe<Array<(
      { __typename: 'PartnerApplication' }
      & Pick<PartnerApplication, 'id' | 'applicationId' | 'name' | 'linkedDate' | 'advertiserAutomappingStatus'>
      & { linkedBy?: Maybe<(
        { __typename: 'User' }
        & Pick<User, 'id' | 'name'>
      )> }
    )>> }
  )> }
);

export type GetPartnerAccountNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerAccountNameQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'companyName'>
      ) }
    )> }
  )> }
);

export type GetLinkableApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLinkableApplicationsQuery = (
  { __typename: 'Query' }
  & { linkableApplications?: Maybe<Array<(
    { __typename: 'LinkableApplication' }
    & Pick<LinkableApplication, 'applicationId' | 'name'>
  )>> }
);

type LinkOrUnlinkResponse_ApplicationDetails_Fragment = (
  { __typename: 'ApplicationDetails' }
  & Pick<ApplicationDetails, 'id' | 'applicationId' | 'isLinked' | 'advertiserAutomappingStatus'>
  & { partner: (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
  ) }
);

type LinkOrUnlinkResponse_ClientError_Fragment = { __typename: 'ClientError' };

type LinkOrUnlinkResponse_InvalidState_Fragment = { __typename: 'InvalidState' };

export type LinkOrUnlinkResponseFragment = LinkOrUnlinkResponse_ApplicationDetails_Fragment | LinkOrUnlinkResponse_ClientError_Fragment | LinkOrUnlinkResponse_InvalidState_Fragment;

export type LinkApplicationMutationVariables = Exact<{
  input: LinkApplicationInput;
}>;


export type LinkApplicationMutation = (
  { __typename: 'Mutation' }
  & { linkApplication?: Maybe<(
    { __typename: 'ApplicationDetails' }
    & LinkOrUnlinkResponse_ApplicationDetails_Fragment
  ) | (
    { __typename: 'ClientError' }
    & LinkOrUnlinkResponse_ClientError_Fragment
  ) | (
    { __typename: 'InvalidState' }
    & LinkOrUnlinkResponse_InvalidState_Fragment
  )> }
);

export type UnlinkApplicationMutationVariables = Exact<{
  input: UnlinkApplicationInput;
}>;


export type UnlinkApplicationMutation = (
  { __typename: 'Mutation' }
  & { unlinkApplication?: Maybe<(
    { __typename: 'ApplicationDetails' }
    & LinkOrUnlinkResponse_ApplicationDetails_Fragment
  ) | (
    { __typename: 'ClientError' }
    & LinkOrUnlinkResponse_ClientError_Fragment
  ) | (
    { __typename: 'InvalidState' }
    & LinkOrUnlinkResponse_InvalidState_Fragment
  )> }
);

export type UpdateApplicationMutationVariables = Exact<{
  input: UpdateApplicationInput;
}>;


export type UpdateApplicationMutation = (
  { __typename: 'Mutation' }
  & { updateApplication?: Maybe<(
    { __typename: 'ApplicationDetails' }
    & Pick<ApplicationDetails, 'id' | 'applicationId' | 'advertiserAutomappingStatus'>
  ) | (
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  )> }
);

export type GetAggregateCertificationTypeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAggregateCertificationTypeDataQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'totalUsersCount' | 'certifiedUsersCount'>
    & { certificationData?: Maybe<(
      { __typename: 'CertificationData' }
      & { certificationDataByType?: Maybe<Array<(
        { __typename: 'CertificationTypeData' }
        & Pick<CertificationTypeData, 'name' | 'count'>
      )>> }
    )> }
  )> }
);

export type GetCertificationEntriesQueryVariables = Exact<{
  queryInput?: Maybe<CertificationQueryInput>;
  pagination?: Maybe<PaginationInput>;
  sorts?: Maybe<Array<Maybe<SortInput>> | Maybe<SortInput>>;
}>;


export type GetCertificationEntriesQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & { certificationData?: Maybe<(
      { __typename: 'CertificationData' }
      & { certifiedUsers?: Maybe<(
        { __typename: 'CertificationEntryConnection' }
        & Pick<CertificationEntryConnection, 'totalCertificationEntryCount'>
        & { pageInfo?: Maybe<(
          { __typename: 'PageInfo' }
          & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
        )>, edges: Array<(
          { __typename: 'CertificationEntryEdge' }
          & Pick<CertificationEntryEdge, 'cursor'>
          & { node: (
            { __typename: 'CertificationEntryNode' }
            & Pick<CertificationEntryNode, 'expirationDate' | 'courseTag' | 'name' | 'type'>
            & { certificationUser: (
              { __typename: 'PartnerUser' }
              & { user?: Maybe<(
                { __typename: 'User' }
                & Pick<User, 'id' | 'name' | 'email'>
              )> }
            ) }
          ) }
        )> }
      ) | { __typename: 'ClientError' }> }
    )> }
  )> }
);

export type GetPartnerUserQueryVariables = Exact<{
  fetchExpired?: Maybe<Scalars['Boolean']>;
}>;


export type GetPartnerUserQuery = (
  { __typename: 'Query' }
  & { partnerUser?: Maybe<(
    { __typename: 'PartnerUser' }
    & { learningConsoleCertificates?: Maybe<Array<(
      { __typename: 'LearningConsoleCertificate' }
      & Pick<LearningConsoleCertificate, 'name' | 'courseTag' | 'badgeContentType' | 'badgeUrl' | 'expirationDate'>
    )>>, user?: Maybe<(
      { __typename: 'User' }
      & Pick<User, 'email'>
    )> }
  )> }
);

export type PartnerUserFragment = (
  { __typename: 'User' }
  & Pick<User, 'id' | 'name' | 'email'>
);

export type GetPartnerUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerUsersQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id' | 'totalUsersCount' | 'certifiedUsersCount'>
    & { users?: Maybe<Array<Maybe<(
      { __typename: 'PartnerUser' }
      & Pick<PartnerUser, 'partnerUserRole'>
      & { user?: Maybe<(
        { __typename: 'User' }
        & PartnerUserFragment
      )> }
    )>>> }
  )> }
);

export type GetPartnerUserCertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerUserCertificatesQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { users?: Maybe<Array<Maybe<(
      { __typename: 'PartnerUser' }
      & { user?: Maybe<(
        { __typename: 'User' }
        & Pick<User, 'id'>
      )>, learningConsoleCertificates?: Maybe<Array<(
        { __typename: 'LearningConsoleCertificate' }
        & Pick<LearningConsoleCertificate, 'name' | 'expirationDate'>
      )>> }
    )>>> }
  )> }
);

export type RemovePartnerUserMutationVariables = Exact<{
  userId: Scalars['CustomerAccountId'];
}>;


export type RemovePartnerUserMutation = (
  { __typename: 'Mutation' }
  & { removePartnerUser?: Maybe<(
    { __typename: 'User' }
    & PartnerUserFragment
  )> }
);

export type UpdatePartnerUserMutationVariables = Exact<{
  input: UpdatePartnerUserInput;
}>;


export type UpdatePartnerUserMutation = (
  { __typename: 'Mutation' }
  & { updatePartnerUser?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'InvalidState' }
    & Pick<InvalidState, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerUser' }
    & Pick<PartnerUser, 'partnerUserRole'>
    & { user?: Maybe<(
      { __typename: 'User' }
      & Pick<User, 'id'>
    )> }
  )> }
);

export type PartnerUserInviteFragment = (
  { __typename: 'PartnerUserInvite' }
  & Pick<PartnerUserInvite, 'id' | 'inviteeName' | 'inviteeEmail' | 'partnerUserRole' | 'creationDate' | 'status'>
);

export type GetUserInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInvitesQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { userInvites?: Maybe<Array<Maybe<(
      { __typename: 'PartnerUserInvite' }
      & PartnerUserInviteFragment
    )>>> }
  )> }
);

export type SendPartnerUserInviteMutationVariables = Exact<{
  input: SendPartnerUserInviteInput;
}>;


export type SendPartnerUserInviteMutation = (
  { __typename: 'Mutation' }
  & { sendPartnerUserInvite?: Maybe<(
    { __typename: 'PartnerUserInvite' }
    & PartnerUserInviteFragment
  )> }
);

export type DeletePartnerUserInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type DeletePartnerUserInviteMutation = (
  { __typename: 'Mutation' }
  & { deletePartnerUserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerUserInvite' }
    & PartnerUserInviteFragment
  )> }
);

export type ResendPartnerUserInviteMutationVariables = Exact<{
  inviteId: Scalars['ID'];
}>;


export type ResendPartnerUserInviteMutation = (
  { __typename: 'Mutation' }
  & { resendPartnerUserInvite?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'NotFound' }
    & Pick<NotFound, 'code'>
  ) | (
    { __typename: 'PartnerUserInvite' }
    & PartnerUserInviteFragment
  )> }
);

export type GetPartnerGroupDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerGroupDetailsQuery = (
  { __typename: 'Query' }
  & { partnerGroup?: Maybe<(
    { __typename: 'PartnerGroup' }
    & Pick<PartnerGroup, 'groupId'>
    & { primaryPartnerAccount: (
      { __typename: 'Partner' }
      & Pick<Partner, 'id'>
      & { liveRegistration?: Maybe<(
        { __typename: 'VerifiablePartnerRegistration' }
        & { registration: (
          { __typename: 'PartnerRegistration' }
          & Pick<PartnerRegistration, 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber'>
          & { companyAddress: (
            { __typename: 'Address' }
            & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
          ) }
        ) }
      )> }
    ), members: Array<(
      { __typename: 'Partner' }
      & Pick<Partner, 'id'>
      & { liveRegistration?: Maybe<(
        { __typename: 'VerifiablePartnerRegistration' }
        & { registration: (
          { __typename: 'PartnerRegistration' }
          & Pick<PartnerRegistration, 'companyName'>
        ) }
      )> }
    )> }
  )> }
);

export type AddPartnerToGroupMutationVariables = Exact<{
  input: AddPartnerToGroupInput;
}>;


export type AddPartnerToGroupMutation = (
  { __typename: 'Mutation' }
  & { addPartnerToGroup?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'PartnerGroup' }
    & Pick<PartnerGroup, 'groupId'>
  )> }
);

export type RemovePartnerFromGroupMutationVariables = Exact<{
  input: RemovePartnerFromGroupInput;
}>;


export type RemovePartnerFromGroupMutation = (
  { __typename: 'Mutation' }
  & { removePartnerFromGroup?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'PartnerGroup' }
    & Pick<PartnerGroup, 'groupId'>
  )> }
);

export type CreatePartnerInGroupMutationVariables = Exact<{
  input: SubmitPartnerRegistrationInput;
}>;


export type CreatePartnerInGroupMutation = (
  { __typename: 'Mutation' }
  & { submitPartnerRegistration?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | { __typename: 'MutationError' } | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
  )> }
);

export type GetPartnerRegistrationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerRegistrationStatusQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { reviewRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ), verification: (
        { __typename: 'Verification' }
        & Pick<Verification, 'status' | 'rejectionReasons' | 'rejectionDetails' | 'lastSubmittedDate' | 'lastReviewedDate'>
        & { mutableRejectionReasons?: Maybe<Array<(
          { __typename: 'ExternalRejectionReasonObject' }
          & Pick<ExternalRejectionReasonObject, 'id' | 'message' | 'helpContentIds' | 'version'>
          & { translations: Array<(
            { __typename: 'Translation' }
            & Pick<Translation, 'text' | 'locale'>
          )> }
        )>> }
      ) }
    )>, unmoderatedRegistrationData?: Maybe<(
      { __typename: 'UnmoderatedRegistrationData' }
      & Pick<UnmoderatedRegistrationData, 'adOffering' | 'doesCurrentlyAdvertise' | 'servicesCategory' | 'adProductsInterest' | 'advertiserBusinessTypes'>
    )> }
  )> }
);

export type DeletePartnerRegistrationMutationVariables = Exact<{
  deleteRegistrationInput: DeletePartnerRegistrationInput;
}>;


export type DeletePartnerRegistrationMutation = (
  { __typename: 'Mutation' }
  & { deletePartnerRegistration?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & Pick<MutationArgumentError, 'argumentName'>
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { reviewRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes' | 'emailDomain'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ), verification: (
        { __typename: 'Verification' }
        & Pick<Verification, 'status' | 'rejectionReasons' | 'rejectionDetails' | 'lastSubmittedDate' | 'lastReviewedDate'>
        & { mutableRejectionReasons?: Maybe<Array<(
          { __typename: 'ExternalRejectionReasonObject' }
          & Pick<ExternalRejectionReasonObject, 'id' | 'message' | 'helpContentIds' | 'version'>
          & { translations: Array<(
            { __typename: 'Translation' }
            & Pick<Translation, 'text' | 'locale'>
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type ResubmitPartnerRegistrationMutationVariables = Exact<{
  submitRegistrationInput: SubmitPartnerRegistrationInput;
}>;


export type ResubmitPartnerRegistrationMutation = (
  { __typename: 'Mutation' }
  & { submitPartnerRegistration?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code' | 'message'>
  ) | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & Pick<MutationArgumentError, 'argumentName'>
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
    & { reviewRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'revision' | 'companyName' | 'companyWebsite' | 'incorporationCountry' | 'registrationNumber' | 'submissionNotes'>
        & { companyAddress: (
          { __typename: 'Address' }
          & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
        ), convertedFromRegionalManagerAccount?: Maybe<(
          { __typename: 'RegionalManagerAccount' }
          & Pick<RegionalManagerAccount, 'id' | 'region'>
        )> }
      ), verification: (
        { __typename: 'Verification' }
        & Pick<Verification, 'status' | 'rejectionReasons' | 'rejectionDetails' | 'lastSubmittedDate' | 'lastReviewedDate'>
        & { mutableRejectionReasons?: Maybe<Array<(
          { __typename: 'ExternalRejectionReasonObject' }
          & Pick<ExternalRejectionReasonObject, 'id' | 'message' | 'helpContentIds' | 'version'>
          & { translations: Array<(
            { __typename: 'Translation' }
            & Pick<Translation, 'text' | 'locale'>
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type RemoveSelfFromPartnerMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveSelfFromPartnerMutation = (
  { __typename: 'Mutation' }
  & { removeSelfFromPartner?: Maybe<(
    { __typename: 'User' }
    & Pick<User, 'id'>
  )> }
);

export type CmsDetailsLocalizedFragment = (
  { __typename: 'CMSDetailsLocalized' }
  & Pick<CmsDetailsLocalized, 'title' | 'shortDescription'>
  & { assets?: Maybe<Array<(
    { __typename: 'CMSAsset' }
    & Pick<CmsAsset, 'mimeType'>
  )>> }
);

export type CmsDetailsFragment = (
  { __typename: 'CMSDetails' }
  & { ar_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, de_DE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_AU?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_GB?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_SG?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, en_US?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, es_CO?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, es_ES?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, es_MX?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, fr_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, fr_FR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, hi_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, it_IT?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, ja_JP?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, ko_KR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, nl_NL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, pl_PL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, pt_BR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, sv_SE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, ta_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, th_TH?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, tr_TR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, vi_VN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, zh_CN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )>, zh_TW?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & CmsDetailsLocalizedFragment
  )> }
);

export type ResourceFragment = (
  { __typename: 'CMSResourceEntry' }
  & Pick<CmsResourceEntry, 'id' | 'resourceCategories' | 'deleted' | 'featured'>
  & { details?: Maybe<(
    { __typename: 'CMSDetails' }
    & CmsDetailsFragment
  )>, audit: (
    { __typename: 'Audit' }
    & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
  ) }
);

export type EventFragment = (
  { __typename: 'CMSEventEntry' }
  & Pick<CmsEventEntry, 'id' | 'eventType' | 'registrationUrl' | 'deleted' | 'featured'>
  & { occurrence?: Maybe<(
    { __typename: 'Occurrence' }
    & Pick<Occurrence, 'start' | 'end'>
  )>, location?: Maybe<(
    { __typename: 'Address' }
    & Pick<Address, 'lines' | 'city' | 'stateOrRegion' | 'districtOrCounty' | 'postalCode' | 'countryCode'>
  )>, details?: Maybe<(
    { __typename: 'CMSDetails' }
    & CmsDetailsFragment
  )>, audit: (
    { __typename: 'Audit' }
    & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
  ) }
);

export type GetFeaturedUpdatesQueryVariables = Exact<{
  pagination?: Maybe<PaginationInput>;
  filters?: Maybe<FilterInput>;
}>;


export type GetFeaturedUpdatesQuery = (
  { __typename: 'Query' }
  & { cmsEntries?: Maybe<(
    { __typename: 'CMSEntryConnection' }
    & Pick<CmsEntryConnection, 'totalCMSEntryCount'>
    & { edges: Array<(
      { __typename: 'CMSEntryEdge' }
      & { node: (
        { __typename: 'CMSEventEntry' }
        & EventFragment
      ) | (
        { __typename: 'CMSResourceEntry' }
        & ResourceFragment
      ) }
    )> }
  )> }
);

export type LocalizedDirectoryListingFragment = (
  { __typename: 'LocalizedDirectoryListing' }
  & { live?: Maybe<(
    { __typename: 'VerifiableLocalizedDirectoryListingData' }
    & { data: (
      { __typename: 'LocalizedDirectoryListingData' }
      & Pick<LocalizedDirectoryListingData, 'revision'>
    ), verification: (
      { __typename: 'Verification' }
      & Pick<Verification, 'status' | 'submissionCountWithoutApproval' | 'submissionCountWithoutReview' | 'firstSubmittedDate' | 'lastSubmittedDate'>
    ) }
  )> }
);

export type AwardDetailsFragment = (
  { __typename: 'LocalizedAwardDetails' }
  & Pick<LocalizedAwardDetails, 'description' | 'locale' | 'name'>
);

export type PartnerAwardDataFragment = (
  { __typename: 'PartnerAward' }
  & Pick<PartnerAward, 'id' | 'awardId' | 'imageDownloadLocation'>
  & { details: Array<(
    { __typename: 'LocalizedAwardDetails' }
    & AwardDetailsFragment
  )>, grant: (
    { __typename: 'PartnerAwardGrantDetails' }
    & Pick<PartnerAwardGrantDetails, 'awardedDate' | 'expirationDate' | 'revocationDate'>
  ) }
);

export type GetPartnerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerProfileQuery = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id' | 'totalUsersCount' | 'certifiedUsersCount'>
    & { accreditationStatus?: Maybe<(
      { __typename: 'PartnerAccreditationStatus' }
      & Pick<PartnerAccreditationStatus, 'value' | 'updatedDate' | 'updatedBy'>
    )>, badges?: Maybe<(
      { __typename: 'PartnerBadges' }
      & { admin?: Maybe<(
        { __typename: 'AssignedPartnerBadges' }
        & { accreditation?: Maybe<Array<(
          { __typename: 'Accreditation' }
          & Pick<Accreditation, 'type'>
          & { statusInfo: (
            { __typename: 'PartnerAccreditationStatusInfo' }
            & Pick<PartnerAccreditationStatusInfo, 'status' | 'lastUpdatedBy' | 'lastUpdatedDate'>
          ) }
        )>> }
      )> }
    )>, awards?: Maybe<Array<Maybe<(
      { __typename: 'PartnerAward' }
      & PartnerAwardDataFragment
    )>>>, applications?: Maybe<Array<(
      { __typename: 'PartnerApplication' }
      & Pick<PartnerApplication, 'applicationId' | 'id' | 'linkedDate'>
    )>>, advertisers?: Maybe<(
      { __typename: 'PartnerAdvertiserConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename: 'PartnerAdvertiserEdge' }
        & { node: (
          { __typename: 'Advertiser' }
          & Pick<Advertiser, 'id'>
        ) }
      )>>> }
    )>, liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'companyName' | 'incorporationCountry'>
      ) }
    )>, unmoderatedRegistrationData?: Maybe<(
      { __typename: 'UnmoderatedRegistrationData' }
      & Pick<UnmoderatedRegistrationData, 'adOffering' | 'adProductsInterest' | 'advertiserBusinessTypes' | 'servicesCategory'>
    )>, localizedDirectoryListings?: Maybe<(
      { __typename: 'LocalizedDirectoryListings' }
      & { ar_ae?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, de_de?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, en_us?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, es_es?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, fr_fr?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, it_it?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, ja_jp?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, ko_kr?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, nl_nl?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, pl_pl?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, pt_br?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, sv_se?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, tr_tr?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )>, zh_cn?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & LocalizedDirectoryListingFragment
      )> }
    )> }
  )> }
);

export type ProfileLocalizedDirectoryListingFragment = (
  { __typename: 'LocalizedDirectoryListing' }
  & { live?: Maybe<(
    { __typename: 'VerifiableLocalizedDirectoryListingData' }
    & { data: (
      { __typename: 'LocalizedDirectoryListingData' }
      & Pick<LocalizedDirectoryListingData, 'revision'>
    ), verification: (
      { __typename: 'Verification' }
      & Pick<Verification, 'status' | 'submissionCountWithoutApproval' | 'submissionCountWithoutReview' | 'firstSubmittedDate' | 'lastSubmittedDate'>
    ) }
  )> }
);

export type ProfileUniversalListingDataFragment = (
  { __typename: 'UniversalDirectoryListingData' }
  & Pick<UniversalDirectoryListingData, 'services' | 'products' | 'marketplaces'>
);

export type ProfileAwardDetailsFragment = (
  { __typename: 'LocalizedAwardDetails' }
  & Pick<LocalizedAwardDetails, 'description' | 'locale' | 'name'>
);

export type ProfilePartnerAwardDataFragment = (
  { __typename: 'PartnerAward' }
  & Pick<PartnerAward, 'id' | 'awardId' | 'imageDownloadLocation'>
  & { details: Array<(
    { __typename: 'LocalizedAwardDetails' }
    & AwardDetailsFragment
  )>, grant: (
    { __typename: 'PartnerAwardGrantDetails' }
    & Pick<PartnerAwardGrantDetails, 'awardedDate' | 'expirationDate' | 'revocationDate'>
  ) }
);

export type GetPartnerProfileV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerProfileV2Query = (
  { __typename: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & Pick<Partner, 'id' | 'isInternal' | 'totalUsersCount' | 'certifiedUsersCount'>
    & { accreditationStatus?: Maybe<(
      { __typename: 'PartnerAccreditationStatus' }
      & Pick<PartnerAccreditationStatus, 'value' | 'updatedDate' | 'updatedBy'>
    )>, badges?: Maybe<(
      { __typename: 'PartnerBadges' }
      & { admin?: Maybe<(
        { __typename: 'AssignedPartnerBadges' }
        & { accreditation?: Maybe<Array<(
          { __typename: 'Accreditation' }
          & Pick<Accreditation, 'type'>
          & { statusInfo: (
            { __typename: 'PartnerAccreditationStatusInfo' }
            & Pick<PartnerAccreditationStatusInfo, 'status' | 'lastUpdatedBy' | 'lastUpdatedDate'>
          ) }
        )>> }
      )> }
    )>, awards?: Maybe<Array<Maybe<(
      { __typename: 'PartnerAward' }
      & ProfilePartnerAwardDataFragment
    )>>>, applications?: Maybe<Array<(
      { __typename: 'PartnerApplication' }
      & Pick<PartnerApplication, 'applicationId' | 'id' | 'linkedDate'>
    )>>, advertisers?: Maybe<(
      { __typename: 'PartnerAdvertiserConnection' }
      & { edges?: Maybe<Array<Maybe<(
        { __typename: 'PartnerAdvertiserEdge' }
        & { node: (
          { __typename: 'Advertiser' }
          & Pick<Advertiser, 'id'>
        ) }
      )>>> }
    )>, liveRegistration?: Maybe<(
      { __typename: 'VerifiablePartnerRegistration' }
      & { registration: (
        { __typename: 'PartnerRegistration' }
        & Pick<PartnerRegistration, 'companyName' | 'incorporationCountry'>
      ) }
    )>, unmoderatedRegistrationData?: Maybe<(
      { __typename: 'UnmoderatedRegistrationData' }
      & Pick<UnmoderatedRegistrationData, 'adOffering' | 'adProductsInterest' | 'advertiserBusinessTypes' | 'servicesCategory'>
    )>, liveDirectoryListingData?: Maybe<(
      { __typename: 'UniversalDirectoryListingData' }
      & ProfileUniversalListingDataFragment
    )>, localizedDirectoryListings?: Maybe<(
      { __typename: 'LocalizedDirectoryListings' }
      & { ar_ae?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, de_de?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, en_us?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, es_es?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, fr_fr?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, it_it?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, ja_jp?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, ko_kr?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, nl_nl?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, pl_pl?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, pt_br?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, sv_se?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, tr_tr?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )>, zh_cn?: Maybe<(
        { __typename: 'LocalizedDirectoryListing' }
        & ProfileLocalizedDirectoryListingFragment
      )> }
    )>, partnerLogo?: Maybe<(
      { __typename: 'PartnerLogo' }
      & PartnerLogoDataFragment
    )> }
  )> }
);

export type SubmitPartnerRegistrationMutationVariables = Exact<{
  submitRegistrationInput: SubmitPartnerRegistrationInput;
}>;


export type SubmitPartnerRegistrationMutation = (
  { __typename: 'Mutation' }
  & { submitPartnerRegistration?: Maybe<(
    { __typename: 'ClientError' }
    & Pick<ClientError, 'code'>
  ) | (
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & Pick<MutationArgumentError, 'argumentName'>
    )> }
  ) | (
    { __typename: 'Partner' }
    & Pick<Partner, 'id'>
  )> }
);

export type GetPartnerManagerAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerManagerAccountsQuery = (
  { __typename: 'Query' }
  & { promotableManagerAccounts: Array<Maybe<(
    { __typename: 'ManagerAccount' }
    & Pick<ManagerAccount, 'id' | 'region'>
  )>> }
);

export type PartnerRegistrationEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerRegistrationEligibilityQuery = (
  { __typename: 'Query' }
  & { partnerRegistrationEligibility?: Maybe<{ __typename: 'ClientError' } | (
    { __typename: 'PartnerRegistrationEligibility' }
    & Pick<PartnerRegistrationEligibility, 'partnerRegistrationEligibilityResponse'>
  )> }
);

export type DetailsFieldsFragment = (
  { __typename: 'CMSDetailsLocalized' }
  & Pick<CmsDetailsLocalized, 'title' | 'shortDescription' | 'description'>
  & { assets?: Maybe<Array<(
    { __typename: 'CMSAsset' }
    & Pick<CmsAsset, 'mimeType' | 'link'>
    & { storageLocation: (
      { __typename: 'S3StorageLocation' }
      & Pick<S3StorageLocation, 'key'>
    ) }
  )>> }
);

export type DetailsLocaleFieldsFragment = (
  { __typename: 'CMSDetails' }
  & { ar_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, cs_CZ?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, de_DE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_AE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_AU?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_GB?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_SG?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, en_US?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, es_CO?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, es_ES?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, es_MX?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, es_US?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, fr_CA?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, fr_FR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, he_IL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, hi_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, it_IT?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, ja_JP?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, kn_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, ko_KR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, nl_NL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, pl_PL?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, pt_BR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, sv_SE?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, ta_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, te_IN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, th_TH?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, tr_TR?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, vi_VN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, zh_CN?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )>, zh_TW?: Maybe<(
    { __typename: 'CMSDetailsLocalized' }
    & DetailsFieldsFragment
  )> }
);

export type GetResourceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetResourceQuery = (
  { __typename: 'Query' }
  & { cmsEntry?: Maybe<(
    { __typename: 'CMSEventEntry' }
    & Pick<CmsEventEntry, 'id' | 'deleted' | 'featured' | 'productCategories' | 'tags' | 'targetSegments'>
    & { audit: (
      { __typename: 'Audit' }
      & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
    ), details?: Maybe<(
      { __typename: 'CMSDetails' }
      & DetailsLocaleFieldsFragment
    )> }
  ) | (
    { __typename: 'CMSResourceEntry' }
    & Pick<CmsResourceEntry, 'resourceCategories' | 'id' | 'deleted' | 'featured' | 'productCategories' | 'tags' | 'targetSegments'>
    & { audit: (
      { __typename: 'Audit' }
      & Pick<Audit, 'createdDate' | 'updatedDate' | 'updatedBy'>
    ), details?: Maybe<(
      { __typename: 'CMSDetails' }
      & DetailsLocaleFieldsFragment
    )> }
  )> }
);

export type OnlineAgreementFragment = (
  { __typename: 'OnlineAgreement' }
  & Pick<OnlineAgreement, 'content' | 'contentToken'>
);

export type OnlineAgreementQueryVariables = Exact<{
  locale: TermsLocale;
}>;


export type OnlineAgreementQuery = (
  { __typename: 'Query' }
  & { onlineAgreement?: Maybe<(
    { __typename: 'OnlineAgreement' }
    & OnlineAgreementFragment
  )> }
);

export type AcceptOnlineAgreementMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptOnlineAgreementMutation = (
  { __typename: 'Mutation' }
  & { acceptOnlineAgreement?: Maybe<(
    { __typename: 'MutationError' }
    & { errors: Array<(
      { __typename: 'MutationArgumentError' }
      & MutationArgumentErrorDataFragment
    )> }
  ) | (
    { __typename: 'OnlineAgreement' }
    & OnlineAgreementFragment
  )> }
);

export const DetailFragmentDoc = gql`
    fragment detail on CMSDetailsLocalized {
  title
  shortDescription
  assets {
    mimeType
    storageLocation {
      key
    }
  }
  description
}
    `;
export const DetailsFragmentDoc = gql`
    fragment details on CMSDetails {
  ar_AE {
    ...detail
  }
  de_DE {
    ...detail
  }
  en_AE {
    ...detail
  }
  en_AU {
    ...detail
  }
  en_CA {
    ...detail
  }
  en_IN {
    ...detail
  }
  en_GB {
    ...detail
  }
  en_SG {
    ...detail
  }
  en_US {
    ...detail
  }
  es_CO {
    ...detail
  }
  es_ES {
    ...detail
  }
  es_MX {
    ...detail
  }
  fr_CA {
    ...detail
  }
  fr_FR {
    ...detail
  }
  hi_IN {
    ...detail
  }
  it_IT {
    ...detail
  }
  ja_JP {
    ...detail
  }
  ko_KR {
    ...detail
  }
  nl_NL {
    ...detail
  }
  pl_PL {
    ...detail
  }
  pt_BR {
    ...detail
  }
  sv_SE {
    ...detail
  }
  ta_IN {
    ...detail
  }
  th_TH {
    ...detail
  }
  tr_TR {
    ...detail
  }
  vi_VN {
    ...detail
  }
  zh_CN {
    ...detail
  }
  zh_TW {
    ...detail
  }
}
    ${DetailFragmentDoc}`;
export const ResourceNodeFragmentDoc = gql`
    fragment resourceNode on CMSResourceEntry {
  id
  resourceCategories
  productCategories
  tags
  details {
    ...details
  }
  audit {
    createdDate
    updatedDate
    updatedBy
  }
}
    ${DetailsFragmentDoc}`;
export const EventNodeFragmentDoc = gql`
    fragment eventNode on CMSEventEntry {
  id
  eventType
  productCategories
  registrationUrl
  tags
  occurrence {
    start
    end
  }
  location {
    lines
    city
    stateOrRegion
    districtOrCounty
    postalCode
    countryCode
  }
  details {
    ...details
  }
  audit {
    createdDate
    updatedDate
    updatedBy
  }
}
    ${DetailsFragmentDoc}`;
export const MutationArgumentErrorDataFragmentDoc = gql`
    fragment mutationArgumentErrorData on MutationArgumentError {
  argumentName
  fieldErrors {
    name
    reason
  }
}
    `;
export const CampaignDetailsFragmentDoc = gql`
    fragment campaignDetails on CampaignDetails {
  clientName
  clientMCID
  campaignTitle
  campaignBudget {
    amount
    currency
  }
  campaignStartDate
  campaignEndDate
}
    `;
export const PartnerClientBackgroundFragmentDoc = gql`
    fragment partnerClientBackground on PartnerClientBackground {
  partnerName
  partnerBackground
  partnerCountry
  clientBackground
  clientCountry
  clientAmazonTenure
  clientGoal
}
    `;
export const CaseStudyDetailsFragmentDoc = gql`
    fragment caseStudyDetails on CaseStudyDetails {
  partnerChallenge
  campaignObjectives
  successIndicators
  deliveryApproach
  productsUtilized
}
    `;
export const CaseStudyOutcomeFragmentDoc = gql`
    fragment caseStudyOutcome on CaseStudyOutcome {
  implementationSummary
  campaignResults
  resultsFutureUsage
}
    `;
export const FeaturedContentRequestInfoFragmentDoc = gql`
    fragment featuredContentRequestInfo on FeaturedContentRequestInfo {
  revision
  campaignDetails {
    ...campaignDetails
  }
  partnerClientBackground {
    ...partnerClientBackground
  }
  caseStudyDetails {
    ...caseStudyDetails
  }
  outcome {
    ...caseStudyOutcome
  }
  quotes {
    ... on CaseStudyQuote {
      quote
      quoteType
    }
  }
}
    ${CampaignDetailsFragmentDoc}
${PartnerClientBackgroundFragmentDoc}
${CaseStudyDetailsFragmentDoc}
${CaseStudyOutcomeFragmentDoc}`;
export const FeaturedContentRequestFragmentDoc = gql`
    fragment featuredContentRequest on FeaturedContentRequest {
  id
  locale
  draft {
    ...featuredContentRequestInfo
  }
  live {
    featuredContentRequestInfo {
      ...featuredContentRequestInfo
    }
  }
  auditInfo {
    createdDate
    updatedDate
    updatedBy
  }
}
    ${FeaturedContentRequestInfoFragmentDoc}`;
export const FeaturedContentRequestEntriesFragmentDoc = gql`
    fragment featuredContentRequestEntries on FeaturedContentRequestEntries {
  entries {
    ...featuredContentRequest
  }
}
    ${FeaturedContentRequestFragmentDoc}`;
export const LocalizedDirectoryDataFragmentDoc = gql`
    fragment localizedDirectoryData on LocalizedDirectoryListingData {
  revision
  displayName
  description
  externalHomeUrl
  contactUrl
}
    `;
export const VerificationDataFragmentDoc = gql`
    fragment verificationData on Verification {
  status
  rejectionReasons
  rejectionDetails
  mutableRejectionReasons {
    id
    message
    helpContentIds
    version
    translations {
      text
      locale
    }
  }
}
    `;
export const VerifiableLocalizedDirectoryDataFragmentDoc = gql`
    fragment verifiableLocalizedDirectoryData on VerifiableLocalizedDirectoryListingData {
  data {
    ...localizedDirectoryData
  }
  verification {
    ...verificationData
  }
}
    ${LocalizedDirectoryDataFragmentDoc}
${VerificationDataFragmentDoc}`;
export const LocalizedDirectoryScopesFragmentDoc = gql`
    fragment localizedDirectoryScopes on LocalizedDirectoryListing {
  draft {
    ...localizedDirectoryData
  }
  review {
    ...verifiableLocalizedDirectoryData
  }
  live {
    ...verifiableLocalizedDirectoryData
  }
}
    ${LocalizedDirectoryDataFragmentDoc}
${VerifiableLocalizedDirectoryDataFragmentDoc}`;
export const LocalizedDirectoriesFragmentDoc = gql`
    fragment localizedDirectories on LocalizedDirectoryListings {
  ar_ae {
    ...localizedDirectoryScopes
  }
  de_de {
    ...localizedDirectoryScopes
  }
  en_us {
    ...localizedDirectoryScopes
  }
  es_es {
    ...localizedDirectoryScopes
  }
  fr_fr {
    ...localizedDirectoryScopes
  }
  it_it {
    ...localizedDirectoryScopes
  }
  ja_jp {
    ...localizedDirectoryScopes
  }
  ko_kr {
    ...localizedDirectoryScopes
  }
  nl_nl {
    ...localizedDirectoryScopes
  }
  pl_pl {
    ...localizedDirectoryScopes
  }
  pt_br {
    ...localizedDirectoryScopes
  }
  sv_se {
    ...localizedDirectoryScopes
  }
  tr_tr {
    ...localizedDirectoryScopes
  }
  zh_cn {
    ...localizedDirectoryScopes
  }
}
    ${LocalizedDirectoryScopesFragmentDoc}`;
export const UniversalListingDataFragmentDoc = gql`
    fragment universalListingData on UniversalDirectoryListingData {
  serviceModel
  services
  products
  serviceModels
  industries
  pricingModels
  marketplaces
  locations
  budgets {
    minimum
    maximum
    currency
  }
}
    `;
export const CasAssetDataFragmentDoc = gql`
    fragment casAssetData on CASAsset {
  assetId
  assetType
  version
}
    `;
export const VerifiableCasAssetDataFragmentDoc = gql`
    fragment verifiableCasAssetData on VerifiableLogoAsset {
  logoAsset {
    ...casAssetData
  }
  verification {
    ...verificationData
  }
}
    ${CasAssetDataFragmentDoc}
${VerificationDataFragmentDoc}`;
export const PartnerLogoDataFragmentDoc = gql`
    fragment partnerLogoData on PartnerLogo {
  draft {
    ...casAssetData
  }
  review {
    ...verifiableCasAssetData
  }
  live {
    ...verifiableCasAssetData
  }
}
    ${CasAssetDataFragmentDoc}
${VerifiableCasAssetDataFragmentDoc}`;
export const BadgesDataFragmentDoc = gql`
    fragment badgesData on PartnerBadges {
  admin {
    directoryListing {
      products {
        type
        value
      }
      services {
        type
        value
      }
    }
    accreditation {
      type
      statusInfo {
        status
        lastUpdatedBy
        lastUpdatedDate
      }
    }
  }
}
    `;
export const DlCampaignDetailsFragmentDoc = gql`
    fragment dlCampaignDetails on CampaignDetails {
  clientName
  clientMCID
  campaignTitle
  campaignBudget {
    amount
    currency
  }
  campaignStartDate
  campaignEndDate
}
    `;
export const DlPartnerClientBackgroundFragmentDoc = gql`
    fragment dlPartnerClientBackground on PartnerClientBackground {
  partnerBackground
  partnerCountry
  clientBackground
  clientCountry
  clientAmazonTenure
  clientGoal
}
    `;
export const DlCaseStudyDetailsFragmentDoc = gql`
    fragment dlCaseStudyDetails on CaseStudyDetails {
  partnerChallenge
  campaignObjectives
  successIndicators
  deliveryApproach
  productsUtilized
}
    `;
export const DlCaseStudyOutcomeFragmentDoc = gql`
    fragment dlCaseStudyOutcome on CaseStudyOutcome {
  implementationSummary
  campaignResults
  resultsFutureUsage
}
    `;
export const DlFeaturedContentRequestInfoFragmentDoc = gql`
    fragment dlFeaturedContentRequestInfo on FeaturedContentRequestInfo {
  revision
  campaignDetails {
    ...dlCampaignDetails
  }
  partnerClientBackground {
    ...dlPartnerClientBackground
  }
  caseStudyDetails {
    ...dlCaseStudyDetails
  }
  outcome {
    ...dlCaseStudyOutcome
  }
  quotes {
    ... on CaseStudyQuote {
      quote
      quoteType
    }
  }
}
    ${DlCampaignDetailsFragmentDoc}
${DlPartnerClientBackgroundFragmentDoc}
${DlCaseStudyDetailsFragmentDoc}
${DlCaseStudyOutcomeFragmentDoc}`;
export const DlFeaturedContentRequestFragmentDoc = gql`
    fragment dlFeaturedContentRequest on FeaturedContentRequest {
  id
  locale
  draft {
    ...dlFeaturedContentRequestInfo
  }
  live {
    featuredContentRequestInfo {
      ...dlFeaturedContentRequestInfo
    }
  }
  auditInfo {
    createdDate
    updatedDate
    updatedBy
  }
}
    ${DlFeaturedContentRequestInfoFragmentDoc}`;
export const DlFeaturedContentRequestEntriesFragmentDoc = gql`
    fragment dlFeaturedContentRequestEntries on FeaturedContentRequestEntries {
  entries {
    ...dlFeaturedContentRequest
  }
}
    ${DlFeaturedContentRequestFragmentDoc}`;
export const SocialDataFragmentDoc = gql`
    fragment socialData on SocialData {
  socialPlatform
  socialUrl
  urlStatus
}
    `;
export const CaseStudyFragmentDoc = gql`
    fragment caseStudy on CaseStudy {
  contentUrlKey
  lastUpdatedBy
  lastUpdatedDate
}
    `;
export const EventDetailsFieldsFragmentDoc = gql`
    fragment eventDetailsFields on CMSDetailsLocalized {
  title
  shortDescription
  description
}
    `;
export const EventDetailsLocaleFieldsFragmentDoc = gql`
    fragment eventDetailsLocaleFields on CMSDetails {
  ar_AE {
    ...eventDetailsFields
  }
  cs_CZ {
    ...eventDetailsFields
  }
  de_DE {
    ...eventDetailsFields
  }
  en_AE {
    ...eventDetailsFields
  }
  en_AU {
    ...eventDetailsFields
  }
  en_CA {
    ...eventDetailsFields
  }
  en_GB {
    ...eventDetailsFields
  }
  en_IN {
    ...eventDetailsFields
  }
  en_SG {
    ...eventDetailsFields
  }
  en_US {
    ...eventDetailsFields
  }
  es_CO {
    ...eventDetailsFields
  }
  es_ES {
    ...eventDetailsFields
  }
  es_MX {
    ...eventDetailsFields
  }
  es_US {
    ...eventDetailsFields
  }
  fr_CA {
    ...eventDetailsFields
  }
  fr_FR {
    ...eventDetailsFields
  }
  he_IL {
    ...eventDetailsFields
  }
  hi_IN {
    ...eventDetailsFields
  }
  it_IT {
    ...eventDetailsFields
  }
  ja_JP {
    ...eventDetailsFields
  }
  kn_IN {
    ...eventDetailsFields
  }
  ko_KR {
    ...eventDetailsFields
  }
  nl_NL {
    ...eventDetailsFields
  }
  pl_PL {
    ...eventDetailsFields
  }
  pt_BR {
    ...eventDetailsFields
  }
  sv_SE {
    ...eventDetailsFields
  }
  ta_IN {
    ...eventDetailsFields
  }
  te_IN {
    ...eventDetailsFields
  }
  th_TH {
    ...eventDetailsFields
  }
  tr_TR {
    ...eventDetailsFields
  }
  vi_VN {
    ...eventDetailsFields
  }
  zh_CN {
    ...eventDetailsFields
  }
  zh_TW {
    ...eventDetailsFields
  }
}
    ${EventDetailsFieldsFragmentDoc}`;
export const PartnerAdvertiserInviteFragmentDoc = gql`
    fragment partnerAdvertiserInvite on PartnerAdvertiserInvite {
  invitationToken
  inviteeEmail
  creationDate
  status
}
    `;
export const AdvertiserFragmentDoc = gql`
    fragment advertiser on Advertiser {
  id
  name
  type
  countryCode
}
    `;
export const LinkOrUnlinkResponseFragmentDoc = gql`
    fragment linkOrUnlinkResponse on LinkOrUnlinkApplicationResponse {
  __typename
  ... on ApplicationDetails {
    id
    applicationId
    partner {
      id
    }
    isLinked
    advertiserAutomappingStatus
  }
}
    `;
export const PartnerUserFragmentDoc = gql`
    fragment partnerUser on User {
  id
  name
  email
}
    `;
export const PartnerUserInviteFragmentDoc = gql`
    fragment partnerUserInvite on PartnerUserInvite {
  id
  inviteeName
  inviteeEmail
  partnerUserRole
  creationDate
  status
}
    `;
export const CmsDetailsLocalizedFragmentDoc = gql`
    fragment cmsDetailsLocalized on CMSDetailsLocalized {
  title
  shortDescription
  assets {
    mimeType
  }
}
    `;
export const CmsDetailsFragmentDoc = gql`
    fragment cmsDetails on CMSDetails {
  ar_AE {
    ...cmsDetailsLocalized
  }
  de_DE {
    ...cmsDetailsLocalized
  }
  en_AE {
    ...cmsDetailsLocalized
  }
  en_AU {
    ...cmsDetailsLocalized
  }
  en_CA {
    ...cmsDetailsLocalized
  }
  en_GB {
    ...cmsDetailsLocalized
  }
  en_IN {
    ...cmsDetailsLocalized
  }
  en_SG {
    ...cmsDetailsLocalized
  }
  en_US {
    ...cmsDetailsLocalized
  }
  es_CO {
    ...cmsDetailsLocalized
  }
  es_ES {
    ...cmsDetailsLocalized
  }
  es_MX {
    ...cmsDetailsLocalized
  }
  fr_CA {
    ...cmsDetailsLocalized
  }
  fr_FR {
    ...cmsDetailsLocalized
  }
  hi_IN {
    ...cmsDetailsLocalized
  }
  it_IT {
    ...cmsDetailsLocalized
  }
  ja_JP {
    ...cmsDetailsLocalized
  }
  ko_KR {
    ...cmsDetailsLocalized
  }
  nl_NL {
    ...cmsDetailsLocalized
  }
  pl_PL {
    ...cmsDetailsLocalized
  }
  pt_BR {
    ...cmsDetailsLocalized
  }
  sv_SE {
    ...cmsDetailsLocalized
  }
  ta_IN {
    ...cmsDetailsLocalized
  }
  th_TH {
    ...cmsDetailsLocalized
  }
  tr_TR {
    ...cmsDetailsLocalized
  }
  vi_VN {
    ...cmsDetailsLocalized
  }
  zh_CN {
    ...cmsDetailsLocalized
  }
  zh_TW {
    ...cmsDetailsLocalized
  }
}
    ${CmsDetailsLocalizedFragmentDoc}`;
export const ResourceFragmentDoc = gql`
    fragment resource on CMSResourceEntry {
  id
  resourceCategories
  details {
    ...cmsDetails
  }
  deleted
  featured
  audit {
    createdDate
    updatedDate
    updatedBy
  }
}
    ${CmsDetailsFragmentDoc}`;
export const EventFragmentDoc = gql`
    fragment event on CMSEventEntry {
  id
  eventType
  registrationUrl
  occurrence {
    start
    end
  }
  location {
    lines
    city
    stateOrRegion
    districtOrCounty
    postalCode
    countryCode
  }
  details {
    ...cmsDetails
  }
  deleted
  featured
  audit {
    createdDate
    updatedDate
    updatedBy
  }
}
    ${CmsDetailsFragmentDoc}`;
export const LocalizedDirectoryListingFragmentDoc = gql`
    fragment localizedDirectoryListing on LocalizedDirectoryListing {
  live {
    data {
      revision
    }
    verification {
      status
      submissionCountWithoutApproval
      submissionCountWithoutReview
      firstSubmittedDate
      lastSubmittedDate
    }
  }
}
    `;
export const AwardDetailsFragmentDoc = gql`
    fragment awardDetails on LocalizedAwardDetails {
  description
  locale
  name
}
    `;
export const PartnerAwardDataFragmentDoc = gql`
    fragment partnerAwardData on PartnerAward {
  id
  awardId
  details {
    ...awardDetails
  }
  grant {
    awardedDate
    expirationDate
    revocationDate
  }
  imageDownloadLocation
}
    ${AwardDetailsFragmentDoc}`;
export const ProfileLocalizedDirectoryListingFragmentDoc = gql`
    fragment profileLocalizedDirectoryListing on LocalizedDirectoryListing {
  live {
    data {
      revision
    }
    verification {
      status
      submissionCountWithoutApproval
      submissionCountWithoutReview
      firstSubmittedDate
      lastSubmittedDate
    }
  }
}
    `;
export const ProfileUniversalListingDataFragmentDoc = gql`
    fragment profileUniversalListingData on UniversalDirectoryListingData {
  services
  products
  marketplaces
}
    `;
export const ProfileAwardDetailsFragmentDoc = gql`
    fragment profileAwardDetails on LocalizedAwardDetails {
  description
  locale
  name
}
    `;
export const ProfilePartnerAwardDataFragmentDoc = gql`
    fragment profilePartnerAwardData on PartnerAward {
  id
  awardId
  details {
    ...awardDetails
  }
  grant {
    awardedDate
    expirationDate
    revocationDate
  }
  imageDownloadLocation
}
    ${AwardDetailsFragmentDoc}`;
export const DetailsFieldsFragmentDoc = gql`
    fragment detailsFields on CMSDetailsLocalized {
  title
  shortDescription
  description
  assets {
    mimeType
    link
    storageLocation {
      key
    }
  }
}
    `;
export const DetailsLocaleFieldsFragmentDoc = gql`
    fragment detailsLocaleFields on CMSDetails {
  ar_AE {
    ...detailsFields
  }
  cs_CZ {
    ...detailsFields
  }
  de_DE {
    ...detailsFields
  }
  en_AE {
    ...detailsFields
  }
  en_AU {
    ...detailsFields
  }
  en_CA {
    ...detailsFields
  }
  en_GB {
    ...detailsFields
  }
  en_IN {
    ...detailsFields
  }
  en_SG {
    ...detailsFields
  }
  en_US {
    ...detailsFields
  }
  es_CO {
    ...detailsFields
  }
  es_ES {
    ...detailsFields
  }
  es_MX {
    ...detailsFields
  }
  es_US {
    ...detailsFields
  }
  fr_CA {
    ...detailsFields
  }
  fr_FR {
    ...detailsFields
  }
  he_IL {
    ...detailsFields
  }
  hi_IN {
    ...detailsFields
  }
  it_IT {
    ...detailsFields
  }
  ja_JP {
    ...detailsFields
  }
  kn_IN {
    ...detailsFields
  }
  ko_KR {
    ...detailsFields
  }
  nl_NL {
    ...detailsFields
  }
  pl_PL {
    ...detailsFields
  }
  pt_BR {
    ...detailsFields
  }
  sv_SE {
    ...detailsFields
  }
  ta_IN {
    ...detailsFields
  }
  te_IN {
    ...detailsFields
  }
  th_TH {
    ...detailsFields
  }
  tr_TR {
    ...detailsFields
  }
  vi_VN {
    ...detailsFields
  }
  zh_CN {
    ...detailsFields
  }
  zh_TW {
    ...detailsFields
  }
}
    ${DetailsFieldsFragmentDoc}`;
export const OnlineAgreementFragmentDoc = gql`
    fragment onlineAgreement on OnlineAgreement {
  content
  contentToken
}
    `;
export const GetCmsEntriesDocument = gql`
    query GetCmsEntries($pagination: PaginationInput, $filters: FilterInput, $sorts: [SortInput!], $search: String) {
  cmsEntries(
    pagination: $pagination
    filters: $filters
    sorts: $sorts
    search: $search
  ) {
    edges {
      node {
        ...resourceNode
        ...eventNode
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCMSEntryCount
  }
}
    ${ResourceNodeFragmentDoc}
${EventNodeFragmentDoc}`;

/**
 * __useGetCmsEntriesQuery__
 *
 * To run a query within a React component, call `useGetCmsEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsEntriesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCmsEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCmsEntriesQuery, GetCmsEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsEntriesQuery, GetCmsEntriesQueryVariables>(GetCmsEntriesDocument, options);
      }
export function useGetCmsEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsEntriesQuery, GetCmsEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsEntriesQuery, GetCmsEntriesQueryVariables>(GetCmsEntriesDocument, options);
        }
export type GetCmsEntriesQueryHookResult = ReturnType<typeof useGetCmsEntriesQuery>;
export type GetCmsEntriesLazyQueryHookResult = ReturnType<typeof useGetCmsEntriesLazyQuery>;
export type GetCmsEntriesQueryResult = Apollo.QueryResult<GetCmsEntriesQuery, GetCmsEntriesQueryVariables>;
export const EvaluateFeaturesDocument = gql`
    query EvaluateFeatures($features: [String!]!) {
  evaluateFeatures(input: $features) {
    feature
    variation
  }
}
    `;

/**
 * __useEvaluateFeaturesQuery__
 *
 * To run a query within a React component, call `useEvaluateFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluateFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluateFeaturesQuery({
 *   variables: {
 *      features: // value for 'features'
 *   },
 * });
 */
export function useEvaluateFeaturesQuery(baseOptions: Apollo.QueryHookOptions<EvaluateFeaturesQuery, EvaluateFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluateFeaturesQuery, EvaluateFeaturesQueryVariables>(EvaluateFeaturesDocument, options);
      }
export function useEvaluateFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluateFeaturesQuery, EvaluateFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluateFeaturesQuery, EvaluateFeaturesQueryVariables>(EvaluateFeaturesDocument, options);
        }
export type EvaluateFeaturesQueryHookResult = ReturnType<typeof useEvaluateFeaturesQuery>;
export type EvaluateFeaturesLazyQueryHookResult = ReturnType<typeof useEvaluateFeaturesLazyQuery>;
export type EvaluateFeaturesQueryResult = Apollo.QueryResult<EvaluateFeaturesQuery, EvaluateFeaturesQueryVariables>;
export const GetCompanyNameDocument = gql`
    query getCompanyName {
  partner {
    id
    liveRegistration {
      registration {
        companyName
      }
    }
  }
}
    `;

/**
 * __useGetCompanyNameQuery__
 *
 * To run a query within a React component, call `useGetCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyNameQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyNameQuery, GetCompanyNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyNameQuery, GetCompanyNameQueryVariables>(GetCompanyNameDocument, options);
      }
export function useGetCompanyNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyNameQuery, GetCompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyNameQuery, GetCompanyNameQueryVariables>(GetCompanyNameDocument, options);
        }
export type GetCompanyNameQueryHookResult = ReturnType<typeof useGetCompanyNameQuery>;
export type GetCompanyNameLazyQueryHookResult = ReturnType<typeof useGetCompanyNameLazyQuery>;
export type GetCompanyNameQueryResult = Apollo.QueryResult<GetCompanyNameQuery, GetCompanyNameQueryVariables>;
export const GetWhoAmIDocument = gql`
    query GetWhoAmI {
  whoAmI {
    rights
    userName
    userEmail
    partnerUserRole
  }
  partnerGroup {
    groupId
  }
}
    `;

/**
 * __useGetWhoAmIQuery__
 *
 * To run a query within a React component, call `useGetWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<GetWhoAmIQuery, GetWhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhoAmIQuery, GetWhoAmIQueryVariables>(GetWhoAmIDocument, options);
      }
export function useGetWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhoAmIQuery, GetWhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhoAmIQuery, GetWhoAmIQueryVariables>(GetWhoAmIDocument, options);
        }
export type GetWhoAmIQueryHookResult = ReturnType<typeof useGetWhoAmIQuery>;
export type GetWhoAmILazyQueryHookResult = ReturnType<typeof useGetWhoAmILazyQuery>;
export type GetWhoAmIQueryResult = Apollo.QueryResult<GetWhoAmIQuery, GetWhoAmIQueryVariables>;
export const GetPartnerStatusDocument = gql`
    query GetPartnerStatus {
  partner {
    badges {
      admin {
        accreditation {
          type
          statusInfo {
            status
            lastUpdatedBy
            lastUpdatedDate
          }
        }
      }
    }
    disabledStatus {
      isDisabled
      updatedDate
    }
    liveRegistration {
      registration {
        companyName
      }
      verification {
        lastReviewedDate
      }
    }
    partnerGroupSummary {
      groupId
    }
    accreditationStatus {
      value
    }
  }
}
    `;

/**
 * __useGetPartnerStatusQuery__
 *
 * To run a query within a React component, call `useGetPartnerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerStatusQuery, GetPartnerStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerStatusQuery, GetPartnerStatusQueryVariables>(GetPartnerStatusDocument, options);
      }
export function useGetPartnerStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerStatusQuery, GetPartnerStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerStatusQuery, GetPartnerStatusQueryVariables>(GetPartnerStatusDocument, options);
        }
export type GetPartnerStatusQueryHookResult = ReturnType<typeof useGetPartnerStatusQuery>;
export type GetPartnerStatusLazyQueryHookResult = ReturnType<typeof useGetPartnerStatusLazyQuery>;
export type GetPartnerStatusQueryResult = Apollo.QueryResult<GetPartnerStatusQuery, GetPartnerStatusQueryVariables>;
export const GetPartnersDocument = gql`
    query GetPartners($after: Cursor) {
  partners(after: $after) {
    edges {
      node {
        id
        liveRegistration {
          registration {
            companyName
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetPartnersQuery__
 *
 * To run a query within a React component, call `useGetPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnersQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPartnersQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnersQuery, GetPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnersQuery, GetPartnersQueryVariables>(GetPartnersDocument, options);
      }
export function useGetPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnersQuery, GetPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnersQuery, GetPartnersQueryVariables>(GetPartnersDocument, options);
        }
export type GetPartnersQueryHookResult = ReturnType<typeof useGetPartnersQuery>;
export type GetPartnersLazyQueryHookResult = ReturnType<typeof useGetPartnersLazyQuery>;
export type GetPartnersQueryResult = Apollo.QueryResult<GetPartnersQuery, GetPartnersQueryVariables>;
export const SetUserPreferencesDocument = gql`
    mutation SetUserPreferences($input: SetUserPreferencesInput!) {
  setUserPreferences(input: $input) {
    __typename
    ... on UserPreferences {
      locale {
        preferredLocale
      }
      partnerId
    }
    ... on RetryableDependency {
      code
    }
    ... on NonRetryableDependency {
      code
    }
  }
}
    `;
export type SetUserPreferencesMutationFn = Apollo.MutationFunction<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>;

/**
 * __useSetUserPreferencesMutation__
 *
 * To run a mutation, you first call `useSetUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPreferencesMutation, { data, loading, error }] = useSetUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>(SetUserPreferencesDocument, options);
      }
export type SetUserPreferencesMutationHookResult = ReturnType<typeof useSetUserPreferencesMutation>;
export type SetUserPreferencesMutationResult = Apollo.MutationResult<SetUserPreferencesMutation>;
export type SetUserPreferencesMutationOptions = Apollo.BaseMutationOptions<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>;
export const GetUserPreferencesV2Document = gql`
    query GetUserPreferencesV2 {
  getUserPreferencesV2 {
    __typename
    ... on UserPreferences {
      locale {
        preferredLocale
      }
      partnerId
    }
    ... on RetryableDependency {
      code
    }
    ... on NonRetryableDependency {
      code
    }
  }
}
    `;

/**
 * __useGetUserPreferencesV2Query__
 *
 * To run a query within a React component, call `useGetUserPreferencesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferencesV2Query(baseOptions?: Apollo.QueryHookOptions<GetUserPreferencesV2Query, GetUserPreferencesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPreferencesV2Query, GetUserPreferencesV2QueryVariables>(GetUserPreferencesV2Document, options);
      }
export function useGetUserPreferencesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferencesV2Query, GetUserPreferencesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPreferencesV2Query, GetUserPreferencesV2QueryVariables>(GetUserPreferencesV2Document, options);
        }
export type GetUserPreferencesV2QueryHookResult = ReturnType<typeof useGetUserPreferencesV2Query>;
export type GetUserPreferencesV2LazyQueryHookResult = ReturnType<typeof useGetUserPreferencesV2LazyQuery>;
export type GetUserPreferencesV2QueryResult = Apollo.QueryResult<GetUserPreferencesV2Query, GetUserPreferencesV2QueryVariables>;
export const UpdateFeaturedContentRequestDocument = gql`
    mutation UpdateFeaturedContentRequest($input: UpdateFeaturedContentRequestInput!) {
  updateFeaturedContentRequest(input: $input) {
    ... on FeaturedContentRequest {
      id
      draft {
        ...featuredContentRequestInfo
      }
      live {
        featuredContentRequestInfo {
          ...featuredContentRequestInfo
        }
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${FeaturedContentRequestInfoFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type UpdateFeaturedContentRequestMutationFn = Apollo.MutationFunction<UpdateFeaturedContentRequestMutation, UpdateFeaturedContentRequestMutationVariables>;

/**
 * __useUpdateFeaturedContentRequestMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturedContentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturedContentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturedContentRequestMutation, { data, loading, error }] = useUpdateFeaturedContentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeaturedContentRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeaturedContentRequestMutation, UpdateFeaturedContentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeaturedContentRequestMutation, UpdateFeaturedContentRequestMutationVariables>(UpdateFeaturedContentRequestDocument, options);
      }
export type UpdateFeaturedContentRequestMutationHookResult = ReturnType<typeof useUpdateFeaturedContentRequestMutation>;
export type UpdateFeaturedContentRequestMutationResult = Apollo.MutationResult<UpdateFeaturedContentRequestMutation>;
export type UpdateFeaturedContentRequestMutationOptions = Apollo.BaseMutationOptions<UpdateFeaturedContentRequestMutation, UpdateFeaturedContentRequestMutationVariables>;
export const GetFeaturedContentRequestsDocument = gql`
    query GetFeaturedContentRequests {
  partner {
    id
    featuredContentRequests {
      ...featuredContentRequestEntries
    }
  }
}
    ${FeaturedContentRequestEntriesFragmentDoc}`;

/**
 * __useGetFeaturedContentRequestsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedContentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedContentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedContentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedContentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedContentRequestsQuery, GetFeaturedContentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedContentRequestsQuery, GetFeaturedContentRequestsQueryVariables>(GetFeaturedContentRequestsDocument, options);
      }
export function useGetFeaturedContentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedContentRequestsQuery, GetFeaturedContentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedContentRequestsQuery, GetFeaturedContentRequestsQueryVariables>(GetFeaturedContentRequestsDocument, options);
        }
export type GetFeaturedContentRequestsQueryHookResult = ReturnType<typeof useGetFeaturedContentRequestsQuery>;
export type GetFeaturedContentRequestsLazyQueryHookResult = ReturnType<typeof useGetFeaturedContentRequestsLazyQuery>;
export type GetFeaturedContentRequestsQueryResult = Apollo.QueryResult<GetFeaturedContentRequestsQuery, GetFeaturedContentRequestsQueryVariables>;
export const GetDirectoryListingsDocument = gql`
    query GetDirectoryListings {
  partner {
    id
    accreditationStatus {
      value
      updatedDate
      updatedBy
    }
    badges {
      ...badgesData
    }
    liveDirectoryListingData {
      ...universalListingData
    }
    localizedDirectoryListings {
      ...localizedDirectories
    }
    partnerLogo {
      ...partnerLogoData
    }
    social {
      ...socialData
    }
    featuredContentRequests {
      ...dlFeaturedContentRequestEntries
    }
    featuredContent {
      id
      ...caseStudy
    }
  }
}
    ${BadgesDataFragmentDoc}
${UniversalListingDataFragmentDoc}
${LocalizedDirectoriesFragmentDoc}
${PartnerLogoDataFragmentDoc}
${SocialDataFragmentDoc}
${DlFeaturedContentRequestEntriesFragmentDoc}
${CaseStudyFragmentDoc}`;

/**
 * __useGetDirectoryListingsQuery__
 *
 * To run a query within a React component, call `useGetDirectoryListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectoryListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectoryListingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDirectoryListingsQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectoryListingsQuery, GetDirectoryListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectoryListingsQuery, GetDirectoryListingsQueryVariables>(GetDirectoryListingsDocument, options);
      }
export function useGetDirectoryListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectoryListingsQuery, GetDirectoryListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectoryListingsQuery, GetDirectoryListingsQueryVariables>(GetDirectoryListingsDocument, options);
        }
export type GetDirectoryListingsQueryHookResult = ReturnType<typeof useGetDirectoryListingsQuery>;
export type GetDirectoryListingsLazyQueryHookResult = ReturnType<typeof useGetDirectoryListingsLazyQuery>;
export type GetDirectoryListingsQueryResult = Apollo.QueryResult<GetDirectoryListingsQuery, GetDirectoryListingsQueryVariables>;
export const GetSocialDataDocument = gql`
    query GetSocialData {
  partner {
    id
    accreditationStatus {
      value
      updatedDate
      updatedBy
    }
    social {
      ...socialData
    }
  }
}
    ${SocialDataFragmentDoc}`;

/**
 * __useGetSocialDataQuery__
 *
 * To run a query within a React component, call `useGetSocialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialDataQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialDataQuery, GetSocialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialDataQuery, GetSocialDataQueryVariables>(GetSocialDataDocument, options);
      }
export function useGetSocialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialDataQuery, GetSocialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialDataQuery, GetSocialDataQueryVariables>(GetSocialDataDocument, options);
        }
export type GetSocialDataQueryHookResult = ReturnType<typeof useGetSocialDataQuery>;
export type GetSocialDataLazyQueryHookResult = ReturnType<typeof useGetSocialDataLazyQuery>;
export type GetSocialDataQueryResult = Apollo.QueryResult<GetSocialDataQuery, GetSocialDataQueryVariables>;
export const UpdateSocialDataDocument = gql`
    mutation UpdateSocialData($input: UpdateSocialDataInput!) {
  updateSocialData(input: $input) {
    ... on Partner {
      id
      social {
        ...socialData
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${SocialDataFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type UpdateSocialDataMutationFn = Apollo.MutationFunction<UpdateSocialDataMutation, UpdateSocialDataMutationVariables>;

/**
 * __useUpdateSocialDataMutation__
 *
 * To run a mutation, you first call `useUpdateSocialDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialDataMutation, { data, loading, error }] = useUpdateSocialDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialDataMutation, UpdateSocialDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialDataMutation, UpdateSocialDataMutationVariables>(UpdateSocialDataDocument, options);
      }
export type UpdateSocialDataMutationHookResult = ReturnType<typeof useUpdateSocialDataMutation>;
export type UpdateSocialDataMutationResult = Apollo.MutationResult<UpdateSocialDataMutation>;
export type UpdateSocialDataMutationOptions = Apollo.BaseMutationOptions<UpdateSocialDataMutation, UpdateSocialDataMutationVariables>;
export const DeleteSocialDataDocument = gql`
    mutation DeleteSocialData($input: SocialDataInput!) {
  deleteSocialData(input: $input) {
    ... on Partner {
      id
      social {
        ...socialData
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${SocialDataFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type DeleteSocialDataMutationFn = Apollo.MutationFunction<DeleteSocialDataMutation, DeleteSocialDataMutationVariables>;

/**
 * __useDeleteSocialDataMutation__
 *
 * To run a mutation, you first call `useDeleteSocialDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialDataMutation, { data, loading, error }] = useDeleteSocialDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSocialDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSocialDataMutation, DeleteSocialDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSocialDataMutation, DeleteSocialDataMutationVariables>(DeleteSocialDataDocument, options);
      }
export type DeleteSocialDataMutationHookResult = ReturnType<typeof useDeleteSocialDataMutation>;
export type DeleteSocialDataMutationResult = Apollo.MutationResult<DeleteSocialDataMutation>;
export type DeleteSocialDataMutationOptions = Apollo.BaseMutationOptions<DeleteSocialDataMutation, DeleteSocialDataMutationVariables>;
export const UpdateUniversalListingDocument = gql`
    mutation UpdateUniversalListing($input: UpdateUniversalListingInput!) {
  updateUniversalListing(input: $input) {
    ... on Partner {
      id
      liveDirectoryListingData {
        ...universalListingData
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${UniversalListingDataFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type UpdateUniversalListingMutationFn = Apollo.MutationFunction<UpdateUniversalListingMutation, UpdateUniversalListingMutationVariables>;

/**
 * __useUpdateUniversalListingMutation__
 *
 * To run a mutation, you first call `useUpdateUniversalListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUniversalListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUniversalListingMutation, { data, loading, error }] = useUpdateUniversalListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUniversalListingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUniversalListingMutation, UpdateUniversalListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUniversalListingMutation, UpdateUniversalListingMutationVariables>(UpdateUniversalListingDocument, options);
      }
export type UpdateUniversalListingMutationHookResult = ReturnType<typeof useUpdateUniversalListingMutation>;
export type UpdateUniversalListingMutationResult = Apollo.MutationResult<UpdateUniversalListingMutation>;
export type UpdateUniversalListingMutationOptions = Apollo.BaseMutationOptions<UpdateUniversalListingMutation, UpdateUniversalListingMutationVariables>;
export const UpdateLocalizedListingDocument = gql`
    mutation UpdateLocalizedListing($input: UpdateLocalizedListingInput!) {
  updateLocalizedListing(input: $input) {
    ... on Partner {
      id
      localizedDirectoryListings {
        ...localizedDirectories
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${LocalizedDirectoriesFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type UpdateLocalizedListingMutationFn = Apollo.MutationFunction<UpdateLocalizedListingMutation, UpdateLocalizedListingMutationVariables>;

/**
 * __useUpdateLocalizedListingMutation__
 *
 * To run a mutation, you first call `useUpdateLocalizedListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalizedListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalizedListingMutation, { data, loading, error }] = useUpdateLocalizedListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalizedListingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocalizedListingMutation, UpdateLocalizedListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocalizedListingMutation, UpdateLocalizedListingMutationVariables>(UpdateLocalizedListingDocument, options);
      }
export type UpdateLocalizedListingMutationHookResult = ReturnType<typeof useUpdateLocalizedListingMutation>;
export type UpdateLocalizedListingMutationResult = Apollo.MutationResult<UpdateLocalizedListingMutation>;
export type UpdateLocalizedListingMutationOptions = Apollo.BaseMutationOptions<UpdateLocalizedListingMutation, UpdateLocalizedListingMutationVariables>;
export const DeleteListingSubmissionDocument = gql`
    mutation DeleteListingSubmission($input: DeleteListingSubmissionInput!) {
  deleteListingSubmission(input: $input) {
    ... on Partner {
      id
      localizedDirectoryListings {
        ...localizedDirectories
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${LocalizedDirectoriesFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type DeleteListingSubmissionMutationFn = Apollo.MutationFunction<DeleteListingSubmissionMutation, DeleteListingSubmissionMutationVariables>;

/**
 * __useDeleteListingSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteListingSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListingSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListingSubmissionMutation, { data, loading, error }] = useDeleteListingSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteListingSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListingSubmissionMutation, DeleteListingSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListingSubmissionMutation, DeleteListingSubmissionMutationVariables>(DeleteListingSubmissionDocument, options);
      }
export type DeleteListingSubmissionMutationHookResult = ReturnType<typeof useDeleteListingSubmissionMutation>;
export type DeleteListingSubmissionMutationResult = Apollo.MutationResult<DeleteListingSubmissionMutation>;
export type DeleteListingSubmissionMutationOptions = Apollo.BaseMutationOptions<DeleteListingSubmissionMutation, DeleteListingSubmissionMutationVariables>;
export const UnpublishListingDocument = gql`
    mutation UnpublishListing($input: UnpublishListingInput!) {
  unpublishListing(input: $input) {
    ... on Partner {
      id
      localizedDirectoryListings {
        ...localizedDirectories
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${LocalizedDirectoriesFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type UnpublishListingMutationFn = Apollo.MutationFunction<UnpublishListingMutation, UnpublishListingMutationVariables>;

/**
 * __useUnpublishListingMutation__
 *
 * To run a mutation, you first call `useUnpublishListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishListingMutation, { data, loading, error }] = useUnpublishListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpublishListingMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishListingMutation, UnpublishListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishListingMutation, UnpublishListingMutationVariables>(UnpublishListingDocument, options);
      }
export type UnpublishListingMutationHookResult = ReturnType<typeof useUnpublishListingMutation>;
export type UnpublishListingMutationResult = Apollo.MutationResult<UnpublishListingMutation>;
export type UnpublishListingMutationOptions = Apollo.BaseMutationOptions<UnpublishListingMutation, UnpublishListingMutationVariables>;
export const GetLogoDownloadDocument = gql`
    query GetLogoDownload($version: Int) {
  partnerLogoDownloadURL(version: $version) {
    downloadUrl
    downloadVersion
  }
}
    `;

/**
 * __useGetLogoDownloadQuery__
 *
 * To run a query within a React component, call `useGetLogoDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogoDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogoDownloadQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetLogoDownloadQuery(baseOptions?: Apollo.QueryHookOptions<GetLogoDownloadQuery, GetLogoDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogoDownloadQuery, GetLogoDownloadQueryVariables>(GetLogoDownloadDocument, options);
      }
export function useGetLogoDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogoDownloadQuery, GetLogoDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogoDownloadQuery, GetLogoDownloadQueryVariables>(GetLogoDownloadDocument, options);
        }
export type GetLogoDownloadQueryHookResult = ReturnType<typeof useGetLogoDownloadQuery>;
export type GetLogoDownloadLazyQueryHookResult = ReturnType<typeof useGetLogoDownloadLazyQuery>;
export type GetLogoDownloadQueryResult = Apollo.QueryResult<GetLogoDownloadQuery, GetLogoDownloadQueryVariables>;
export const GetLogoUploadDocument = gql`
    query GetLogoUpload($mediaType: String!) {
  partnerLogoUploadURL(mediaType: $mediaType) {
    uploadUrl
  }
}
    `;

/**
 * __useGetLogoUploadQuery__
 *
 * To run a query within a React component, call `useGetLogoUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogoUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogoUploadQuery({
 *   variables: {
 *      mediaType: // value for 'mediaType'
 *   },
 * });
 */
export function useGetLogoUploadQuery(baseOptions: Apollo.QueryHookOptions<GetLogoUploadQuery, GetLogoUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogoUploadQuery, GetLogoUploadQueryVariables>(GetLogoUploadDocument, options);
      }
export function useGetLogoUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogoUploadQuery, GetLogoUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogoUploadQuery, GetLogoUploadQueryVariables>(GetLogoUploadDocument, options);
        }
export type GetLogoUploadQueryHookResult = ReturnType<typeof useGetLogoUploadQuery>;
export type GetLogoUploadLazyQueryHookResult = ReturnType<typeof useGetLogoUploadLazyQuery>;
export type GetLogoUploadQueryResult = Apollo.QueryResult<GetLogoUploadQuery, GetLogoUploadQueryVariables>;
export const SubmitPartnerLogoDocument = gql`
    mutation SubmitPartnerLogo($input: SubmitPartnerLogoInput!) {
  submitPartnerLogo(input: $input) {
    ... on Partner {
      id
      partnerLogo {
        ...partnerLogoData
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${PartnerLogoDataFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type SubmitPartnerLogoMutationFn = Apollo.MutationFunction<SubmitPartnerLogoMutation, SubmitPartnerLogoMutationVariables>;

/**
 * __useSubmitPartnerLogoMutation__
 *
 * To run a mutation, you first call `useSubmitPartnerLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPartnerLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPartnerLogoMutation, { data, loading, error }] = useSubmitPartnerLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPartnerLogoMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPartnerLogoMutation, SubmitPartnerLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPartnerLogoMutation, SubmitPartnerLogoMutationVariables>(SubmitPartnerLogoDocument, options);
      }
export type SubmitPartnerLogoMutationHookResult = ReturnType<typeof useSubmitPartnerLogoMutation>;
export type SubmitPartnerLogoMutationResult = Apollo.MutationResult<SubmitPartnerLogoMutation>;
export type SubmitPartnerLogoMutationOptions = Apollo.BaseMutationOptions<SubmitPartnerLogoMutation, SubmitPartnerLogoMutationVariables>;
export const UnsubmitPartnerLogoDocument = gql`
    mutation unsubmitPartnerLogo($input: UnsubmitPartnerLogoInput!) {
  unsubmitPartnerLogo(input: $input) {
    ... on Partner {
      id
      partnerLogo {
        ...partnerLogoData
      }
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${PartnerLogoDataFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type UnsubmitPartnerLogoMutationFn = Apollo.MutationFunction<UnsubmitPartnerLogoMutation, UnsubmitPartnerLogoMutationVariables>;

/**
 * __useUnsubmitPartnerLogoMutation__
 *
 * To run a mutation, you first call `useUnsubmitPartnerLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubmitPartnerLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubmitPartnerLogoMutation, { data, loading, error }] = useUnsubmitPartnerLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubmitPartnerLogoMutation(baseOptions?: Apollo.MutationHookOptions<UnsubmitPartnerLogoMutation, UnsubmitPartnerLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubmitPartnerLogoMutation, UnsubmitPartnerLogoMutationVariables>(UnsubmitPartnerLogoDocument, options);
      }
export type UnsubmitPartnerLogoMutationHookResult = ReturnType<typeof useUnsubmitPartnerLogoMutation>;
export type UnsubmitPartnerLogoMutationResult = Apollo.MutationResult<UnsubmitPartnerLogoMutation>;
export type UnsubmitPartnerLogoMutationOptions = Apollo.BaseMutationOptions<UnsubmitPartnerLogoMutation, UnsubmitPartnerLogoMutationVariables>;
export const PitchDeckDocument = gql`
    mutation PitchDeck($input: PitchDeckInput!) {
  pitchDeck(input: $input) {
    ... on PitchDeckDownloadUrl {
      downloadUrl
    }
    ... on ClientError {
      code
      message
    }
  }
}
    `;
export type PitchDeckMutationFn = Apollo.MutationFunction<PitchDeckMutation, PitchDeckMutationVariables>;

/**
 * __usePitchDeckMutation__
 *
 * To run a mutation, you first call `usePitchDeckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePitchDeckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pitchDeckMutation, { data, loading, error }] = usePitchDeckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePitchDeckMutation(baseOptions?: Apollo.MutationHookOptions<PitchDeckMutation, PitchDeckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PitchDeckMutation, PitchDeckMutationVariables>(PitchDeckDocument, options);
      }
export type PitchDeckMutationHookResult = ReturnType<typeof usePitchDeckMutation>;
export type PitchDeckMutationResult = Apollo.MutationResult<PitchDeckMutation>;
export type PitchDeckMutationOptions = Apollo.BaseMutationOptions<PitchDeckMutation, PitchDeckMutationVariables>;
export const UpdatePartnerRegistrationDocument = gql`
    mutation UpdatePartnerRegistration($updateRegistrationInput: UpdatePartnerRegistrationInput!) {
  updatePartnerRegistration(updateRegistrationInput: $updateRegistrationInput) {
    ... on Partner {
      id
      reviewRegistration {
        registration {
          revision
          companyName
          companyWebsite
          companyAddress {
            lines
            city
            stateOrRegion
            districtOrCounty
            postalCode
            countryCode
          }
          incorporationCountry
          registrationNumber
          submissionNotes
          convertedFromRegionalManagerAccount {
            id
            region
          }
          emailDomain
        }
        verification {
          status
          rejectionReasons
          mutableRejectionReasons {
            id
            message
            helpContentIds
            version
            translations {
              text
              locale
            }
          }
          rejectionDetails
          lastSubmittedDate
          lastReviewedDate
        }
      }
    }
    ... on MutationError {
      errors {
        argumentName
      }
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type UpdatePartnerRegistrationMutationFn = Apollo.MutationFunction<UpdatePartnerRegistrationMutation, UpdatePartnerRegistrationMutationVariables>;

/**
 * __useUpdatePartnerRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerRegistrationMutation, { data, loading, error }] = useUpdatePartnerRegistrationMutation({
 *   variables: {
 *      updateRegistrationInput: // value for 'updateRegistrationInput'
 *   },
 * });
 */
export function useUpdatePartnerRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerRegistrationMutation, UpdatePartnerRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerRegistrationMutation, UpdatePartnerRegistrationMutationVariables>(UpdatePartnerRegistrationDocument, options);
      }
export type UpdatePartnerRegistrationMutationHookResult = ReturnType<typeof useUpdatePartnerRegistrationMutation>;
export type UpdatePartnerRegistrationMutationResult = Apollo.MutationResult<UpdatePartnerRegistrationMutation>;
export type UpdatePartnerRegistrationMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerRegistrationMutation, UpdatePartnerRegistrationMutationVariables>;
export const UpdateUnmoderatedPartnerRegDocument = gql`
    mutation UpdateUnmoderatedPartnerReg($input: UnmoderatedPartnerRegInput!) {
  updateUnmoderatedPartnerReg(input: $input) {
    ... on Partner {
      id
      unmoderatedRegistrationData {
        adOffering
        servicesCategory
        advertiserBusinessTypes
        adProductsInterest
      }
    }
    ... on MutationError {
      errors {
        argumentName
      }
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type UpdateUnmoderatedPartnerRegMutationFn = Apollo.MutationFunction<UpdateUnmoderatedPartnerRegMutation, UpdateUnmoderatedPartnerRegMutationVariables>;

/**
 * __useUpdateUnmoderatedPartnerRegMutation__
 *
 * To run a mutation, you first call `useUpdateUnmoderatedPartnerRegMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnmoderatedPartnerRegMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnmoderatedPartnerRegMutation, { data, loading, error }] = useUpdateUnmoderatedPartnerRegMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUnmoderatedPartnerRegMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnmoderatedPartnerRegMutation, UpdateUnmoderatedPartnerRegMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnmoderatedPartnerRegMutation, UpdateUnmoderatedPartnerRegMutationVariables>(UpdateUnmoderatedPartnerRegDocument, options);
      }
export type UpdateUnmoderatedPartnerRegMutationHookResult = ReturnType<typeof useUpdateUnmoderatedPartnerRegMutation>;
export type UpdateUnmoderatedPartnerRegMutationResult = Apollo.MutationResult<UpdateUnmoderatedPartnerRegMutation>;
export type UpdateUnmoderatedPartnerRegMutationOptions = Apollo.BaseMutationOptions<UpdateUnmoderatedPartnerRegMutation, UpdateUnmoderatedPartnerRegMutationVariables>;
export const GetPartnerRegistrationInfoDocument = gql`
    query GetPartnerRegistrationInfo {
  partner {
    id
    reviewRegistration {
      registration {
        revision
        companyName
        companyWebsite
        companyAddress {
          lines
          city
          stateOrRegion
          districtOrCounty
          postalCode
          countryCode
        }
        incorporationCountry
        registrationNumber
        submissionNotes
        convertedFromRegionalManagerAccount {
          id
          region
        }
      }
      verification {
        status
        rejectionReasons
        mutableRejectionReasons {
          id
          message
          helpContentIds
          version
          translations {
            text
            locale
          }
        }
        rejectionDetails
        lastSubmittedDate
        lastReviewedDate
      }
    }
    liveRegistration {
      registration {
        revision
        companyName
        companyWebsite
        companyAddress {
          lines
          city
          stateOrRegion
          districtOrCounty
          postalCode
          countryCode
        }
        incorporationCountry
        registrationNumber
        submissionNotes
        convertedFromRegionalManagerAccount {
          id
          region
        }
      }
    }
    unmoderatedRegistrationData {
      adOffering
      servicesCategory
      advertiserBusinessTypes
      adProductsInterest
    }
  }
}
    `;

/**
 * __useGetPartnerRegistrationInfoQuery__
 *
 * To run a query within a React component, call `useGetPartnerRegistrationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerRegistrationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerRegistrationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerRegistrationInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerRegistrationInfoQuery, GetPartnerRegistrationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerRegistrationInfoQuery, GetPartnerRegistrationInfoQueryVariables>(GetPartnerRegistrationInfoDocument, options);
      }
export function useGetPartnerRegistrationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerRegistrationInfoQuery, GetPartnerRegistrationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerRegistrationInfoQuery, GetPartnerRegistrationInfoQueryVariables>(GetPartnerRegistrationInfoDocument, options);
        }
export type GetPartnerRegistrationInfoQueryHookResult = ReturnType<typeof useGetPartnerRegistrationInfoQuery>;
export type GetPartnerRegistrationInfoLazyQueryHookResult = ReturnType<typeof useGetPartnerRegistrationInfoLazyQuery>;
export type GetPartnerRegistrationInfoQueryResult = Apollo.QueryResult<GetPartnerRegistrationInfoQuery, GetPartnerRegistrationInfoQueryVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($input: UpdatePartnerProfileDraftInput!) {
  updatePartnerProfileDraft(input: $input) {
    id
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const GetEventDocument = gql`
    query GetEvent($id: ID!) {
  cmsEntry(id: $id) {
    id
    audit {
      createdDate
      updatedDate
      updatedBy
    }
    deleted
    featured
    productCategories
    tags
    targetSegments
    details {
      ...eventDetailsLocaleFields
    }
    ... on CMSEventEntry {
      registrationUrl
      occurrence {
        start
        end
      }
      location {
        lines
        city
        stateOrRegion
        districtOrCounty
        postalCode
        countryCode
      }
    }
  }
}
    ${EventDetailsLocaleFieldsFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetAdvertiserInviteDocument = gql`
    query GetAdvertiserInvite($inviteId: ID!) {
  advertiserInvite(inviteId: $inviteId) {
    ... on PartnerAdvertiserInvite {
      partner {
        liveRegistration {
          registration {
            companyName
            companyWebsite
          }
        }
      }
      status
    }
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    `;

/**
 * __useGetAdvertiserInviteQuery__
 *
 * To run a query within a React component, call `useGetAdvertiserInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertiserInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertiserInviteQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useGetAdvertiserInviteQuery(baseOptions: Apollo.QueryHookOptions<GetAdvertiserInviteQuery, GetAdvertiserInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertiserInviteQuery, GetAdvertiserInviteQueryVariables>(GetAdvertiserInviteDocument, options);
      }
export function useGetAdvertiserInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertiserInviteQuery, GetAdvertiserInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertiserInviteQuery, GetAdvertiserInviteQueryVariables>(GetAdvertiserInviteDocument, options);
        }
export type GetAdvertiserInviteQueryHookResult = ReturnType<typeof useGetAdvertiserInviteQuery>;
export type GetAdvertiserInviteLazyQueryHookResult = ReturnType<typeof useGetAdvertiserInviteLazyQuery>;
export type GetAdvertiserInviteQueryResult = Apollo.QueryResult<GetAdvertiserInviteQuery, GetAdvertiserInviteQueryVariables>;
export const GetUserInvitedAdvertisersDocument = gql`
    query GetUserInvitedAdvertisers($inviteId: ID!) {
  userInvitedAdvertisers(inviteId: $inviteId) {
    ... on UserInviteAdvertisers {
      advertisers {
        advertiser {
          id
          name
          type
          countryCode
        }
        isLinked
      }
    }
    ... on InvalidState {
      code
    }
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    `;

/**
 * __useGetUserInvitedAdvertisersQuery__
 *
 * To run a query within a React component, call `useGetUserInvitedAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvitedAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvitedAdvertisersQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useGetUserInvitedAdvertisersQuery(baseOptions: Apollo.QueryHookOptions<GetUserInvitedAdvertisersQuery, GetUserInvitedAdvertisersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInvitedAdvertisersQuery, GetUserInvitedAdvertisersQueryVariables>(GetUserInvitedAdvertisersDocument, options);
      }
export function useGetUserInvitedAdvertisersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInvitedAdvertisersQuery, GetUserInvitedAdvertisersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInvitedAdvertisersQuery, GetUserInvitedAdvertisersQueryVariables>(GetUserInvitedAdvertisersDocument, options);
        }
export type GetUserInvitedAdvertisersQueryHookResult = ReturnType<typeof useGetUserInvitedAdvertisersQuery>;
export type GetUserInvitedAdvertisersLazyQueryHookResult = ReturnType<typeof useGetUserInvitedAdvertisersLazyQuery>;
export type GetUserInvitedAdvertisersQueryResult = Apollo.QueryResult<GetUserInvitedAdvertisersQuery, GetUserInvitedAdvertisersQueryVariables>;
export const RedeemPartnerAdvertiserInviteDocument = gql`
    mutation RedeemPartnerAdvertiserInvite($input: RedeemPartnerAdvertiserInviteInput!) {
  redeemPartnerAdvertiserInvite(input: $input) {
    ... on PartnerAdvertiserInvite {
      status
    }
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type RedeemPartnerAdvertiserInviteMutationFn = Apollo.MutationFunction<RedeemPartnerAdvertiserInviteMutation, RedeemPartnerAdvertiserInviteMutationVariables>;

/**
 * __useRedeemPartnerAdvertiserInviteMutation__
 *
 * To run a mutation, you first call `useRedeemPartnerAdvertiserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemPartnerAdvertiserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemPartnerAdvertiserInviteMutation, { data, loading, error }] = useRedeemPartnerAdvertiserInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedeemPartnerAdvertiserInviteMutation(baseOptions?: Apollo.MutationHookOptions<RedeemPartnerAdvertiserInviteMutation, RedeemPartnerAdvertiserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemPartnerAdvertiserInviteMutation, RedeemPartnerAdvertiserInviteMutationVariables>(RedeemPartnerAdvertiserInviteDocument, options);
      }
export type RedeemPartnerAdvertiserInviteMutationHookResult = ReturnType<typeof useRedeemPartnerAdvertiserInviteMutation>;
export type RedeemPartnerAdvertiserInviteMutationResult = Apollo.MutationResult<RedeemPartnerAdvertiserInviteMutation>;
export type RedeemPartnerAdvertiserInviteMutationOptions = Apollo.BaseMutationOptions<RedeemPartnerAdvertiserInviteMutation, RedeemPartnerAdvertiserInviteMutationVariables>;
export const GetPartnerUserInviteDocument = gql`
    query GetPartnerUserInvite($inviteToken: ID!) {
  partnerUserInvite(inviteToken: $inviteToken) {
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
    ... on PartnerUserInvite {
      id
      invitedBy {
        id
        name
      }
      creationDate
      revokedDate
      acceptedDate
      expirationDate
      partner {
        id
        liveRegistration {
          registration {
            companyName
          }
        }
      }
      status
    }
  }
}
    `;

/**
 * __useGetPartnerUserInviteQuery__
 *
 * To run a query within a React component, call `useGetPartnerUserInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUserInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUserInviteQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useGetPartnerUserInviteQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerUserInviteQuery, GetPartnerUserInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerUserInviteQuery, GetPartnerUserInviteQueryVariables>(GetPartnerUserInviteDocument, options);
      }
export function useGetPartnerUserInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerUserInviteQuery, GetPartnerUserInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerUserInviteQuery, GetPartnerUserInviteQueryVariables>(GetPartnerUserInviteDocument, options);
        }
export type GetPartnerUserInviteQueryHookResult = ReturnType<typeof useGetPartnerUserInviteQuery>;
export type GetPartnerUserInviteLazyQueryHookResult = ReturnType<typeof useGetPartnerUserInviteLazyQuery>;
export type GetPartnerUserInviteQueryResult = Apollo.QueryResult<GetPartnerUserInviteQuery, GetPartnerUserInviteQueryVariables>;
export const RedeemPartnerUserInviteDocument = gql`
    mutation RedeemPartnerUserInvite($inviteId: ID!) {
  redeemPartnerUserInvite(inviteId: $inviteId) {
    ...partnerUserInvite
    ... on NotFound {
      code
    }
    ... on InvalidState {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    ${PartnerUserInviteFragmentDoc}`;
export type RedeemPartnerUserInviteMutationFn = Apollo.MutationFunction<RedeemPartnerUserInviteMutation, RedeemPartnerUserInviteMutationVariables>;

/**
 * __useRedeemPartnerUserInviteMutation__
 *
 * To run a mutation, you first call `useRedeemPartnerUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemPartnerUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemPartnerUserInviteMutation, { data, loading, error }] = useRedeemPartnerUserInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRedeemPartnerUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<RedeemPartnerUserInviteMutation, RedeemPartnerUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemPartnerUserInviteMutation, RedeemPartnerUserInviteMutationVariables>(RedeemPartnerUserInviteDocument, options);
      }
export type RedeemPartnerUserInviteMutationHookResult = ReturnType<typeof useRedeemPartnerUserInviteMutation>;
export type RedeemPartnerUserInviteMutationResult = Apollo.MutationResult<RedeemPartnerUserInviteMutation>;
export type RedeemPartnerUserInviteMutationOptions = Apollo.BaseMutationOptions<RedeemPartnerUserInviteMutation, RedeemPartnerUserInviteMutationVariables>;
export const SubmitBulkAccountCreationDocument = gql`
    mutation SubmitBulkAccountCreation($input: SubmitBulkAccountCreationRequest!) {
  submitBulkAccountCreation(input: $input) {
    __typename
    ... on SubmitBulkAccountCreationOutput {
      requestId
      status
      __typename
    }
    ... on ClientError {
      code
      message
      __typename
    }
  }
}
    `;
export type SubmitBulkAccountCreationMutationFn = Apollo.MutationFunction<SubmitBulkAccountCreationMutation, SubmitBulkAccountCreationMutationVariables>;

/**
 * __useSubmitBulkAccountCreationMutation__
 *
 * To run a mutation, you first call `useSubmitBulkAccountCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBulkAccountCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBulkAccountCreationMutation, { data, loading, error }] = useSubmitBulkAccountCreationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitBulkAccountCreationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBulkAccountCreationMutation, SubmitBulkAccountCreationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBulkAccountCreationMutation, SubmitBulkAccountCreationMutationVariables>(SubmitBulkAccountCreationDocument, options);
      }
export type SubmitBulkAccountCreationMutationHookResult = ReturnType<typeof useSubmitBulkAccountCreationMutation>;
export type SubmitBulkAccountCreationMutationResult = Apollo.MutationResult<SubmitBulkAccountCreationMutation>;
export type SubmitBulkAccountCreationMutationOptions = Apollo.BaseMutationOptions<SubmitBulkAccountCreationMutation, SubmitBulkAccountCreationMutationVariables>;
export const GetBulkAccountCreationRequestUploadUrlDocument = gql`
    query GetBulkAccountCreationRequestUploadURL {
  bulkAccountCreationRequestUploadURL {
    ... on RequestFileLocation {
      url
      requestId
    }
    ... on ClientError {
      code
      message
    }
  }
}
    `;

/**
 * __useGetBulkAccountCreationRequestUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetBulkAccountCreationRequestUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkAccountCreationRequestUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkAccountCreationRequestUploadUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBulkAccountCreationRequestUploadUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetBulkAccountCreationRequestUploadUrlQuery, GetBulkAccountCreationRequestUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkAccountCreationRequestUploadUrlQuery, GetBulkAccountCreationRequestUploadUrlQueryVariables>(GetBulkAccountCreationRequestUploadUrlDocument, options);
      }
export function useGetBulkAccountCreationRequestUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkAccountCreationRequestUploadUrlQuery, GetBulkAccountCreationRequestUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkAccountCreationRequestUploadUrlQuery, GetBulkAccountCreationRequestUploadUrlQueryVariables>(GetBulkAccountCreationRequestUploadUrlDocument, options);
        }
export type GetBulkAccountCreationRequestUploadUrlQueryHookResult = ReturnType<typeof useGetBulkAccountCreationRequestUploadUrlQuery>;
export type GetBulkAccountCreationRequestUploadUrlLazyQueryHookResult = ReturnType<typeof useGetBulkAccountCreationRequestUploadUrlLazyQuery>;
export type GetBulkAccountCreationRequestUploadUrlQueryResult = Apollo.QueryResult<GetBulkAccountCreationRequestUploadUrlQuery, GetBulkAccountCreationRequestUploadUrlQueryVariables>;
export const GetBulkAccountsCreationReportDownloadUrlDocument = gql`
    query GetBulkAccountsCreationReportDownloadURL($input: BulkAccountCreationReportDownloadURLRequest!) {
  bulkAccountCreationReportDownloadURL(input: $input) {
    ... on ReportFileLocation {
      url
      reportId
    }
    ... on ClientError {
      code
      message
    }
  }
}
    `;

/**
 * __useGetBulkAccountsCreationReportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetBulkAccountsCreationReportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkAccountsCreationReportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkAccountsCreationReportDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBulkAccountsCreationReportDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetBulkAccountsCreationReportDownloadUrlQuery, GetBulkAccountsCreationReportDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkAccountsCreationReportDownloadUrlQuery, GetBulkAccountsCreationReportDownloadUrlQueryVariables>(GetBulkAccountsCreationReportDownloadUrlDocument, options);
      }
export function useGetBulkAccountsCreationReportDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkAccountsCreationReportDownloadUrlQuery, GetBulkAccountsCreationReportDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkAccountsCreationReportDownloadUrlQuery, GetBulkAccountsCreationReportDownloadUrlQueryVariables>(GetBulkAccountsCreationReportDownloadUrlDocument, options);
        }
export type GetBulkAccountsCreationReportDownloadUrlQueryHookResult = ReturnType<typeof useGetBulkAccountsCreationReportDownloadUrlQuery>;
export type GetBulkAccountsCreationReportDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetBulkAccountsCreationReportDownloadUrlLazyQuery>;
export type GetBulkAccountsCreationReportDownloadUrlQueryResult = Apollo.QueryResult<GetBulkAccountsCreationReportDownloadUrlQuery, GetBulkAccountsCreationReportDownloadUrlQueryVariables>;
export const GetBulkAccountsCreationTemplateDownloadUrlDocument = gql`
    query GetBulkAccountsCreationTemplateDownloadURL {
  bulkAccountCreationTemplateDownloadURL {
    ... on TemplateFileLocation {
      url
      __typename
    }
    ... on ClientError {
      code
      message
      __typename
    }
  }
}
    `;

/**
 * __useGetBulkAccountsCreationTemplateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetBulkAccountsCreationTemplateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkAccountsCreationTemplateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkAccountsCreationTemplateDownloadUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBulkAccountsCreationTemplateDownloadUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetBulkAccountsCreationTemplateDownloadUrlQuery, GetBulkAccountsCreationTemplateDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkAccountsCreationTemplateDownloadUrlQuery, GetBulkAccountsCreationTemplateDownloadUrlQueryVariables>(GetBulkAccountsCreationTemplateDownloadUrlDocument, options);
      }
export function useGetBulkAccountsCreationTemplateDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkAccountsCreationTemplateDownloadUrlQuery, GetBulkAccountsCreationTemplateDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkAccountsCreationTemplateDownloadUrlQuery, GetBulkAccountsCreationTemplateDownloadUrlQueryVariables>(GetBulkAccountsCreationTemplateDownloadUrlDocument, options);
        }
export type GetBulkAccountsCreationTemplateDownloadUrlQueryHookResult = ReturnType<typeof useGetBulkAccountsCreationTemplateDownloadUrlQuery>;
export type GetBulkAccountsCreationTemplateDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetBulkAccountsCreationTemplateDownloadUrlLazyQuery>;
export type GetBulkAccountsCreationTemplateDownloadUrlQueryResult = Apollo.QueryResult<GetBulkAccountsCreationTemplateDownloadUrlQuery, GetBulkAccountsCreationTemplateDownloadUrlQueryVariables>;
export const GetBulkAccountsCreationHistoryDocument = gql`
    query GetBulkAccountsCreationHistory {
  bulkAccountCreationUploadHistory {
    ... on BulkAccountCreationUploadHistoryOutput {
      uploadRequests {
        fileName
        customerEmail
        failedReason
        numberOfCreatedAccounts
        reportId
        status
        totalRequestedAccounts
        submittedAt
      }
    }
    ... on ClientError {
      code
      message
    }
  }
}
    `;

/**
 * __useGetBulkAccountsCreationHistoryQuery__
 *
 * To run a query within a React component, call `useGetBulkAccountsCreationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkAccountsCreationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkAccountsCreationHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBulkAccountsCreationHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetBulkAccountsCreationHistoryQuery, GetBulkAccountsCreationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkAccountsCreationHistoryQuery, GetBulkAccountsCreationHistoryQueryVariables>(GetBulkAccountsCreationHistoryDocument, options);
      }
export function useGetBulkAccountsCreationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkAccountsCreationHistoryQuery, GetBulkAccountsCreationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkAccountsCreationHistoryQuery, GetBulkAccountsCreationHistoryQueryVariables>(GetBulkAccountsCreationHistoryDocument, options);
        }
export type GetBulkAccountsCreationHistoryQueryHookResult = ReturnType<typeof useGetBulkAccountsCreationHistoryQuery>;
export type GetBulkAccountsCreationHistoryLazyQueryHookResult = ReturnType<typeof useGetBulkAccountsCreationHistoryLazyQuery>;
export type GetBulkAccountsCreationHistoryQueryResult = Apollo.QueryResult<GetBulkAccountsCreationHistoryQuery, GetBulkAccountsCreationHistoryQueryVariables>;
export const GetPartnerInfoDocument = gql`
    query GetPartnerInfo {
  partner {
    id
    liveRegistration {
      registration {
        revision
        companyName
        companyWebsite
        companyAddress {
          lines
          city
          stateOrRegion
          districtOrCounty
          postalCode
          countryCode
        }
        incorporationCountry
        registrationNumber
        submissionNotes
        convertedFromRegionalManagerAccount {
          id
          region
        }
      }
    }
    isPartnerTrusted
  }
}
    `;

/**
 * __useGetPartnerInfoQuery__
 *
 * To run a query within a React component, call `useGetPartnerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerInfoQuery, GetPartnerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerInfoQuery, GetPartnerInfoQueryVariables>(GetPartnerInfoDocument, options);
      }
export function useGetPartnerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerInfoQuery, GetPartnerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerInfoQuery, GetPartnerInfoQueryVariables>(GetPartnerInfoDocument, options);
        }
export type GetPartnerInfoQueryHookResult = ReturnType<typeof useGetPartnerInfoQuery>;
export type GetPartnerInfoLazyQueryHookResult = ReturnType<typeof useGetPartnerInfoLazyQuery>;
export type GetPartnerInfoQueryResult = Apollo.QueryResult<GetPartnerInfoQuery, GetPartnerInfoQueryVariables>;
export const GetAdvertiserInvitesDocument = gql`
    query GetAdvertiserInvites($first: Int, $after: Cursor) {
  partner {
    id
    advertiserInvites(first: $first, after: $after) {
      edges {
        node {
          ...partnerAdvertiserInvite
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${PartnerAdvertiserInviteFragmentDoc}`;

/**
 * __useGetAdvertiserInvitesQuery__
 *
 * To run a query within a React component, call `useGetAdvertiserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertiserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertiserInvitesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAdvertiserInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvertiserInvitesQuery, GetAdvertiserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertiserInvitesQuery, GetAdvertiserInvitesQueryVariables>(GetAdvertiserInvitesDocument, options);
      }
export function useGetAdvertiserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertiserInvitesQuery, GetAdvertiserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertiserInvitesQuery, GetAdvertiserInvitesQueryVariables>(GetAdvertiserInvitesDocument, options);
        }
export type GetAdvertiserInvitesQueryHookResult = ReturnType<typeof useGetAdvertiserInvitesQuery>;
export type GetAdvertiserInvitesLazyQueryHookResult = ReturnType<typeof useGetAdvertiserInvitesLazyQuery>;
export type GetAdvertiserInvitesQueryResult = Apollo.QueryResult<GetAdvertiserInvitesQuery, GetAdvertiserInvitesQueryVariables>;
export const SendPartnerAdvertiserInviteDocument = gql`
    mutation SendPartnerAdvertiserInvite($email: String!) {
  sendPartnerAdvertiserInvite(email: $email) {
    ...partnerAdvertiserInvite
  }
}
    ${PartnerAdvertiserInviteFragmentDoc}`;
export type SendPartnerAdvertiserInviteMutationFn = Apollo.MutationFunction<SendPartnerAdvertiserInviteMutation, SendPartnerAdvertiserInviteMutationVariables>;

/**
 * __useSendPartnerAdvertiserInviteMutation__
 *
 * To run a mutation, you first call `useSendPartnerAdvertiserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPartnerAdvertiserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPartnerAdvertiserInviteMutation, { data, loading, error }] = useSendPartnerAdvertiserInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPartnerAdvertiserInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendPartnerAdvertiserInviteMutation, SendPartnerAdvertiserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPartnerAdvertiserInviteMutation, SendPartnerAdvertiserInviteMutationVariables>(SendPartnerAdvertiserInviteDocument, options);
      }
export type SendPartnerAdvertiserInviteMutationHookResult = ReturnType<typeof useSendPartnerAdvertiserInviteMutation>;
export type SendPartnerAdvertiserInviteMutationResult = Apollo.MutationResult<SendPartnerAdvertiserInviteMutation>;
export type SendPartnerAdvertiserInviteMutationOptions = Apollo.BaseMutationOptions<SendPartnerAdvertiserInviteMutation, SendPartnerAdvertiserInviteMutationVariables>;
export const ResendPartnerAdvertiserInviteDocument = gql`
    mutation ResendPartnerAdvertiserInvite($inviteId: ID!) {
  resendPartnerAdvertiserInvite(inviteId: $inviteId) {
    ...partnerAdvertiserInvite
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    ${PartnerAdvertiserInviteFragmentDoc}`;
export type ResendPartnerAdvertiserInviteMutationFn = Apollo.MutationFunction<ResendPartnerAdvertiserInviteMutation, ResendPartnerAdvertiserInviteMutationVariables>;

/**
 * __useResendPartnerAdvertiserInviteMutation__
 *
 * To run a mutation, you first call `useResendPartnerAdvertiserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPartnerAdvertiserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPartnerAdvertiserInviteMutation, { data, loading, error }] = useResendPartnerAdvertiserInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useResendPartnerAdvertiserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendPartnerAdvertiserInviteMutation, ResendPartnerAdvertiserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPartnerAdvertiserInviteMutation, ResendPartnerAdvertiserInviteMutationVariables>(ResendPartnerAdvertiserInviteDocument, options);
      }
export type ResendPartnerAdvertiserInviteMutationHookResult = ReturnType<typeof useResendPartnerAdvertiserInviteMutation>;
export type ResendPartnerAdvertiserInviteMutationResult = Apollo.MutationResult<ResendPartnerAdvertiserInviteMutation>;
export type ResendPartnerAdvertiserInviteMutationOptions = Apollo.BaseMutationOptions<ResendPartnerAdvertiserInviteMutation, ResendPartnerAdvertiserInviteMutationVariables>;
export const DeletePartnerAdvertiserInviteDocument = gql`
    mutation DeletePartnerAdvertiserInvite($inviteId: ID!) {
  deletePartnerAdvertiserInvite(inviteId: $inviteId) {
    ...partnerAdvertiserInvite
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    ${PartnerAdvertiserInviteFragmentDoc}`;
export type DeletePartnerAdvertiserInviteMutationFn = Apollo.MutationFunction<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>;

/**
 * __useDeletePartnerAdvertiserInviteMutation__
 *
 * To run a mutation, you first call `useDeletePartnerAdvertiserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerAdvertiserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerAdvertiserInviteMutation, { data, loading, error }] = useDeletePartnerAdvertiserInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeletePartnerAdvertiserInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>(DeletePartnerAdvertiserInviteDocument, options);
      }
export type DeletePartnerAdvertiserInviteMutationHookResult = ReturnType<typeof useDeletePartnerAdvertiserInviteMutation>;
export type DeletePartnerAdvertiserInviteMutationResult = Apollo.MutationResult<DeletePartnerAdvertiserInviteMutation>;
export type DeletePartnerAdvertiserInviteMutationOptions = Apollo.BaseMutationOptions<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>;
export const GetPartnerUserAdvertisersDocument = gql`
    query GetPartnerUserAdvertisers {
  partnerUser {
    managedAdvertisers {
      advertiser {
        id
        name
        type
        countryCode
      }
    }
  }
}
    `;

/**
 * __useGetPartnerUserAdvertisersQuery__
 *
 * To run a query within a React component, call `useGetPartnerUserAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUserAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUserAdvertisersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerUserAdvertisersQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerUserAdvertisersQuery, GetPartnerUserAdvertisersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerUserAdvertisersQuery, GetPartnerUserAdvertisersQueryVariables>(GetPartnerUserAdvertisersDocument, options);
      }
export function useGetPartnerUserAdvertisersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerUserAdvertisersQuery, GetPartnerUserAdvertisersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerUserAdvertisersQuery, GetPartnerUserAdvertisersQueryVariables>(GetPartnerUserAdvertisersDocument, options);
        }
export type GetPartnerUserAdvertisersQueryHookResult = ReturnType<typeof useGetPartnerUserAdvertisersQuery>;
export type GetPartnerUserAdvertisersLazyQueryHookResult = ReturnType<typeof useGetPartnerUserAdvertisersLazyQuery>;
export type GetPartnerUserAdvertisersQueryResult = Apollo.QueryResult<GetPartnerUserAdvertisersQuery, GetPartnerUserAdvertisersQueryVariables>;
export const GetAdvertisersDocument = gql`
    query GetAdvertisers($after: Cursor) {
  partner {
    id
    liveRegistration {
      registration {
        companyName
      }
    }
    advertisers(after: $after) {
      edges {
        node {
          ...advertiser
        }
        accessLevel
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${AdvertiserFragmentDoc}`;

/**
 * __useGetAdvertisersQuery__
 *
 * To run a query within a React component, call `useGetAdvertisersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertisersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertisersQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAdvertisersQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvertisersQuery, GetAdvertisersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertisersQuery, GetAdvertisersQueryVariables>(GetAdvertisersDocument, options);
      }
export function useGetAdvertisersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertisersQuery, GetAdvertisersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertisersQuery, GetAdvertisersQueryVariables>(GetAdvertisersDocument, options);
        }
export type GetAdvertisersQueryHookResult = ReturnType<typeof useGetAdvertisersQuery>;
export type GetAdvertisersLazyQueryHookResult = ReturnType<typeof useGetAdvertisersLazyQuery>;
export type GetAdvertisersQueryResult = Apollo.QueryResult<GetAdvertisersQuery, GetAdvertisersQueryVariables>;
export const RemovePartnerAdvertiserDocument = gql`
    mutation RemovePartnerAdvertiser($input: RemovePartnerAdvertiserInput!) {
  removePartnerAdvertiser(input: $input) {
    ...advertiser
  }
}
    ${AdvertiserFragmentDoc}`;
export type RemovePartnerAdvertiserMutationFn = Apollo.MutationFunction<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>;

/**
 * __useRemovePartnerAdvertiserMutation__
 *
 * To run a mutation, you first call `useRemovePartnerAdvertiserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartnerAdvertiserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartnerAdvertiserMutation, { data, loading, error }] = useRemovePartnerAdvertiserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePartnerAdvertiserMutation(baseOptions?: Apollo.MutationHookOptions<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>(RemovePartnerAdvertiserDocument, options);
      }
export type RemovePartnerAdvertiserMutationHookResult = ReturnType<typeof useRemovePartnerAdvertiserMutation>;
export type RemovePartnerAdvertiserMutationResult = Apollo.MutationResult<RemovePartnerAdvertiserMutation>;
export type RemovePartnerAdvertiserMutationOptions = Apollo.BaseMutationOptions<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>;
export const GetAdvertiserReportDocument = gql`
    query GetAdvertiserReport {
  advertiserReport {
    __typename
    ... on PendingReport {
      reportType
      creationDate
    }
    ... on CompletedReport {
      reportType
      creationDate
      location
    }
    ... on NoReport {
      reportType
    }
    ... on InvalidState {
      code
    }
  }
}
    `;

/**
 * __useGetAdvertiserReportQuery__
 *
 * To run a query within a React component, call `useGetAdvertiserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertiserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertiserReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvertiserReportQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvertiserReportQuery, GetAdvertiserReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertiserReportQuery, GetAdvertiserReportQueryVariables>(GetAdvertiserReportDocument, options);
      }
export function useGetAdvertiserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertiserReportQuery, GetAdvertiserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertiserReportQuery, GetAdvertiserReportQueryVariables>(GetAdvertiserReportDocument, options);
        }
export type GetAdvertiserReportQueryHookResult = ReturnType<typeof useGetAdvertiserReportQuery>;
export type GetAdvertiserReportLazyQueryHookResult = ReturnType<typeof useGetAdvertiserReportLazyQuery>;
export type GetAdvertiserReportQueryResult = Apollo.QueryResult<GetAdvertiserReportQuery, GetAdvertiserReportQueryVariables>;
export const GenerateAdvertiserReportDocument = gql`
    mutation GenerateAdvertiserReport {
  generateAdvertiserReport {
    __typename
    ... on PendingReport {
      reportType
      creationDate
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type GenerateAdvertiserReportMutationFn = Apollo.MutationFunction<GenerateAdvertiserReportMutation, GenerateAdvertiserReportMutationVariables>;

/**
 * __useGenerateAdvertiserReportMutation__
 *
 * To run a mutation, you first call `useGenerateAdvertiserReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAdvertiserReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAdvertiserReportMutation, { data, loading, error }] = useGenerateAdvertiserReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateAdvertiserReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAdvertiserReportMutation, GenerateAdvertiserReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAdvertiserReportMutation, GenerateAdvertiserReportMutationVariables>(GenerateAdvertiserReportDocument, options);
      }
export type GenerateAdvertiserReportMutationHookResult = ReturnType<typeof useGenerateAdvertiserReportMutation>;
export type GenerateAdvertiserReportMutationResult = Apollo.MutationResult<GenerateAdvertiserReportMutation>;
export type GenerateAdvertiserReportMutationOptions = Apollo.BaseMutationOptions<GenerateAdvertiserReportMutation, GenerateAdvertiserReportMutationVariables>;
export const GetApplicationsDocument = gql`
    query GetApplications {
  partner {
    id
    applications {
      id
      applicationId
      name
      linkedBy {
        id
        name
      }
      linkedDate
      advertiserAutomappingStatus
    }
  }
}
    `;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
      }
export function useGetApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
        }
export type GetApplicationsQueryHookResult = ReturnType<typeof useGetApplicationsQuery>;
export type GetApplicationsLazyQueryHookResult = ReturnType<typeof useGetApplicationsLazyQuery>;
export type GetApplicationsQueryResult = Apollo.QueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export const GetPartnerAccountNameDocument = gql`
    query GetPartnerAccountName {
  partner {
    id
    liveRegistration {
      registration {
        companyName
      }
    }
  }
}
    `;

/**
 * __useGetPartnerAccountNameQuery__
 *
 * To run a query within a React component, call `useGetPartnerAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerAccountNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerAccountNameQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerAccountNameQuery, GetPartnerAccountNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerAccountNameQuery, GetPartnerAccountNameQueryVariables>(GetPartnerAccountNameDocument, options);
      }
export function useGetPartnerAccountNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerAccountNameQuery, GetPartnerAccountNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerAccountNameQuery, GetPartnerAccountNameQueryVariables>(GetPartnerAccountNameDocument, options);
        }
export type GetPartnerAccountNameQueryHookResult = ReturnType<typeof useGetPartnerAccountNameQuery>;
export type GetPartnerAccountNameLazyQueryHookResult = ReturnType<typeof useGetPartnerAccountNameLazyQuery>;
export type GetPartnerAccountNameQueryResult = Apollo.QueryResult<GetPartnerAccountNameQuery, GetPartnerAccountNameQueryVariables>;
export const GetLinkableApplicationsDocument = gql`
    query GetLinkableApplications {
  linkableApplications {
    applicationId
    name
  }
}
    `;

/**
 * __useGetLinkableApplicationsQuery__
 *
 * To run a query within a React component, call `useGetLinkableApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkableApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkableApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLinkableApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLinkableApplicationsQuery, GetLinkableApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkableApplicationsQuery, GetLinkableApplicationsQueryVariables>(GetLinkableApplicationsDocument, options);
      }
export function useGetLinkableApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkableApplicationsQuery, GetLinkableApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkableApplicationsQuery, GetLinkableApplicationsQueryVariables>(GetLinkableApplicationsDocument, options);
        }
export type GetLinkableApplicationsQueryHookResult = ReturnType<typeof useGetLinkableApplicationsQuery>;
export type GetLinkableApplicationsLazyQueryHookResult = ReturnType<typeof useGetLinkableApplicationsLazyQuery>;
export type GetLinkableApplicationsQueryResult = Apollo.QueryResult<GetLinkableApplicationsQuery, GetLinkableApplicationsQueryVariables>;
export const LinkApplicationDocument = gql`
    mutation LinkApplication($input: LinkApplicationInput!) {
  linkApplication(input: $input) {
    ...linkOrUnlinkResponse
  }
}
    ${LinkOrUnlinkResponseFragmentDoc}`;
export type LinkApplicationMutationFn = Apollo.MutationFunction<LinkApplicationMutation, LinkApplicationMutationVariables>;

/**
 * __useLinkApplicationMutation__
 *
 * To run a mutation, you first call `useLinkApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkApplicationMutation, { data, loading, error }] = useLinkApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkApplicationMutation(baseOptions?: Apollo.MutationHookOptions<LinkApplicationMutation, LinkApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkApplicationMutation, LinkApplicationMutationVariables>(LinkApplicationDocument, options);
      }
export type LinkApplicationMutationHookResult = ReturnType<typeof useLinkApplicationMutation>;
export type LinkApplicationMutationResult = Apollo.MutationResult<LinkApplicationMutation>;
export type LinkApplicationMutationOptions = Apollo.BaseMutationOptions<LinkApplicationMutation, LinkApplicationMutationVariables>;
export const UnlinkApplicationDocument = gql`
    mutation UnlinkApplication($input: UnlinkApplicationInput!) {
  unlinkApplication(input: $input) {
    ...linkOrUnlinkResponse
  }
}
    ${LinkOrUnlinkResponseFragmentDoc}`;
export type UnlinkApplicationMutationFn = Apollo.MutationFunction<UnlinkApplicationMutation, UnlinkApplicationMutationVariables>;

/**
 * __useUnlinkApplicationMutation__
 *
 * To run a mutation, you first call `useUnlinkApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkApplicationMutation, { data, loading, error }] = useUnlinkApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkApplicationMutation, UnlinkApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkApplicationMutation, UnlinkApplicationMutationVariables>(UnlinkApplicationDocument, options);
      }
export type UnlinkApplicationMutationHookResult = ReturnType<typeof useUnlinkApplicationMutation>;
export type UnlinkApplicationMutationResult = Apollo.MutationResult<UnlinkApplicationMutation>;
export type UnlinkApplicationMutationOptions = Apollo.BaseMutationOptions<UnlinkApplicationMutation, UnlinkApplicationMutationVariables>;
export const UpdateApplicationDocument = gql`
    mutation UpdateApplication($input: UpdateApplicationInput!) {
  updateApplication(input: $input) {
    __typename
    ... on ApplicationDetails {
      id
      applicationId
      advertiserAutomappingStatus
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const GetAggregateCertificationTypeDataDocument = gql`
    query GetAggregateCertificationTypeData {
  partner {
    totalUsersCount
    certifiedUsersCount
    certificationData {
      certificationDataByType {
        ... on CertificationTypeData {
          name
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetAggregateCertificationTypeDataQuery__
 *
 * To run a query within a React component, call `useGetAggregateCertificationTypeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateCertificationTypeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateCertificationTypeDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAggregateCertificationTypeDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAggregateCertificationTypeDataQuery, GetAggregateCertificationTypeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregateCertificationTypeDataQuery, GetAggregateCertificationTypeDataQueryVariables>(GetAggregateCertificationTypeDataDocument, options);
      }
export function useGetAggregateCertificationTypeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregateCertificationTypeDataQuery, GetAggregateCertificationTypeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregateCertificationTypeDataQuery, GetAggregateCertificationTypeDataQueryVariables>(GetAggregateCertificationTypeDataDocument, options);
        }
export type GetAggregateCertificationTypeDataQueryHookResult = ReturnType<typeof useGetAggregateCertificationTypeDataQuery>;
export type GetAggregateCertificationTypeDataLazyQueryHookResult = ReturnType<typeof useGetAggregateCertificationTypeDataLazyQuery>;
export type GetAggregateCertificationTypeDataQueryResult = Apollo.QueryResult<GetAggregateCertificationTypeDataQuery, GetAggregateCertificationTypeDataQueryVariables>;
export const GetCertificationEntriesDocument = gql`
    query GetCertificationEntries($queryInput: CertificationQueryInput, $pagination: PaginationInput, $sorts: [SortInput]) {
  partner {
    certificationData {
      certifiedUsers(query: $queryInput, pagination: $pagination, sorts: $sorts) {
        ... on CertificationEntryConnection {
          totalCertificationEntryCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
          edges {
            ... on CertificationEntryEdge {
              cursor
              node {
                expirationDate
                courseTag
                name
                type
                certificationUser {
                  user {
                    id
                    name
                    email
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCertificationEntriesQuery__
 *
 * To run a query within a React component, call `useGetCertificationEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationEntriesQuery({
 *   variables: {
 *      queryInput: // value for 'queryInput'
 *      pagination: // value for 'pagination'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useGetCertificationEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCertificationEntriesQuery, GetCertificationEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificationEntriesQuery, GetCertificationEntriesQueryVariables>(GetCertificationEntriesDocument, options);
      }
export function useGetCertificationEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificationEntriesQuery, GetCertificationEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificationEntriesQuery, GetCertificationEntriesQueryVariables>(GetCertificationEntriesDocument, options);
        }
export type GetCertificationEntriesQueryHookResult = ReturnType<typeof useGetCertificationEntriesQuery>;
export type GetCertificationEntriesLazyQueryHookResult = ReturnType<typeof useGetCertificationEntriesLazyQuery>;
export type GetCertificationEntriesQueryResult = Apollo.QueryResult<GetCertificationEntriesQuery, GetCertificationEntriesQueryVariables>;
export const GetPartnerUserDocument = gql`
    query GetPartnerUser($fetchExpired: Boolean = false) {
  partnerUser {
    learningConsoleCertificates(fetchExpired: $fetchExpired) {
      name
      courseTag
      badgeContentType
      badgeUrl
      expirationDate
    }
    user {
      email
    }
  }
}
    `;

/**
 * __useGetPartnerUserQuery__
 *
 * To run a query within a React component, call `useGetPartnerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUserQuery({
 *   variables: {
 *      fetchExpired: // value for 'fetchExpired'
 *   },
 * });
 */
export function useGetPartnerUserQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerUserQuery, GetPartnerUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerUserQuery, GetPartnerUserQueryVariables>(GetPartnerUserDocument, options);
      }
export function useGetPartnerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerUserQuery, GetPartnerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerUserQuery, GetPartnerUserQueryVariables>(GetPartnerUserDocument, options);
        }
export type GetPartnerUserQueryHookResult = ReturnType<typeof useGetPartnerUserQuery>;
export type GetPartnerUserLazyQueryHookResult = ReturnType<typeof useGetPartnerUserLazyQuery>;
export type GetPartnerUserQueryResult = Apollo.QueryResult<GetPartnerUserQuery, GetPartnerUserQueryVariables>;
export const GetPartnerUsersDocument = gql`
    query GetPartnerUsers {
  partner {
    id
    totalUsersCount
    certifiedUsersCount
    users {
      user {
        ...partnerUser
      }
      partnerUserRole
    }
  }
}
    ${PartnerUserFragmentDoc}`;

/**
 * __useGetPartnerUsersQuery__
 *
 * To run a query within a React component, call `useGetPartnerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerUsersQuery, GetPartnerUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerUsersQuery, GetPartnerUsersQueryVariables>(GetPartnerUsersDocument, options);
      }
export function useGetPartnerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerUsersQuery, GetPartnerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerUsersQuery, GetPartnerUsersQueryVariables>(GetPartnerUsersDocument, options);
        }
export type GetPartnerUsersQueryHookResult = ReturnType<typeof useGetPartnerUsersQuery>;
export type GetPartnerUsersLazyQueryHookResult = ReturnType<typeof useGetPartnerUsersLazyQuery>;
export type GetPartnerUsersQueryResult = Apollo.QueryResult<GetPartnerUsersQuery, GetPartnerUsersQueryVariables>;
export const GetPartnerUserCertificatesDocument = gql`
    query GetPartnerUserCertificates {
  partner {
    id
    users {
      user {
        id
      }
      learningConsoleCertificates {
        name
        expirationDate
      }
    }
  }
}
    `;

/**
 * __useGetPartnerUserCertificatesQuery__
 *
 * To run a query within a React component, call `useGetPartnerUserCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerUserCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerUserCertificatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerUserCertificatesQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerUserCertificatesQuery, GetPartnerUserCertificatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerUserCertificatesQuery, GetPartnerUserCertificatesQueryVariables>(GetPartnerUserCertificatesDocument, options);
      }
export function useGetPartnerUserCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerUserCertificatesQuery, GetPartnerUserCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerUserCertificatesQuery, GetPartnerUserCertificatesQueryVariables>(GetPartnerUserCertificatesDocument, options);
        }
export type GetPartnerUserCertificatesQueryHookResult = ReturnType<typeof useGetPartnerUserCertificatesQuery>;
export type GetPartnerUserCertificatesLazyQueryHookResult = ReturnType<typeof useGetPartnerUserCertificatesLazyQuery>;
export type GetPartnerUserCertificatesQueryResult = Apollo.QueryResult<GetPartnerUserCertificatesQuery, GetPartnerUserCertificatesQueryVariables>;
export const RemovePartnerUserDocument = gql`
    mutation RemovePartnerUser($userId: CustomerAccountId!) {
  removePartnerUser(userId: $userId) {
    ...partnerUser
  }
}
    ${PartnerUserFragmentDoc}`;
export type RemovePartnerUserMutationFn = Apollo.MutationFunction<RemovePartnerUserMutation, RemovePartnerUserMutationVariables>;

/**
 * __useRemovePartnerUserMutation__
 *
 * To run a mutation, you first call `useRemovePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartnerUserMutation, { data, loading, error }] = useRemovePartnerUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemovePartnerUserMutation(baseOptions?: Apollo.MutationHookOptions<RemovePartnerUserMutation, RemovePartnerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePartnerUserMutation, RemovePartnerUserMutationVariables>(RemovePartnerUserDocument, options);
      }
export type RemovePartnerUserMutationHookResult = ReturnType<typeof useRemovePartnerUserMutation>;
export type RemovePartnerUserMutationResult = Apollo.MutationResult<RemovePartnerUserMutation>;
export type RemovePartnerUserMutationOptions = Apollo.BaseMutationOptions<RemovePartnerUserMutation, RemovePartnerUserMutationVariables>;
export const UpdatePartnerUserDocument = gql`
    mutation UpdatePartnerUser($input: UpdatePartnerUserInput!) {
  updatePartnerUser(input: $input) {
    __typename
    ... on PartnerUser {
      user {
        id
      }
      partnerUserRole
    }
    ... on InvalidState {
      code
    }
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type UpdatePartnerUserMutationFn = Apollo.MutationFunction<UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables>;

/**
 * __useUpdatePartnerUserMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerUserMutation, { data, loading, error }] = useUpdatePartnerUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartnerUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables>(UpdatePartnerUserDocument, options);
      }
export type UpdatePartnerUserMutationHookResult = ReturnType<typeof useUpdatePartnerUserMutation>;
export type UpdatePartnerUserMutationResult = Apollo.MutationResult<UpdatePartnerUserMutation>;
export type UpdatePartnerUserMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables>;
export const GetUserInvitesDocument = gql`
    query GetUserInvites {
  partner {
    id
    userInvites {
      ...partnerUserInvite
    }
  }
}
    ${PartnerUserInviteFragmentDoc}`;

/**
 * __useGetUserInvitesQuery__
 *
 * To run a query within a React component, call `useGetUserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInvitesQuery, GetUserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInvitesQuery, GetUserInvitesQueryVariables>(GetUserInvitesDocument, options);
      }
export function useGetUserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInvitesQuery, GetUserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInvitesQuery, GetUserInvitesQueryVariables>(GetUserInvitesDocument, options);
        }
export type GetUserInvitesQueryHookResult = ReturnType<typeof useGetUserInvitesQuery>;
export type GetUserInvitesLazyQueryHookResult = ReturnType<typeof useGetUserInvitesLazyQuery>;
export type GetUserInvitesQueryResult = Apollo.QueryResult<GetUserInvitesQuery, GetUserInvitesQueryVariables>;
export const SendPartnerUserInviteDocument = gql`
    mutation SendPartnerUserInvite($input: SendPartnerUserInviteInput!) {
  sendPartnerUserInvite(input: $input) {
    ...partnerUserInvite
  }
}
    ${PartnerUserInviteFragmentDoc}`;
export type SendPartnerUserInviteMutationFn = Apollo.MutationFunction<SendPartnerUserInviteMutation, SendPartnerUserInviteMutationVariables>;

/**
 * __useSendPartnerUserInviteMutation__
 *
 * To run a mutation, you first call `useSendPartnerUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPartnerUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPartnerUserInviteMutation, { data, loading, error }] = useSendPartnerUserInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPartnerUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendPartnerUserInviteMutation, SendPartnerUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPartnerUserInviteMutation, SendPartnerUserInviteMutationVariables>(SendPartnerUserInviteDocument, options);
      }
export type SendPartnerUserInviteMutationHookResult = ReturnType<typeof useSendPartnerUserInviteMutation>;
export type SendPartnerUserInviteMutationResult = Apollo.MutationResult<SendPartnerUserInviteMutation>;
export type SendPartnerUserInviteMutationOptions = Apollo.BaseMutationOptions<SendPartnerUserInviteMutation, SendPartnerUserInviteMutationVariables>;
export const DeletePartnerUserInviteDocument = gql`
    mutation DeletePartnerUserInvite($inviteId: ID!) {
  deletePartnerUserInvite(inviteId: $inviteId) {
    ...partnerUserInvite
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    ${PartnerUserInviteFragmentDoc}`;
export type DeletePartnerUserInviteMutationFn = Apollo.MutationFunction<DeletePartnerUserInviteMutation, DeletePartnerUserInviteMutationVariables>;

/**
 * __useDeletePartnerUserInviteMutation__
 *
 * To run a mutation, you first call `useDeletePartnerUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerUserInviteMutation, { data, loading, error }] = useDeletePartnerUserInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeletePartnerUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerUserInviteMutation, DeletePartnerUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerUserInviteMutation, DeletePartnerUserInviteMutationVariables>(DeletePartnerUserInviteDocument, options);
      }
export type DeletePartnerUserInviteMutationHookResult = ReturnType<typeof useDeletePartnerUserInviteMutation>;
export type DeletePartnerUserInviteMutationResult = Apollo.MutationResult<DeletePartnerUserInviteMutation>;
export type DeletePartnerUserInviteMutationOptions = Apollo.BaseMutationOptions<DeletePartnerUserInviteMutation, DeletePartnerUserInviteMutationVariables>;
export const ResendPartnerUserInviteDocument = gql`
    mutation ResendPartnerUserInvite($inviteId: ID!) {
  resendPartnerUserInvite(inviteId: $inviteId) {
    ...partnerUserInvite
    ... on NotFound {
      code
    }
    ... on ClientError {
      code
    }
  }
}
    ${PartnerUserInviteFragmentDoc}`;
export type ResendPartnerUserInviteMutationFn = Apollo.MutationFunction<ResendPartnerUserInviteMutation, ResendPartnerUserInviteMutationVariables>;

/**
 * __useResendPartnerUserInviteMutation__
 *
 * To run a mutation, you first call `useResendPartnerUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPartnerUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPartnerUserInviteMutation, { data, loading, error }] = useResendPartnerUserInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useResendPartnerUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendPartnerUserInviteMutation, ResendPartnerUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPartnerUserInviteMutation, ResendPartnerUserInviteMutationVariables>(ResendPartnerUserInviteDocument, options);
      }
export type ResendPartnerUserInviteMutationHookResult = ReturnType<typeof useResendPartnerUserInviteMutation>;
export type ResendPartnerUserInviteMutationResult = Apollo.MutationResult<ResendPartnerUserInviteMutation>;
export type ResendPartnerUserInviteMutationOptions = Apollo.BaseMutationOptions<ResendPartnerUserInviteMutation, ResendPartnerUserInviteMutationVariables>;
export const GetPartnerGroupDetailsDocument = gql`
    query GetPartnerGroupDetails {
  partnerGroup {
    groupId
    primaryPartnerAccount {
      id
      liveRegistration {
        registration {
          companyName
          companyWebsite
          companyAddress {
            lines
            city
            stateOrRegion
            districtOrCounty
            postalCode
            countryCode
          }
          incorporationCountry
          registrationNumber
        }
      }
    }
    members {
      id
      liveRegistration {
        registration {
          companyName
        }
      }
    }
  }
}
    `;

/**
 * __useGetPartnerGroupDetailsQuery__
 *
 * To run a query within a React component, call `useGetPartnerGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerGroupDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerGroupDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerGroupDetailsQuery, GetPartnerGroupDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerGroupDetailsQuery, GetPartnerGroupDetailsQueryVariables>(GetPartnerGroupDetailsDocument, options);
      }
export function useGetPartnerGroupDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerGroupDetailsQuery, GetPartnerGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerGroupDetailsQuery, GetPartnerGroupDetailsQueryVariables>(GetPartnerGroupDetailsDocument, options);
        }
export type GetPartnerGroupDetailsQueryHookResult = ReturnType<typeof useGetPartnerGroupDetailsQuery>;
export type GetPartnerGroupDetailsLazyQueryHookResult = ReturnType<typeof useGetPartnerGroupDetailsLazyQuery>;
export type GetPartnerGroupDetailsQueryResult = Apollo.QueryResult<GetPartnerGroupDetailsQuery, GetPartnerGroupDetailsQueryVariables>;
export const AddPartnerToGroupDocument = gql`
    mutation AddPartnerToGroup($input: AddPartnerToGroupInput!) {
  addPartnerToGroup(input: $input) {
    ... on PartnerGroup {
      groupId
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type AddPartnerToGroupMutationFn = Apollo.MutationFunction<AddPartnerToGroupMutation, AddPartnerToGroupMutationVariables>;

/**
 * __useAddPartnerToGroupMutation__
 *
 * To run a mutation, you first call `useAddPartnerToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartnerToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartnerToGroupMutation, { data, loading, error }] = useAddPartnerToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartnerToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddPartnerToGroupMutation, AddPartnerToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartnerToGroupMutation, AddPartnerToGroupMutationVariables>(AddPartnerToGroupDocument, options);
      }
export type AddPartnerToGroupMutationHookResult = ReturnType<typeof useAddPartnerToGroupMutation>;
export type AddPartnerToGroupMutationResult = Apollo.MutationResult<AddPartnerToGroupMutation>;
export type AddPartnerToGroupMutationOptions = Apollo.BaseMutationOptions<AddPartnerToGroupMutation, AddPartnerToGroupMutationVariables>;
export const RemovePartnerFromGroupDocument = gql`
    mutation RemovePartnerFromGroup($input: RemovePartnerFromGroupInput!) {
  removePartnerFromGroup(input: $input) {
    ... on PartnerGroup {
      groupId
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type RemovePartnerFromGroupMutationFn = Apollo.MutationFunction<RemovePartnerFromGroupMutation, RemovePartnerFromGroupMutationVariables>;

/**
 * __useRemovePartnerFromGroupMutation__
 *
 * To run a mutation, you first call `useRemovePartnerFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePartnerFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePartnerFromGroupMutation, { data, loading, error }] = useRemovePartnerFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePartnerFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemovePartnerFromGroupMutation, RemovePartnerFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePartnerFromGroupMutation, RemovePartnerFromGroupMutationVariables>(RemovePartnerFromGroupDocument, options);
      }
export type RemovePartnerFromGroupMutationHookResult = ReturnType<typeof useRemovePartnerFromGroupMutation>;
export type RemovePartnerFromGroupMutationResult = Apollo.MutationResult<RemovePartnerFromGroupMutation>;
export type RemovePartnerFromGroupMutationOptions = Apollo.BaseMutationOptions<RemovePartnerFromGroupMutation, RemovePartnerFromGroupMutationVariables>;
export const CreatePartnerInGroupDocument = gql`
    mutation CreatePartnerInGroup($input: SubmitPartnerRegistrationInput!) {
  submitPartnerRegistration(submitRegistrationInput: $input) {
    ... on Partner {
      id
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type CreatePartnerInGroupMutationFn = Apollo.MutationFunction<CreatePartnerInGroupMutation, CreatePartnerInGroupMutationVariables>;

/**
 * __useCreatePartnerInGroupMutation__
 *
 * To run a mutation, you first call `useCreatePartnerInGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerInGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerInGroupMutation, { data, loading, error }] = useCreatePartnerInGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerInGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerInGroupMutation, CreatePartnerInGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerInGroupMutation, CreatePartnerInGroupMutationVariables>(CreatePartnerInGroupDocument, options);
      }
export type CreatePartnerInGroupMutationHookResult = ReturnType<typeof useCreatePartnerInGroupMutation>;
export type CreatePartnerInGroupMutationResult = Apollo.MutationResult<CreatePartnerInGroupMutation>;
export type CreatePartnerInGroupMutationOptions = Apollo.BaseMutationOptions<CreatePartnerInGroupMutation, CreatePartnerInGroupMutationVariables>;
export const GetPartnerRegistrationStatusDocument = gql`
    query GetPartnerRegistrationStatus {
  partner {
    id
    reviewRegistration {
      registration {
        revision
        companyName
        companyWebsite
        companyAddress {
          lines
          city
          stateOrRegion
          districtOrCounty
          postalCode
          countryCode
        }
        incorporationCountry
        registrationNumber
        submissionNotes
        convertedFromRegionalManagerAccount {
          id
          region
        }
      }
      verification {
        status
        rejectionReasons
        mutableRejectionReasons {
          id
          message
          helpContentIds
          version
          translations {
            text
            locale
          }
        }
        rejectionDetails
        lastSubmittedDate
        lastReviewedDate
      }
    }
    unmoderatedRegistrationData {
      adOffering
      doesCurrentlyAdvertise
      servicesCategory
      adProductsInterest
      advertiserBusinessTypes
    }
  }
}
    `;

/**
 * __useGetPartnerRegistrationStatusQuery__
 *
 * To run a query within a React component, call `useGetPartnerRegistrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerRegistrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerRegistrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerRegistrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerRegistrationStatusQuery, GetPartnerRegistrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerRegistrationStatusQuery, GetPartnerRegistrationStatusQueryVariables>(GetPartnerRegistrationStatusDocument, options);
      }
export function useGetPartnerRegistrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerRegistrationStatusQuery, GetPartnerRegistrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerRegistrationStatusQuery, GetPartnerRegistrationStatusQueryVariables>(GetPartnerRegistrationStatusDocument, options);
        }
export type GetPartnerRegistrationStatusQueryHookResult = ReturnType<typeof useGetPartnerRegistrationStatusQuery>;
export type GetPartnerRegistrationStatusLazyQueryHookResult = ReturnType<typeof useGetPartnerRegistrationStatusLazyQuery>;
export type GetPartnerRegistrationStatusQueryResult = Apollo.QueryResult<GetPartnerRegistrationStatusQuery, GetPartnerRegistrationStatusQueryVariables>;
export const DeletePartnerRegistrationDocument = gql`
    mutation DeletePartnerRegistration($deleteRegistrationInput: DeletePartnerRegistrationInput!) {
  deletePartnerRegistration(deleteRegistrationInput: $deleteRegistrationInput) {
    ... on Partner {
      id
      reviewRegistration {
        registration {
          revision
          companyName
          companyWebsite
          companyAddress {
            lines
            city
            stateOrRegion
            districtOrCounty
            postalCode
            countryCode
          }
          incorporationCountry
          registrationNumber
          submissionNotes
          convertedFromRegionalManagerAccount {
            id
            region
          }
          emailDomain
        }
        verification {
          status
          rejectionReasons
          mutableRejectionReasons {
            id
            message
            helpContentIds
            version
            translations {
              text
              locale
            }
          }
          rejectionDetails
          lastSubmittedDate
          lastReviewedDate
        }
      }
    }
    ... on MutationError {
      errors {
        argumentName
      }
    }
  }
}
    `;
export type DeletePartnerRegistrationMutationFn = Apollo.MutationFunction<DeletePartnerRegistrationMutation, DeletePartnerRegistrationMutationVariables>;

/**
 * __useDeletePartnerRegistrationMutation__
 *
 * To run a mutation, you first call `useDeletePartnerRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerRegistrationMutation, { data, loading, error }] = useDeletePartnerRegistrationMutation({
 *   variables: {
 *      deleteRegistrationInput: // value for 'deleteRegistrationInput'
 *   },
 * });
 */
export function useDeletePartnerRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerRegistrationMutation, DeletePartnerRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerRegistrationMutation, DeletePartnerRegistrationMutationVariables>(DeletePartnerRegistrationDocument, options);
      }
export type DeletePartnerRegistrationMutationHookResult = ReturnType<typeof useDeletePartnerRegistrationMutation>;
export type DeletePartnerRegistrationMutationResult = Apollo.MutationResult<DeletePartnerRegistrationMutation>;
export type DeletePartnerRegistrationMutationOptions = Apollo.BaseMutationOptions<DeletePartnerRegistrationMutation, DeletePartnerRegistrationMutationVariables>;
export const ResubmitPartnerRegistrationDocument = gql`
    mutation ResubmitPartnerRegistration($submitRegistrationInput: SubmitPartnerRegistrationInput!) {
  submitPartnerRegistration(submitRegistrationInput: $submitRegistrationInput) {
    ... on Partner {
      id
      reviewRegistration {
        registration {
          revision
          companyName
          companyWebsite
          companyAddress {
            lines
            city
            stateOrRegion
            districtOrCounty
            postalCode
            countryCode
          }
          incorporationCountry
          registrationNumber
          submissionNotes
          convertedFromRegionalManagerAccount {
            id
            region
          }
        }
        verification {
          status
          rejectionReasons
          mutableRejectionReasons {
            id
            message
            helpContentIds
            version
            translations {
              text
              locale
            }
          }
          rejectionDetails
          lastSubmittedDate
          lastReviewedDate
        }
      }
    }
    ... on MutationError {
      errors {
        argumentName
      }
    }
    ... on ClientError {
      code
      message
    }
  }
}
    `;
export type ResubmitPartnerRegistrationMutationFn = Apollo.MutationFunction<ResubmitPartnerRegistrationMutation, ResubmitPartnerRegistrationMutationVariables>;

/**
 * __useResubmitPartnerRegistrationMutation__
 *
 * To run a mutation, you first call `useResubmitPartnerRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubmitPartnerRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubmitPartnerRegistrationMutation, { data, loading, error }] = useResubmitPartnerRegistrationMutation({
 *   variables: {
 *      submitRegistrationInput: // value for 'submitRegistrationInput'
 *   },
 * });
 */
export function useResubmitPartnerRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<ResubmitPartnerRegistrationMutation, ResubmitPartnerRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResubmitPartnerRegistrationMutation, ResubmitPartnerRegistrationMutationVariables>(ResubmitPartnerRegistrationDocument, options);
      }
export type ResubmitPartnerRegistrationMutationHookResult = ReturnType<typeof useResubmitPartnerRegistrationMutation>;
export type ResubmitPartnerRegistrationMutationResult = Apollo.MutationResult<ResubmitPartnerRegistrationMutation>;
export type ResubmitPartnerRegistrationMutationOptions = Apollo.BaseMutationOptions<ResubmitPartnerRegistrationMutation, ResubmitPartnerRegistrationMutationVariables>;
export const RemoveSelfFromPartnerDocument = gql`
    mutation RemoveSelfFromPartner {
  removeSelfFromPartner {
    id
  }
}
    `;
export type RemoveSelfFromPartnerMutationFn = Apollo.MutationFunction<RemoveSelfFromPartnerMutation, RemoveSelfFromPartnerMutationVariables>;

/**
 * __useRemoveSelfFromPartnerMutation__
 *
 * To run a mutation, you first call `useRemoveSelfFromPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSelfFromPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSelfFromPartnerMutation, { data, loading, error }] = useRemoveSelfFromPartnerMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveSelfFromPartnerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSelfFromPartnerMutation, RemoveSelfFromPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSelfFromPartnerMutation, RemoveSelfFromPartnerMutationVariables>(RemoveSelfFromPartnerDocument, options);
      }
export type RemoveSelfFromPartnerMutationHookResult = ReturnType<typeof useRemoveSelfFromPartnerMutation>;
export type RemoveSelfFromPartnerMutationResult = Apollo.MutationResult<RemoveSelfFromPartnerMutation>;
export type RemoveSelfFromPartnerMutationOptions = Apollo.BaseMutationOptions<RemoveSelfFromPartnerMutation, RemoveSelfFromPartnerMutationVariables>;
export const GetFeaturedUpdatesDocument = gql`
    query GetFeaturedUpdates($pagination: PaginationInput, $filters: FilterInput) {
  cmsEntries(pagination: $pagination, filters: $filters) {
    edges {
      node {
        ...resource
        ...event
      }
    }
    totalCMSEntryCount
  }
}
    ${ResourceFragmentDoc}
${EventFragmentDoc}`;

/**
 * __useGetFeaturedUpdatesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedUpdatesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFeaturedUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedUpdatesQuery, GetFeaturedUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedUpdatesQuery, GetFeaturedUpdatesQueryVariables>(GetFeaturedUpdatesDocument, options);
      }
export function useGetFeaturedUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedUpdatesQuery, GetFeaturedUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedUpdatesQuery, GetFeaturedUpdatesQueryVariables>(GetFeaturedUpdatesDocument, options);
        }
export type GetFeaturedUpdatesQueryHookResult = ReturnType<typeof useGetFeaturedUpdatesQuery>;
export type GetFeaturedUpdatesLazyQueryHookResult = ReturnType<typeof useGetFeaturedUpdatesLazyQuery>;
export type GetFeaturedUpdatesQueryResult = Apollo.QueryResult<GetFeaturedUpdatesQuery, GetFeaturedUpdatesQueryVariables>;
export const GetPartnerProfileDocument = gql`
    query GetPartnerProfile {
  partner {
    id
    accreditationStatus {
      value
      updatedDate
      updatedBy
    }
    badges {
      admin {
        accreditation {
          type
          statusInfo {
            status
            lastUpdatedBy
            lastUpdatedDate
          }
        }
      }
    }
    awards {
      ...partnerAwardData
    }
    applications {
      applicationId
      id
      linkedDate
    }
    totalUsersCount
    certifiedUsersCount
    advertisers {
      edges {
        node {
          id
        }
      }
    }
    liveRegistration {
      registration {
        companyName
        incorporationCountry
      }
    }
    unmoderatedRegistrationData {
      adOffering
      adProductsInterest
      advertiserBusinessTypes
      servicesCategory
    }
    localizedDirectoryListings {
      ar_ae {
        ...localizedDirectoryListing
      }
      de_de {
        ...localizedDirectoryListing
      }
      en_us {
        ...localizedDirectoryListing
      }
      es_es {
        ...localizedDirectoryListing
      }
      fr_fr {
        ...localizedDirectoryListing
      }
      it_it {
        ...localizedDirectoryListing
      }
      ja_jp {
        ...localizedDirectoryListing
      }
      ko_kr {
        ...localizedDirectoryListing
      }
      nl_nl {
        ...localizedDirectoryListing
      }
      pl_pl {
        ...localizedDirectoryListing
      }
      pt_br {
        ...localizedDirectoryListing
      }
      sv_se {
        ...localizedDirectoryListing
      }
      tr_tr {
        ...localizedDirectoryListing
      }
      zh_cn {
        ...localizedDirectoryListing
      }
    }
  }
}
    ${PartnerAwardDataFragmentDoc}
${LocalizedDirectoryListingFragmentDoc}`;

/**
 * __useGetPartnerProfileQuery__
 *
 * To run a query within a React component, call `useGetPartnerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerProfileQuery, GetPartnerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerProfileQuery, GetPartnerProfileQueryVariables>(GetPartnerProfileDocument, options);
      }
export function useGetPartnerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerProfileQuery, GetPartnerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerProfileQuery, GetPartnerProfileQueryVariables>(GetPartnerProfileDocument, options);
        }
export type GetPartnerProfileQueryHookResult = ReturnType<typeof useGetPartnerProfileQuery>;
export type GetPartnerProfileLazyQueryHookResult = ReturnType<typeof useGetPartnerProfileLazyQuery>;
export type GetPartnerProfileQueryResult = Apollo.QueryResult<GetPartnerProfileQuery, GetPartnerProfileQueryVariables>;
export const GetPartnerProfileV2Document = gql`
    query GetPartnerProfileV2 {
  partner {
    id
    accreditationStatus {
      value
      updatedDate
      updatedBy
    }
    isInternal
    badges {
      admin {
        accreditation {
          type
          statusInfo {
            status
            lastUpdatedBy
            lastUpdatedDate
          }
        }
      }
    }
    awards {
      ...profilePartnerAwardData
    }
    applications {
      applicationId
      id
      linkedDate
    }
    totalUsersCount
    certifiedUsersCount
    advertisers {
      edges {
        node {
          id
        }
      }
    }
    liveRegistration {
      registration {
        companyName
        incorporationCountry
      }
    }
    unmoderatedRegistrationData {
      adOffering
      adProductsInterest
      advertiserBusinessTypes
      servicesCategory
    }
    liveDirectoryListingData {
      ...profileUniversalListingData
    }
    localizedDirectoryListings {
      ar_ae {
        ...profileLocalizedDirectoryListing
      }
      de_de {
        ...profileLocalizedDirectoryListing
      }
      en_us {
        ...profileLocalizedDirectoryListing
      }
      es_es {
        ...profileLocalizedDirectoryListing
      }
      fr_fr {
        ...profileLocalizedDirectoryListing
      }
      it_it {
        ...profileLocalizedDirectoryListing
      }
      ja_jp {
        ...profileLocalizedDirectoryListing
      }
      ko_kr {
        ...profileLocalizedDirectoryListing
      }
      nl_nl {
        ...profileLocalizedDirectoryListing
      }
      pl_pl {
        ...profileLocalizedDirectoryListing
      }
      pt_br {
        ...profileLocalizedDirectoryListing
      }
      sv_se {
        ...profileLocalizedDirectoryListing
      }
      tr_tr {
        ...profileLocalizedDirectoryListing
      }
      zh_cn {
        ...profileLocalizedDirectoryListing
      }
    }
    partnerLogo {
      ...partnerLogoData
    }
  }
}
    ${ProfilePartnerAwardDataFragmentDoc}
${ProfileUniversalListingDataFragmentDoc}
${ProfileLocalizedDirectoryListingFragmentDoc}
${PartnerLogoDataFragmentDoc}`;

/**
 * __useGetPartnerProfileV2Query__
 *
 * To run a query within a React component, call `useGetPartnerProfileV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerProfileV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerProfileV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerProfileV2Query(baseOptions?: Apollo.QueryHookOptions<GetPartnerProfileV2Query, GetPartnerProfileV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerProfileV2Query, GetPartnerProfileV2QueryVariables>(GetPartnerProfileV2Document, options);
      }
export function useGetPartnerProfileV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerProfileV2Query, GetPartnerProfileV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerProfileV2Query, GetPartnerProfileV2QueryVariables>(GetPartnerProfileV2Document, options);
        }
export type GetPartnerProfileV2QueryHookResult = ReturnType<typeof useGetPartnerProfileV2Query>;
export type GetPartnerProfileV2LazyQueryHookResult = ReturnType<typeof useGetPartnerProfileV2LazyQuery>;
export type GetPartnerProfileV2QueryResult = Apollo.QueryResult<GetPartnerProfileV2Query, GetPartnerProfileV2QueryVariables>;
export const SubmitPartnerRegistrationDocument = gql`
    mutation SubmitPartnerRegistration($submitRegistrationInput: SubmitPartnerRegistrationInput!) {
  submitPartnerRegistration(submitRegistrationInput: $submitRegistrationInput) {
    ... on Partner {
      id
    }
    ... on MutationError {
      errors {
        argumentName
      }
    }
    ... on ClientError {
      code
    }
  }
}
    `;
export type SubmitPartnerRegistrationMutationFn = Apollo.MutationFunction<SubmitPartnerRegistrationMutation, SubmitPartnerRegistrationMutationVariables>;

/**
 * __useSubmitPartnerRegistrationMutation__
 *
 * To run a mutation, you first call `useSubmitPartnerRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPartnerRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPartnerRegistrationMutation, { data, loading, error }] = useSubmitPartnerRegistrationMutation({
 *   variables: {
 *      submitRegistrationInput: // value for 'submitRegistrationInput'
 *   },
 * });
 */
export function useSubmitPartnerRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPartnerRegistrationMutation, SubmitPartnerRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPartnerRegistrationMutation, SubmitPartnerRegistrationMutationVariables>(SubmitPartnerRegistrationDocument, options);
      }
export type SubmitPartnerRegistrationMutationHookResult = ReturnType<typeof useSubmitPartnerRegistrationMutation>;
export type SubmitPartnerRegistrationMutationResult = Apollo.MutationResult<SubmitPartnerRegistrationMutation>;
export type SubmitPartnerRegistrationMutationOptions = Apollo.BaseMutationOptions<SubmitPartnerRegistrationMutation, SubmitPartnerRegistrationMutationVariables>;
export const GetPartnerManagerAccountsDocument = gql`
    query GetPartnerManagerAccounts {
  promotableManagerAccounts {
    id
    region
  }
}
    `;

/**
 * __useGetPartnerManagerAccountsQuery__
 *
 * To run a query within a React component, call `useGetPartnerManagerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerManagerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerManagerAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerManagerAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerManagerAccountsQuery, GetPartnerManagerAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerManagerAccountsQuery, GetPartnerManagerAccountsQueryVariables>(GetPartnerManagerAccountsDocument, options);
      }
export function useGetPartnerManagerAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerManagerAccountsQuery, GetPartnerManagerAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerManagerAccountsQuery, GetPartnerManagerAccountsQueryVariables>(GetPartnerManagerAccountsDocument, options);
        }
export type GetPartnerManagerAccountsQueryHookResult = ReturnType<typeof useGetPartnerManagerAccountsQuery>;
export type GetPartnerManagerAccountsLazyQueryHookResult = ReturnType<typeof useGetPartnerManagerAccountsLazyQuery>;
export type GetPartnerManagerAccountsQueryResult = Apollo.QueryResult<GetPartnerManagerAccountsQuery, GetPartnerManagerAccountsQueryVariables>;
export const PartnerRegistrationEligibilityDocument = gql`
    query PartnerRegistrationEligibility {
  partnerRegistrationEligibility {
    ... on PartnerRegistrationEligibility {
      partnerRegistrationEligibilityResponse
    }
  }
}
    `;

/**
 * __usePartnerRegistrationEligibilityQuery__
 *
 * To run a query within a React component, call `usePartnerRegistrationEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRegistrationEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRegistrationEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerRegistrationEligibilityQuery(baseOptions?: Apollo.QueryHookOptions<PartnerRegistrationEligibilityQuery, PartnerRegistrationEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerRegistrationEligibilityQuery, PartnerRegistrationEligibilityQueryVariables>(PartnerRegistrationEligibilityDocument, options);
      }
export function usePartnerRegistrationEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerRegistrationEligibilityQuery, PartnerRegistrationEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerRegistrationEligibilityQuery, PartnerRegistrationEligibilityQueryVariables>(PartnerRegistrationEligibilityDocument, options);
        }
export type PartnerRegistrationEligibilityQueryHookResult = ReturnType<typeof usePartnerRegistrationEligibilityQuery>;
export type PartnerRegistrationEligibilityLazyQueryHookResult = ReturnType<typeof usePartnerRegistrationEligibilityLazyQuery>;
export type PartnerRegistrationEligibilityQueryResult = Apollo.QueryResult<PartnerRegistrationEligibilityQuery, PartnerRegistrationEligibilityQueryVariables>;
export const GetResourceDocument = gql`
    query GetResource($id: ID!) {
  cmsEntry(id: $id) {
    id
    audit {
      createdDate
      updatedDate
      updatedBy
    }
    deleted
    featured
    productCategories
    tags
    targetSegments
    details {
      ...detailsLocaleFields
    }
    ... on CMSResourceEntry {
      resourceCategories
    }
  }
}
    ${DetailsLocaleFieldsFragmentDoc}`;

/**
 * __useGetResourceQuery__
 *
 * To run a query within a React component, call `useGetResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResourceQuery(baseOptions: Apollo.QueryHookOptions<GetResourceQuery, GetResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceQuery, GetResourceQueryVariables>(GetResourceDocument, options);
      }
export function useGetResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceQuery, GetResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceQuery, GetResourceQueryVariables>(GetResourceDocument, options);
        }
export type GetResourceQueryHookResult = ReturnType<typeof useGetResourceQuery>;
export type GetResourceLazyQueryHookResult = ReturnType<typeof useGetResourceLazyQuery>;
export type GetResourceQueryResult = Apollo.QueryResult<GetResourceQuery, GetResourceQueryVariables>;
export const OnlineAgreementDocument = gql`
    query OnlineAgreement($locale: TermsLocale!) {
  onlineAgreement(locale: $locale) {
    ...onlineAgreement
  }
}
    ${OnlineAgreementFragmentDoc}`;

/**
 * __useOnlineAgreementQuery__
 *
 * To run a query within a React component, call `useOnlineAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlineAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlineAgreementQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useOnlineAgreementQuery(baseOptions: Apollo.QueryHookOptions<OnlineAgreementQuery, OnlineAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnlineAgreementQuery, OnlineAgreementQueryVariables>(OnlineAgreementDocument, options);
      }
export function useOnlineAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnlineAgreementQuery, OnlineAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnlineAgreementQuery, OnlineAgreementQueryVariables>(OnlineAgreementDocument, options);
        }
export type OnlineAgreementQueryHookResult = ReturnType<typeof useOnlineAgreementQuery>;
export type OnlineAgreementLazyQueryHookResult = ReturnType<typeof useOnlineAgreementLazyQuery>;
export type OnlineAgreementQueryResult = Apollo.QueryResult<OnlineAgreementQuery, OnlineAgreementQueryVariables>;
export const AcceptOnlineAgreementDocument = gql`
    mutation AcceptOnlineAgreement {
  acceptOnlineAgreement {
    ... on OnlineAgreement {
      ...onlineAgreement
    }
    ... on MutationError {
      errors {
        ...mutationArgumentErrorData
      }
    }
  }
}
    ${OnlineAgreementFragmentDoc}
${MutationArgumentErrorDataFragmentDoc}`;
export type AcceptOnlineAgreementMutationFn = Apollo.MutationFunction<AcceptOnlineAgreementMutation, AcceptOnlineAgreementMutationVariables>;

/**
 * __useAcceptOnlineAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptOnlineAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOnlineAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOnlineAgreementMutation, { data, loading, error }] = useAcceptOnlineAgreementMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptOnlineAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOnlineAgreementMutation, AcceptOnlineAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOnlineAgreementMutation, AcceptOnlineAgreementMutationVariables>(AcceptOnlineAgreementDocument, options);
      }
export type AcceptOnlineAgreementMutationHookResult = ReturnType<typeof useAcceptOnlineAgreementMutation>;
export type AcceptOnlineAgreementMutationResult = Apollo.MutationResult<AcceptOnlineAgreementMutation>;
export type AcceptOnlineAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptOnlineAgreementMutation, AcceptOnlineAgreementMutationVariables>;